export default {
  'activity.addPromotionSettings': 'Thêm cài đặt ưu đãi',
  'activity.editPromotionSettings': 'Chỉnh sửa cài đặt ưu đãi',
  'activity.appIcon': 'Biểu tượng App',
  'activity.back': 'Quay lại',
  'activity.basicSettings': 'Cài đặt cơ bản',
  'activity.batchModify': 'Sửa đổi hàng loạt',
  'activity.batchModifyMaxAmount': 'Sửa đổi hàng loạt số tiền hoàn trả tối đa hàng ngày',
  'activity.batchModifyRebate': 'Sửa đổi hàng loạt tỷ lệ hoàn trả',
  'activity.batchModifyTicket': 'Sửa đổi hàng loạt vé tham gia',
  'activity.batchModifyTicketCount': 'Sửa đổi hàng loạt số lượng vé tham gia',
  'activity.cannotDelete': 'Không thể xóa dữ liệu',
  'activity.cannotDeleteWithBoundTickets': 'Chỉ xóa khi không có vé liên kết',
  'activity.clickToUpload': 'Nhấp để tải lên',
  'activity.copyPromotion': 'Sao chép hoạt động',
  'activity.currency': 'Loại tiền',
  'activity.dataLoadFailed': 'Tải dữ liệu thất bại',
  'activity.deselectAll': 'Bỏ chọn tất cả',
  'activity.displaySort': 'Thứ tự hiển thị',
  'activity.editCopy': 'Chỉnh sửa nội dung',
  'activity.enterBatchMaxAmount': 'Vui lòng nhập số tiền hoàn trả tối đa hàng loạt',
  'activity.enterBatchRebate': 'Vui lòng nhập tỷ lệ hoàn trả hàng loạt',
  'activity.enterBetAmount': 'Vui lòng nhập số tiền cược (bao gồm)',
  'activity.enterDisplaySort': 'Vui lòng nhập thứ tự hiển thị',
  'activity.rewardExpireDays': 'Số ngày hết hạn phần thưởng',
  'activity.enterRewardExpireDays': 'Vui lòng nhập số ngày hết hạn phần thưởng (-1 có nghĩa là không hết hạn)',
  'activity.rewardExpireDaysTooltip': 'Nhập số ngày, -1 có nghĩa là không hết hạn',
  'activity.rewardExpireDaysCannotBeZero': 'Số ngày hết hạn phần thưởng không thể là 0',
  'activity.showFlowMultiple': 'Công tắc hiển thị bội số lưu thông',
  'activity.showFlowMultipleOn': 'Bật',
  'activity.showFlowMultipleOff': 'Tắt',
  'activity.days': 'Ngày',
  'activity.activityIntroduction': 'Giới thiệu hoạt động',
  'activity.enterActivityIntroduction': 'Vui lòng nhập giới thiệu hoạt động',
  'activity.activityIcon': 'Biểu tượng hoạt động',
  'activity.selectActivityIcon': 'Vui lòng tải lên biểu tượng hoạt động',
  'activity.detailUrl': 'URL chi tiết',
  'activity.enterDetailUrl': 'Vui lòng nhập URL chi tiết',
  'activity.enterMaxRebateAmount': 'Vui lòng nhập số tiền hoàn trả tối đa',
  'activity.enterPromotionContent': 'Vui lòng nhập nội dung ưu đãi',
  'activity.enterPromotionName': 'Vui lòng nhập tên ưu đãi',
  'activity.enterRebatePercent': 'Vui lòng nhập tỷ lệ hoàn trả',
  'activity.enterTurnoverMultiple': 'Vui lòng nhập số lần doanh thu',
  'activity.errorParsingMultiTypeName': 'Lỗi khi phân tích tên đa loại',
  'activity.formValidationFailed': 'Xác thực biểu mẫu thất bại',
  'activity.gamePlatform': 'Nền tảng trò chơi',
  'activity.h5Icon': 'Biểu tượng H5',
  'activity.language': 'Ngôn ngữ',
  'activity.loadingTemplate': 'Đang tải mẫu ưu đãi thời gian thực...',
  'activity.manualSend.add': 'Thêm mới',
  'activity.manualSend.back': 'Quay lại',
  'activity.manualSend.batchImport': 'Nhập hàng loạt',
  'activity.manualSend.bonusAmount': 'Số tiền ưu đãi',
  'activity.manualSend.bonusPoints': 'Điểm ưu đãi',
  'activity.manualSend.cash': 'Tiền mặt',
  'activity.manualSend.point': 'Điểm',
  'activity.manualSend.ticket': 'Vé tham gia',
  'activity.manualSend.confirmIssue': 'Xác nhận phát',
  'activity.manualSend.search': 'Tìm kiếm',
  'activity.manualSend.reset': 'Đặt lại',
  'activity.manualSend.execute': 'Thực hiện',
  'activity.manualSend.memberAccount': 'Tài khoản thành viên',
  'activity.manualSend.enterMemberAccount': 'Vui lòng nhập tài khoản thành viên',
  'activity.confirmEnable': 'Bạn có chắc chắn muốn bật hoạt động này?',
  'activity.confirmDisable': 'Bạn có chắc chắn muốn tắt hoạt động này?',
  'activity.manualSend.currency': 'Loại tiền',
  'activity.manualSend.dataLoadFailed': 'Tải dữ liệu thất bại',
  'activity.manualSend.downloadTemplate': 'Tải mẫu nhập',
  'activity.manualSend.enterBonusAmount': 'Vui lòng nhập số tiền ưu đãi',
  'activity.manualSend.enterBonusPoints': 'Vui lòng nhập điểm ưu đãi',
  'activity.manualSend.enterMemberName': 'Vui lòng nhập tên thành viên',
  'activity.manualSend.enterTurnoverMultiple': 'Vui lòng nhập số lần doanh thu',
  'activity.manualSend.failCount': 'Số lượng thất bại',
  'activity.manualSend.importCount': 'Số lượng nhập',
  'activity.manualSend.importDetails': 'Chi tiết nhập',
  'activity.manualSend.importStatus': 'Trạng thái nhập',
  'activity.manualSend.importTime': 'Thời gian nhập',
  'activity.manualSend.memberName': 'Tên thành viên',
  'activity.manualSend.operationSuccess': 'Thao tác thành công',
  'activity.manualSend.operationTime': 'Thời gian thao tác',
  'activity.manualSend.operator': 'Người thao tác',
  'activity.manualSend.promotionName': 'Tên ưu đãi',
  'activity.manualSend.rewardType': 'Loại phần thưởng',
  'activity.manualSend.selectCurrency': 'Vui lòng chọn loại tiền',
  'activity.manualSend.selectImportStatus': 'Vui lòng chọn trạng thái nhập',
  'activity.manualSend.selectPromotionName': 'Vui lòng chọn tên ưu đãi',
  'activity.manualSend.selectRewardType': 'Vui lòng chọn loại phần thưởng',
  'activity.manualSend.successAmount': 'Số tiền phát thành công',
  'activity.manualSend.successCount': 'Số lượng thành công',
  'activity.manualSend.turnoverMultiple': 'Số lần doanh thu',
  'activity.manualSend.uploadFile': 'Vui lòng tải lên file CSV hoặc Excel',
  'activity.manualSend.uploadSuccess': 'Thêm mới thành công',
  'activity.manualSend.usageInstructions': 'Hướng dẫn sử dụng',
  'activity.manualSend.instruction1': 'Vui lòng tải xuống mẫu nhập trước, nhập hàng loạt số lượng thành viên dưới 100k',
  'activity.manualSend.instruction2': 'Vượt quá vui lòng tải lên theo lô, tối đa mỗi 5 phút một lần',
  'activity.manualSend.instruction3': 'Kích thước tài liệu tải lên không quá 20M',
  'activity.manualSend.view': 'Xem',
  'activity.manualSend.selectTicket': 'Vui lòng chọn vé tham gia',
  'activity.manualSend.ticketName': 'Tên vé tham gia',
  'activity.manualSend.ticketNameLabel': 'Chọn vé tham gia',
  'activity.manualSend.batchImportSuccess': 'Nhập hàng loạt thành công',
  'activity.manualSend.templateFileName': 'Mẫu nhập vé tham gia.csv',
  'activity.manualSend.csvColumnMemberName': 'Tên thành viên',
  'activity.manualSend.csvColumnQuantity': 'Số lượng',
  'activity.manualSend.csvExampleRow': 'Vui lòng xóa dòng ví dụ này-{{memberName}},{{quantity}}',
  'activity.manualSend.fileFormat': 'Định dạng file: CSV',
  'activity.manualSend.fileSize': 'Kích thước file: Không quá 20MB',
  'activity.manualSend.columnFields': 'Cột dữ liệu: Tên thành viên,Số lượng',
  'activity.manualSend.totalIssuedQuantity': 'Tổng số lượng phát hành',
  'activity.modifySuccess': 'Sửa đổi thành công',
  'activity.operationSuccess': 'Thao tác thành công',
  'activity.pcIcon': 'Biểu tượng PC',
  'activity.promotionCategory': 'Danh mục ưu đãi',
  'activity.promotionContent': 'Nội dung ưu đãi',
  'activity.promotionEffectiveTime': 'Thời gian hiệu lực ưu đãi',
  'activity.promotionName': 'Tên ưu đãi',
  'activity.promotionSettings': 'Cài đặt ưu đãi',
  'activity.promotionShowTime': 'Thời gian hiển thị ưu đãi',
  'activity.promotionTemplate': 'Mẫu ưu đãi',
  'activity.rebate.awardMax': 'Giới hạn phần thưởng',
  'activity.rebate.betAmount': 'Số tiền cược (bao gồm)',
  'activity.rebate.betAmountMax': 'Số tiền cược tối đa (không bao gồm)',
  'activity.rebate.betAmountMaxError': 'Số tiền cược tối đa (không bao gồm) phải lớn hơn số tiền cược (bao gồm)',
  'activity.rebate.cashAmount': 'Số tiền mặt',
  'activity.rebate.cashAwardMethod': 'Phương thức thưởng tiền mặt',
  'activity.rebate.dailyRecharge': 'Nạp tiền hàng ngày',
  'activity.rebate.desireMultiple': 'Số lần doanh thu',
  'activity.rebate.enterAwardMax': 'Vui lòng nhập giới hạn phần thưởng',
  'activity.rebate.enterBetAmount': 'Vui lòng nhập số tiền cược (bao gồm)',
  'activity.rebate.enterBetAmountMax': 'Vui lòng nhập số tiền cược tối đa (không bao gồm)',
  'activity.rebate.enterCashAmount': 'Vui lòng nhập số tiền mặt',
  'activity.rebate.enterDailyRecharge': 'Vui lòng nhập số tiền nạp hàng ngày',
  'activity.rebate.enterDesireMultiple': 'Vui lòng nhập số lần doanh thu',
  'activity.rebate.enterPointAmount': 'Vui lòng nhập số điểm',
  'activity.rebate.fixedAmount': 'Số tiền cố định',
  'activity.rebate.gamePlatform': 'Nền tảng trò chơi',
  'activity.rebate.percentage': 'Tỷ lệ phần trăm',
  'activity.rebate.percentMaxTwoDecimals': 'Tỷ lệ không được âm và tối đa 2 chữ số thập phân',
  'activity.rebate.truncateNotice': 'Tỷ lệ hoàn trả hỗ trợ tối đa 2 chữ số thập phân. Số tiền hoàn trả tiền mặt giữ 2 chữ số thập phân, phần vượt quá sẽ bị cắt bỏ (không làm tròn); phần thưởng dưới 0.01 sẽ bị loại bỏ và không phát. Hoàn trả điểm không bị ảnh hưởng.',
  'activity.rebate.pointAmount': 'Số điểm',
  'activity.rebate.pointAwardMethod': 'Phương thức thưởng điểm',
  'activity.rebate.rebateSettings': 'Cài đặt hoàn trả',
  'activity.rebate.selectCashAwardMethod': 'Vui lòng chọn phương thức thưởng tiền mặt',
  'activity.rebate.selectPointAwardMethod': 'Vui lòng chọn phương thức thưởng điểm',
  'activity.save': 'Lưu',
  'activity.saving': 'Đang lưu...',
  'activity.selectAll': 'Chọn tất cả',
  'activity.selectAppIcon': 'Vui lòng chọn biểu tượng App',
  'activity.selectCurrency': 'Vui lòng chọn loại tiền',
  'activity.selectCurrencyFirst': 'Vui lòng chọn loại tiền trước',
  'activity.selectH5Icon': 'Vui lòng chọn biểu tượng H5',
  'activity.selectLanguage': 'Vui lòng chọn ngôn ngữ',
  'activity.selectPcIcon': 'Vui lòng chọn biểu tượng PC',
  'activity.selectPromotionCategory': 'Vui lòng chọn danh mục ưu đãi',
  'activity.selectPromotionEffectiveTime': 'Vui lòng chọn thời gian hiệu lực ưu đãi',
  'activity.selectPromotionShowTime': 'Vui lòng chọn thời gian hiển thị ưu đãi',
  'activity.selectPromotionTemplate': 'Vui lòng chọn mẫu ưu đãi',
  'activity.selectStatus': 'Vui lòng chọn trạng thái',
  'activity.selectTicket': 'Vui lòng chọn vé tham gia',
  'activity.enterTicketCount': 'Vui lòng nhập số lượng',
  'activity.setMultiLanguage': 'Thiết lập đa ngôn ngữ',
  'activity.turnoverMultiple': 'Số lần doanh thu',
  'activity.type.action': 'Thao tác',
  'activity.type.add': 'Thêm mới',
  'activity.type.addSuccess': 'Thêm mới thành công',
  'activity.type.categoryName': 'Tên danh mục ưu đãi',
  'activity.type.confirmDelete': 'Bạn có chắc chắn muốn xóa?',
  'activity.type.dataLoadFailed': 'Tải dữ liệu thất bại',
  'activity.type.delete': 'Xóa',
  'activity.type.deleteSuccess': 'Xóa thành công',
  'activity.type.edit': 'Sửa đổi',
  'activity.type.enterCategoryName': 'Vui lòng nhập tên danh mục ưu đãi',
  'activity.type.enterRemarks': 'Vui lòng nhập ghi chú',
  'activity.type.enterSort': 'Vui lòng nhập thứ tự sắp xếp',
  'activity.type.formValidationFailed': 'Xác thực biểu mẫu thất bại',
  'activity.type.language': 'Ngôn ngữ',
  'activity.type.modifySuccess': 'Sửa đổi thành công',
  'activity.type.operationTime': 'Thời gian thao tác',
  'activity.type.operator': 'Người thao tác',
  'activity.type.remarks': 'Ghi chú',
  'activity.type.selectLanguage': 'Vui lòng chọn ngôn ngữ',
  'activity.type.setMultiLanguage': 'Thiết lập đa ngôn ngữ',
  'activity.type.sort': 'Sắp xếp',
  'activity.vipLevel': 'VIP{{level}}',
  'activity.welfare.amount': 'Số tiền ưu đãi',
  'activity.welfare.cash': 'Tiền mặt',
  'activity.welfare.claimed': 'Đã nhận',
  'activity.welfare.claimMethod': 'Phương thức nhận',
  'activity.welfare.createTime': 'Thời gian tạo',
  'activity.welfare.claimTime': 'Thời gian nhận',
  'activity.welfare.currency': 'Loại tiền',
  'activity.welfare.dataLoadFailed': 'Tải dữ liệu thất bại',
  'activity.welfare.enterMemberAccount': 'Vui lòng nhập tài khoản thành viên',
  'activity.welfare.expireTime': 'Thời gian hết hạn phần thưởng',
  'activity.welfare.pointExpireTime': 'Thời gian hết hạn điểm',
  'activity.welfare.memberAccount': 'Tài khoản thành viên',
  'activity.welfare.point': 'Điểm',
  'activity.welfare.points': 'Điểm ưu đãi',
  'activity.welfare.promotionName': 'Tên ưu đãi',
  'activity.welfare.rewardName': 'Tên phần thưởng',
  'activity.welfare.selectCurrency': 'Vui lòng chọn loại tiền',
  'activity.welfare.selectPromotionName': 'Vui lòng chọn tên ưu đãi',
  'activity.welfare.selectStatus': 'Vui lòng chọn trạng thái',
  'activity.welfare.selectSubActivityName': 'Vui lòng chọn tên hoạt động phụ',
  'activity.welfare.vipLevel': 'Cấp VIP',
  'activity.welfare.selectVipLevel': 'Vui lòng chọn cấp VIP',
  'activity.welfare.status': 'Trạng thái ưu đãi',
  'activity.welfare.subActivityName': 'Tên hoạt động phụ',
  'activity.welfare.systemIssue': 'Hệ thống phát hành',
  'activity.welfare.status.available': 'Có thể sử dụng',
  'activity.welfare.status.received': 'Đã nhận',
  'activity.welfare.status.expired': 'Đã hết hạn',
  'activity.welfare.turnoverMultiple': 'Số lần doanh thu',
  'activity.welfare.export': 'Xuất',
  'activity.welfare.exportLoading': 'Đang xuất dữ liệu...',
  'activity.welfare.exportSuccess': 'Xuất thành công',
  'activity.welfare.exportFail': 'Xuất thất bại',
  'common.currency': 'Loại tiền',
  'common.status': 'Trạng thái',
  'activity.selectPromotionName': 'Vui lòng chọn tên ưu đãi',
  'activity.uploadValidFile': 'Vui lòng tải lên và phân tích tệp CSV hoặc Excel hợp lệ',
  'export.serialNumber': 'Số thứ tự',
  'export.fileName': 'Tên tệp',
  'export.createDate': 'Ngày tạo',
  'export.status': 'Trạng thái',
  'export.operation': 'Thao tác',
  'export.status.success': 'Thành công',
  'export.status.processing': 'Đang xử lý',
  'export.status.failed': 'Tải xuống thất bại',
  'export.button.download': 'Tải xuống',
  'export.button.delete': 'Xóa',
  'export.button.refresh': 'Làm mới',
  'export.button.clearAll': 'Xóa tất cả',
  'export.downloadList': 'Danh sách tải xuống',
  'export.noData': 'Không có dữ liệu',
  'activity.register.cashAmount': 'Số tiền thưởng bằng tiền mặt',
  'activity.register.cashAmountMustBeNonNegative': 'Số tiền thưởng bằng tiền mặt không thể âm',
  'activity.register.cashAmountTooltip': 'Số tiền thưởng bằng tiền mặt nhận được khi đăng ký, tối đa 2 chữ số thập phân',
  'activity.register.cashRequiresMultiple': 'Phải thiết lập bội số doanh thu khi thưởng tiền mặt lớn hơn 0',
  'activity.register.desireMultiple': 'Bội số doanh thu',
  'activity.register.desireMultipleTooltip': 'Yêu cầu bội số doanh thu cho thưởng tiền mặt, phải là số nguyên',
  'activity.register.enterCashAmount': 'Vui lòng nhập số tiền thưởng bằng tiền mặt',
  'activity.register.enterDesireMultiple': 'Vui lòng nhập bội số doanh thu',
  'activity.register.enterPointAmount': 'Vui lòng nhập số điểm thưởng',
  'activity.register.note': 'Lưu ý',
  'activity.register.noteCashDecimal': 'Số tiền thưởng bằng tiền mặt có thể có tối đa 2 chữ số thập phân',
  'activity.register.noteCashMultiple': 'Phải thiết lập bội số doanh thu khi thưởng tiền mặt lớn hơn 0',
  'activity.register.noteMultipleInteger': 'Bội số doanh thu phải là số nguyên',
  'activity.register.noteOnePerUser': 'Mỗi người dùng chỉ có thể nhận một lần cho mỗi hoạt động',
  'activity.register.notePointInteger': 'Số điểm thưởng phải là số nguyên',
  'activity.register.pointAmount': 'Số điểm thưởng',
  'activity.register.pointAmountMustBeNonNegative': 'Số điểm thưởng không thể âm',
  'activity.register.pointAmountTooltip': 'Số điểm thưởng nhận được khi đăng ký, phải là số nguyên',
  'activity.register.promotionSettings': 'Cài đặt ưu đãi đăng ký',
  'activity.register.ticketReward': 'Phần thưởng vé tham gia',
  'activity.register.ticket': 'Vé tham gia',
  'activity.register.selectTicketTooltip': 'Chọn loại vé tham gia để tặng',
  'activity.register.selectTicketPlaceholder': 'Vui lòng chọn vé tham gia',
  'activity.register.ticketCount': 'Số lượng vé tham gia',
  'activity.register.ticketCountRequired': 'Phải nhập số lượng sau khi chọn vé tham gia',
  'activity.register.ticketCountNonNegative': 'Số lượng không thể âm',
  'activity.register.ticketCountTooltip': 'Thiết lập số lượng vé tham gia để tặng',
  'activity.register.enterTicketCount': 'Vui lòng nhập số lượng',
  'activity.register.addTicket': 'Thêm vé tham gia',
  'activity.register.spinTickets': 'Cấu hình vé tham gia',
  'activity.register.addSpinTicket': '+ Thêm vé tham gia',
  'activity.register.distributeMode': 'Phương thức phát thưởng',
  'activity.register.distributeModeDirect': 'Phát trực tiếp vào tài khoản người dùng',
  'activity.register.distributeModeDirectDesc': 'Khi đăng nhập lần đầu, tiền mặt vào tài khoản chính, điểm vào tài khoản điểm, lượt quay được phát tự động',
  'activity.register.distributeModeCoupon': 'Phát tới Trung tâm ưu đãi chờ nhận',
  'activity.register.distributeModeCouponDesc': 'Khi đăng nhập lần đầu, phần thưởng xuất hiện tại Trung tâm ưu đãi, người dùng nhận thủ công mới được ghi có',
  'activity.register.distributeModeNote': 'Cả hai phương thức đều có hiệu lực khi đăng nhập lần đầu sau đăng ký, phù hợp cho kịch bản thưởng theo giai đoạn với người dùng nhập khẩu',
  'activity.register.defaultReward': 'Phần thưởng mặc định',
  'activity.register.defaultRewardDesc': 'Áp dụng khi không khớp bất kỳ quy tắc nào',
  'activity.register.spinCount': 'Số lượt quay',
  'activity.register.spinTicket': 'Vòng quay chỉ định',
  'activity.register.spinTicketPlaceholder': 'Vòng quay mặc định',
  'activity.register.agentLineRules': 'Phần thưởng khác nhau theo dòng đại lý',
  'activity.register.rule': 'Quy tắc',
  'activity.register.agentLines': 'Dòng đại lý áp dụng',
  'activity.register.addAgentLine': '+ Thêm dòng đại lý',
  'activity.register.addAgentLineRule': '+ Thêm quy tắc dòng đại lý',
  'activity.register.agentIdDuplicate': 'Cùng một đại lý không thể xuất hiện trong nhiều quy tắc',
  'activity.register.agentLinesRequired': 'Vui lòng chọn ít nhất một dòng đại lý',
  'activity.register.onlyTempUser': 'Chỉ phát cho người dùng bảng tạm',
  'activity.register.onlyTempUserDesc': 'Khi bật, phần thưởng chỉ phát cho người dùng đăng ký bảng tạm; người dùng từ nguồn khác sẽ bị bỏ qua',

  // Daily First Recharge Template Vietnamese
  'activity.dailyFirstRecharge.title': 'Cài đặt nạp tiền đầu tiên hàng ngày',
  'activity.dailyFirstRecharge.basicSettings': 'Cài đặt cơ bản',
  'activity.dailyFirstRecharge.cashRewardSettings': 'Cài đặt thưởng tiền mặt',
  'activity.dailyFirstRecharge.pointRewardSettings': 'Cài đặt thưởng điểm',
  'activity.dailyFirstRecharge.rewardLimitSettings': 'Cài đặt giới hạn thưởng',
  'activity.dailyFirstRecharge.dailyMinRechargeAmount': 'Số tiền nạp tối thiểu hàng ngày (bao gồm)',
  'activity.dailyFirstRecharge.dailyMaxRechargeAmount': 'Số tiền nạp tối đa hàng ngày (bao gồm)',
  'activity.dailyFirstRecharge.cashAwardMethod': 'Phương thức thưởng tiền mặt',
  'activity.dailyFirstRecharge.cashAmount': 'Số tiền mặt',
  'activity.dailyFirstRecharge.desireMultiple': 'Bội số doanh thu',
  'activity.dailyFirstRecharge.pointAwardMethod': 'Phương thức thưởng điểm',
  'activity.dailyFirstRecharge.pointAmount': 'Số điểm',
  'activity.dailyFirstRecharge.awardMax': 'Giới hạn thưởng tối đa',
  'activity.dailyFirstRecharge.enterDailyMinRechargeAmount': 'Vui lòng nhập số tiền nạp tối thiểu hàng ngày',
  'activity.dailyFirstRecharge.enterDailyMaxRechargeAmount': 'Vui lòng nhập số tiền nạp tối đa hàng ngày',
  'activity.dailyFirstRecharge.selectCashAwardMethod': 'Vui lòng chọn phương thức thưởng tiền mặt',
  'activity.dailyFirstRecharge.selectPointAwardMethod': 'Vui lòng chọn phương thức thưởng điểm',
  'activity.dailyFirstRecharge.enterCashAmount': 'Vui lòng nhập số tiền mặt',
  'activity.dailyFirstRecharge.enterDesireMultiple': 'Vui lòng nhập bội số doanh thu',
  'activity.dailyFirstRecharge.enterPointAmount': 'Vui lòng nhập số điểm',
  'activity.dailyFirstRecharge.enterAwardMax': 'Vui lòng nhập giới hạn thưởng tối đa',
  'activity.dailyFirstRecharge.fixedAmount': 'Số tiền cố định',
  'activity.dailyFirstRecharge.percentage': 'Theo tỷ lệ phần trăm',
  'activity.dailyFirstRecharge.amountMustBeNonNegative': 'Số tiền không thể âm',
  'activity.dailyFirstRecharge.amountMustBePositive': 'Số tiền phải lớn hơn 0',
  'activity.dailyFirstRecharge.multipleMustBePositive': 'Bội số doanh thu phải lớn hơn 0',
  'activity.dailyFirstRecharge.maxMustBeGreaterThanMin': 'Số tiền nạp tối đa phải lớn hơn số tiền nạp tối thiểu',
  'activity.dailyFirstRecharge.dailyMinRechargeAmountTooltip': 'Tổng số tiền nạp hàng ngày của người dùng phải đạt đến số tiền này để tham gia hoạt động',
  'activity.dailyFirstRecharge.dailyMaxRechargeAmountTooltip': 'Giới hạn trên của tổng số tiền nạp hàng ngày của người dùng, số tiền vượt quá giới hạn này không tham gia vào tính toán hoạt động',
  'activity.dailyFirstRecharge.cashAwardMethodTooltip': 'Chọn phương thức tính thưởng tiền mặt: số tiền cố định hoặc tỷ lệ phần trăm dựa trên tiền nạp',
  'activity.dailyFirstRecharge.cashAmountTooltip': 'Phương thức cố định: số tiền thưởng trực tiếp; Phương thức tỷ lệ: tỷ lệ phần trăm thưởng (ví dụ: 10 có nghĩa là 10%)',
  'activity.dailyFirstRecharge.desireMultipleTooltip': 'Yêu cầu bội số doanh thu để nhận thưởng tiền mặt',
  'activity.dailyFirstRecharge.pointAwardMethodTooltip': 'Chọn phương thức tính thưởng điểm: số điểm cố định hoặc tỷ lệ phần trăm dựa trên tiền nạp',
  'activity.dailyFirstRecharge.pointAmountTooltip': 'Phương thức cố định: số điểm thưởng trực tiếp; Phương thức tỷ lệ: tỷ lệ phần trăm thưởng (ví dụ: 5 có nghĩa là 5%)',
  'activity.dailyFirstRecharge.awardMaxTooltip': 'Giới hạn tổng số tiền thưởng tối đa mà người dùng có thể nhận trong một hoạt động',
  'activity.dailyFirstRecharge.note': 'Lưu ý',
  'activity.dailyFirstRecharge.noteAmountRange': 'Số tiền nạp tối thiểu hàng ngày phải nhỏ hơn số tiền nạp tối đa hàng ngày',
  'activity.dailyFirstRecharge.noteAwardMethod': 'Phương thức thưởng: Cố định = Số tiền/số lượng trực tiếp, Phần trăm = Tính theo phần trăm tiền gửi',
  'activity.dailyFirstRecharge.noteFlowMultiple': 'Bội số lưu thông được sử dụng cho các yêu cầu rút tiền thưởng',
  'activity.dailyFirstRecharge.noteAwardMax': 'Giới hạn thưởng tối đa là tổng giới hạn cho tiền mặt và thưởng điểm',
  'activity.dailyFirstRecharge.dailyMinAmount': 'Số tiền tối thiểu hàng ngày',
  'activity.dailyFirstRecharge.dailyMaxAmount': 'Số tiền tối đa hàng ngày',
  'activity.dailyFirstRecharge.dailyMinAmountTooltip': 'Giới hạn tối thiểu cho số tiền nạp hàng ngày của thành viên',
  'activity.dailyFirstRecharge.dailyMaxAmountTooltip': 'Giới hạn tối đa cho số tiền nạp hàng ngày của thành viên',
  'activity.dailyFirstRecharge.dailyMaxAmountError': 'Số tiền tối đa hàng ngày phải lớn hơn số tiền tối thiểu',
  'activity.dailyFirstRecharge.enterCashPercentage': 'Nhập phần trăm thưởng tiền mặt',
  'activity.dailyFirstRecharge.enterPointPercentage': 'Nhập phần trăm thưởng điểm',
  'activity.dailyFirstRecharge.percentageMaxError': 'Phần trăm không thể vượt quá 100%',
  'activity.dailyFirstRecharge.rechargePageDescription': 'Mô tả trang nạp tiền',
  'activity.dailyFirstRecharge.descriptionZhCN': 'Tiếng Trung Giản Thể',
  'activity.dailyFirstRecharge.descriptionEnUS': 'Tiếng Anh',
  'activity.dailyFirstRecharge.descriptionViVN': 'Tiếng Việt',
  'activity.dailyFirstRecharge.enterDescription': 'Vui lòng nhập mô tả',

  // Cài đặt Thưởng Nạp Tiền
  'activity.recharge.title': 'Cài Đặt Thưởng Nạp Tiền',
  'activity.recharge.rechargeCount': 'Số Lần Nạp Tiền Trong Hoạt Động',
  'activity.recharge.minRechargeAmount': 'Số tiền nạp tối thiểu (đã bao gồm)',
  'activity.recharge.maxRechargeAmount': 'Số tiền nạp tối đa (đã bao gồm)',
  'activity.recharge.cashRewardSettings': "Tiền mặt",
  'activity.recharge.pointRewardSettings': 'Điểm',
  'activity.recharge.awardMax': 'Giới Hạn Thưởng Tối Đa',
  'activity.recharge.addCondition': 'Thêm Điều Kiện Nạp Tiền',
  'activity.recharge.confirmDelete': 'Xác nhận xóa điều kiện này?',
  'activity.recharge.enterRechargeCount': 'Vui lòng nhập số lần nạp tiền',
  'activity.recharge.enterMinRechargeAmount': 'Vui lòng nhập số tiền nạp tối thiểu mỗi lần',
  'activity.recharge.enterMaxRechargeAmount': 'Vui lòng nhập số tiền nạp tối đa mỗi lần',
  'activity.recharge.selectCashAwardMethod': 'Vui lòng chọn phương thức thưởng tiền mặt',
  'activity.recharge.selectPointAwardMethod': 'Vui lòng chọn phương thức thưởng điểm',
  'activity.recharge.enterCashAmount': 'Vui lòng nhập số tiền mặt',
  'activity.recharge.enterDesireMultiple': 'Vui lòng nhập bội số doanh thu',
  'activity.recharge.enterPointAmount': 'Vui lòng nhập số điểm',
  'activity.recharge.enterAwardMax': 'Vui lòng nhập giới hạn thưởng tối đa',
  'activity.recharge.enterCashPercentage': 'Vui lòng nhập phần trăm thưởng tiền mặt',
  'activity.recharge.enterPointPercentage': 'Vui lòng nhập phần trăm thưởng điểm',
  'activity.recharge.fixedAmount': 'Số Tiền Cố Định',
  'activity.recharge.percentage': 'Theo Phần Trăm',
  'activity.recharge.amountMustBePositive': 'Số tiền phải lớn hơn 0',
  'activity.recharge.rechargeCountMustBePositiveInteger': 'Số lần nạp tiền phải là số nguyên dương',
  'activity.recharge.maxAmountError': 'Số tiền nạp tối đa phải lớn hơn số tiền tối thiểu',
  'activity.recharge.percentageMaxError': 'Phần trăm không thể vượt quá 100%',
  'activity.recharge.truncateNotice': 'Tỷ lệ ưu đãi hỗ trợ tối đa 2 chữ số thập phân. Tiền thưởng tính theo tỷ lệ giữ 2 chữ số thập phân, phần vượt quá sẽ bị cắt bỏ (không làm tròn); phần thưởng dưới 0.01 sẽ bị loại bỏ và không phát. Thưởng điểm không bị ảnh hưởng.',
  'activity.recharge.cashAwardMethodTooltip': 'Chọn phương thức tính thưởng tiền mặt: số tiền cố định hoặc phần trăm của số tiền nạp',
  'activity.recharge.pointAwardMethodTooltip': 'Chọn phương thức tính thưởng điểm: số lượng cố định hoặc phần trăm của số tiền nạp',
  'activity.recharge.awardMaxTooltip': 'Giới hạn số tiền thưởng tối đa mà người dùng có thể nhận trong một hoạt động',
  'activity.recharge.rechargeCountMustBeUnique': 'Số lần nạp tiền không thể trùng lặp',
  'activity.recharge.rechargeCountMustBeConsecutive': 'Số lần nạp tiền phải liên tiếp',
  'activity.recharge.cannotBothBeZero': 'Thưởng tiền mặt và thưởng điểm không thể cùng là 0',
  'activity.recharge.stage': 'Giai đoạn',
  'activity.recharge.copyStage': 'Sao chép giai đoạn',
  'activity.recharge.deleteStage': 'Xóa giai đoạn',
  'activity.recharge.enterRechargeCountPlaceholder': 'Vui lòng nhập N, ví dụ: lần 1, lần 2',
  'activity.recharge.awardDistribution': 'Phân phối thưởng',
  'activity.recharge.cashAward': 'Thưởng tiền mặt',
  'activity.recharge.selectAwardMethod': 'Vui lòng chọn phương thức tặng thưởng',
  'activity.recharge.enterPercentage': 'Vui lòng nhập tỷ lệ',
  'activity.recharge.enterFixedAmount': 'Vui lòng nhập số tiền cố định',
  'activity.recharge.maxCashAmount': 'Vui lòng nhập số tiền mặt tối đa (-1 không giới hạn)',
  'activity.recharge.maxAmountValidation': 'Vui lòng nhập -1 hoặc giá trị lớn hơn hoặc bằng 0',
  'activity.recharge.desireMultiple': 'Vui lòng nhập bội số doanh thu (trống hoặc 0 không giới hạn)',
  'activity.recharge.pointAward': 'Thưởng điểm',
  'activity.recharge.enterFixedPoints': 'Vui lòng nhập điểm cố định',
  'activity.recharge.maxPointAmount': 'Vui lòng nhập điểm tối đa (-1 không giới hạn)',
  'activity.recharge.lotteryTicket': 'Vé xổ số',
  'activity.recharge.selectLotteryActivity': 'Vui lòng chọn hoạt động xổ số',
  'activity.recharge.ticketCount': 'Vui lòng nhập số lượng (mặc định 1)',
  'activity.recharge.enterTicketCount': 'Vui lòng nhập số lượng',
  'activity.recharge.ticketCountNonNegative': 'Số lượng không thể âm',
  'activity.recharge.addStage': '+ Thêm giai đoạn',
  // CB7REQ-331 阶段内金额阶梯
  'activity.recharge.tier': 'Bậc',
  'activity.recharge.addTier': '+ Thêm bậc',
  'activity.recharge.deleteTier': 'Xóa bậc',
  'activity.recharge.tierLast': 'Bậc cuối · không giới hạn trên',
  'activity.recharge.tierRangeNoUpper': '≥ {min} (bao gồm), không giới hạn trên',
  'activity.recharge.tierRange': '{min} (bao gồm) – {max} (không bao gồm)',
  'activity.recharge.tierRangePending': 'Khoảng cần chỉnh sửa',
  'activity.recharge.tierMinMustIncrease': 'Mức tối thiểu của bậc phải lớn hơn hẳn bậc trước',
  'activity.recharge.tierListTitle': 'Bậc theo số tiền (xét theo số tiền mỗi lần nạp, loại trừ lẫn nhau)',
  'activity.recharge.tierListHint': 'Khoản nạp dưới mức tối thiểu của bậc 1 không được thưởng · Mỗi bậc chỉ nhập "Số tiền nạp tối thiểu (đã bao gồm)"; giới hạn trên tự động = mức tối thiểu của bậc kế tiếp (không bao gồm), bậc cuối không giới hạn · Mức tối thiểu phải tăng dần nghiêm ngặt; backend kiểm tra lại khi lưu',
  'activity.recharge.tierUpperAuto': 'Giới hạn trên = mức tối thiểu bậc kế tiếp (không bao gồm)',
  'activity.recharge.capOnlyLastTier': 'Trường giới hạn tối đa chỉ xuất hiện ở bậc cuối (bậc này không có giới hạn trên nên thưởng theo tỷ lệ cần chặn trần); -1 nghĩa là không giới hạn.',

  // Login Recharge Template
  'activity.loginRecharge.promotionSettings': 'Cài đặt thưởng đăng nhập nạp tiền',
  'activity.loginRecharge.awardName': 'Tên giải thưởng',
  'activity.loginRecharge.pointAmount': 'Số điểm thưởng',
  'activity.loginRecharge.winners': 'Số người thắng',
  'activity.loginRecharge.type': 'Loại giải thưởng',
  'activity.loginRecharge.deposit': 'Nạp tiền',
  'activity.loginRecharge.login': 'Đăng nhập',
  'activity.loginRecharge.addCondition': 'Thêm điều kiện',
  'activity.loginRecharge.atLeastOneCondition': 'Cần ít nhất một điều kiện',
  'activity.loginRecharge.awardNameRequired': 'Tên giải thưởng là bắt buộc',
  'activity.loginRecharge.pointAmountRequired': 'Số điểm thưởng là bắt buộc',
  'activity.loginRecharge.winnersRequired': 'Số người thắng là bắt buộc',
  'activity.loginRecharge.enterAwardName': 'Vui lòng nhập tên giải thưởng',
  'activity.loginRecharge.awardNameMaxLength': 'Tên giải thưởng không được vượt quá 100 ký tự',
  'activity.loginRecharge.enterPointAmount': 'Vui lòng nhập số điểm thưởng',
  'activity.loginRecharge.pointAmountMustBePositive': 'Số điểm thưởng phải lớn hơn 0',
  'activity.loginRecharge.enterWinners': 'Vui lòng nhập số người thắng',
  'activity.loginRecharge.winnersMustBePositive': 'Số người thắng phải lớn hơn 0',
  'activity.loginRecharge.selectType': 'Vui lòng chọn loại giải thưởng',

  // Activity Operate Management
  'activity.operate.loginRecharge': 'Giảm giá nạp tiền khi đăng nhập',
  'activity.loginRecharge.triggerAmount': 'Số tiền kích hoạt',
  'activity.loginRecharge.drawDate': 'Ngày quay số',
  'activity.loginRecharge.activityName': 'Tên hoạt động',
  'activity.loginRecharge.status': 'Trạng thái',
  'activity.loginRecharge.numberPlate': 'Số biển số',
  'activity.loginRecharge.awardStatus': 'Trạng thái thưởng',
  'activity.loginRecharge.createTime': 'Thời gian tạo',
  'activity.loginRecharge.pendingDraw': 'Chờ quay số',
  'activity.loginRecharge.drawn': 'Đã quay số',
  'activity.loginRecharge.notWin': 'Không trúng',
  'activity.loginRecharge.pendingAward': 'Chờ phát thưởng',
  'activity.loginRecharge.received': 'Đã nhận',
  'activity.loginRecharge.awardStatusPlaceholder': 'Vui lòng chọn trạng thái thưởng',
  'activity.loginRecharge.awardAmount': 'Số tiền thưởng',
  'activity.loginRecharge.operator': 'Người thao tác',
  'activity.loginRecharge.operateTime': 'Thời gian thao tác',
  'activity.loginRecharge.updateShareLink': 'Cập nhật liên kết chia sẻ',
  'activity.loginRecharge.dataPkCode': 'Số serial hệ thống',
  'activity.loginRecharge.shareLink': 'Liên kết chia sẻ',
  'activity.loginRecharge.dataPkCodeRequired': 'Số serial hệ thống không được để trống',
  'activity.loginRecharge.shareLinkRequired': 'Liên kết chia sẻ không được để trống',
  'activity.loginRecharge.shareLinkPlaceholder': 'Vui lòng nhập liên kết chia sẻ',
  'activity.loginRecharge.socialMediaLink': 'Liên kết mạng xã hội',
  'activity.loginRecharge.invalidLink': 'Định dạng liên kết không hợp lệ',
  'activity.loginRecharge.sendAward': 'Gửi thưởng',
  'activity.loginRecharge.awardSentSuccess': 'Gửi thưởng thành công',
  'activity.loginRecharge.awardSentFail': 'Gửi thưởng thất bại',
  'activity.loginRecharge.awardSending': 'Đang gửi thưởng, vui lòng chờ...',
  'activity.loginRecharge.batchSend': 'Gửi hàng loạt',
  'activity.loginRecharge.batchSendConfirm': 'Xác nhận gửi hàng loạt',
  'activity.loginRecharge.batchSendConfirmMessage': 'Bạn có chắc chắn muốn gửi hàng loạt {{count}} bản ghi đã chọn?\n\nLưu ý: Gửi hàng loạt sẽ được xử lý bất đồng bộ trong nền. Vui lòng làm mới trang sau để xem kết quả.',
  'activity.loginRecharge.batchSendConfirmContent': 'Bạn có chắc chắn muốn gửi hàng loạt {{count}} bản ghi đã chọn?',
  'activity.loginRecharge.batchSendAsyncNotice': 'Lưu ý: Gửi hàng loạt sẽ được xử lý bất đồng bộ trong nền. Vui lòng làm mới trang sau để xem kết quả. Không gửi lặp lại.',
  'activity.loginRecharge.confirmSend': 'Xác nhận gửi',
  'activity.loginRecharge.batchSendTaskSubmitted': 'Nhiệm vụ gửi hàng loạt đã được gửi, đang xử lý trong nền',
  'activity.loginRecharge.batchSendSuccess': 'Nhiệm vụ gửi hàng loạt đã được gửi thành công',
  'activity.loginRecharge.batchSendFail': 'Gửi nhiệm vụ gửi hàng loạt thất bại',
  'activity.loginRecharge.batchSending': 'Đang gửi nhiệm vụ gửi hàng loạt...',
  'activity.loginRecharge.selectRecordsToSend': 'Vui lòng chọn bản ghi để gửi',
  'activity.loginRecharge.selectRecordsFirst': 'Vui lòng chọn bản ghi để gửi trước',
  'activity.loginRecharge.eligibleRecords': 'Bản ghi đủ điều kiện',
  'activity.loginRecharge.selectAllEligible': 'Chọn tất cả đủ điều kiện',

  // Redemption Record Management
  'activity.redemptionRecord.useTime': 'Thời gian sử dụng mã đổi thưởng',
  'activity.redemptionRecord.actNameOrId': 'Tên hoạt động/ID',
  'activity.redemptionRecord.actNameOrIdPlaceholder': 'Vui lòng nhập tên hoạt động hoặc ID',
  'activity.redemptionRecord.redemptionCode': 'Mã đổi thưởng',
  'activity.redemptionRecord.redemptionCodePlaceholder': 'Vui lòng nhập mã đổi thưởng',
  'activity.redemptionRecord.memberAccount': 'Tài khoản thành viên',
  'activity.redemptionRecord.memberAccountPlaceholder': 'Vui lòng nhập tài khoản thành viên',
  'activity.redemptionRecord.promotionName': 'Tên ưu đãi',
  'activity.redemptionRecord.usageMode': 'Chế độ sử dụng',
  'activity.redemptionRecord.awardContent': 'Nội dung phần thưởng',
  'activity.redemptionRecord.distributionMethod': 'Phương thức phân phối',
  'activity.redemptionRecord.redemptionTime': 'Thời gian sử dụng',

  // Bản dịch chung
  'common.operation': 'Thao tác',
  'common.delete': 'Xóa',
  'common.save': 'Lưu',
  'common.action': 'Thao tác',
  'common.saveSuccess': 'Lưu thành công',
  'common.saveFailed': 'Lưu thất bại',
  'common.confirm': 'Xác nhận',
  'common.cancel': 'Hủy',
  'common.settings': 'Cài đặt',
  'common.view': 'Xem',

  // Redemption Code Management
  'activity.redemptionCode.list': 'Danh sách mã đổi thưởng',
  'activity.redemptionCode.usageRecord': 'Bản ghi sử dụng mã đổi thưởng',
  'activity.redemptionCode.promotionName': 'Tên ưu đãi',
  'activity.redemptionCode.promotionId': 'ID ưu đãi',
  'activity.redemptionCode.awardType': 'Loại phần thưởng đổi',
  'activity.redemptionCode.awardAmount': 'Phần thưởng đổi',
  'activity.redemptionCode.status': 'Trạng thái',
  'activity.redemptionCode.enabled': 'Bật',
  'activity.redemptionCode.disabled': 'Tắt',
  'activity.redemptionCode.codeQuantity': 'Số lượng mã',
  'activity.redemptionCode.unlimited': 'Không giới hạn',
  'activity.redemptionCode.times': 'lần',
  'activity.redemptionCode.usageMode': 'Chế độ sử dụng',
  'activity.redemptionCode.reusable': 'Tái sử dụng',
  'activity.redemptionCode.singleUse': 'Sử dụng một lần',
  'activity.redemptionCode.unknown': 'Không xác định',
  'activity.redemptionCode.distributionMethod': 'Phương thức phân phối',
  'activity.redemptionCode.manualDistribution': 'Phân phối thủ công',
  'activity.redemptionCode.autoDistribution': 'Phân phối tự động',
  'activity.redemptionCode.usedCount': 'Số lần đã sử dụng',
  'activity.redemptionCode.operator': 'Người thao tác',
  'activity.redemptionCode.availableTime': 'Thời gian có thể đổi',
  'activity.redemptionCode.operation': 'Thao tác',
  'activity.redemptionCode.quantity': 'Số lượng',

  // Redemption Code Forms and Modals
  'activity.redemptionCode.createSuccess': 'Tạo thành công',
  'activity.redemptionCode.createFailed': 'Tạo thất bại',
  'activity.redemptionCode.disableSuccess': 'Tắt thành công',
  'activity.redemptionCode.enableSuccess': 'Bật thành công',
  'activity.redemptionCode.confirmDisable': 'Xác nhận tắt',
  'activity.redemptionCode.confirmEnable': 'Xác nhận bật',
  'activity.redemptionCode.couponSettings': 'Cài đặt phiếu giảm giá',
  'activity.redemptionCode.promotionNameRequired': 'Vui lòng nhập tên ưu đãi',
  'activity.redemptionCode.promotionNamePlaceholder': 'Vui lòng nhập tên ưu đãi',
  'activity.redemptionCode.distributionMethodRequired': 'Vui lòng chọn phương thức phân phối',
  'activity.redemptionCode.distributionMethodPlaceholder': 'Vui lòng chọn phương thức phân phối',
  'activity.redemptionCode.usageModeRequired': 'Vui lòng chọn chế độ sử dụng',
  'activity.redemptionCode.usageModePlaceholder': 'Vui lòng chọn chế độ sử dụng',
  'activity.redemptionCode.availableTimeRequired': 'Vui lòng chọn thời gian có thể sử dụng',
  'activity.redemptionCode.availableTimePlaceholder': ['Thời gian bắt đầu', 'Thời gian kết thúc'],
  'activity.redemptionCode.uniqueCodeRequired': 'Vui lòng nhập mã đổi thưởng duy nhất',
  'activity.redemptionCode.uniqueCodeEmpty': 'Mã đổi thưởng không được để trống',
  'activity.redemptionCode.uniqueCodePlaceholder': 'ví dụ: PROMO2025',
  'activity.redemptionCode.perUserLimitRequired': 'Vui lòng nhập giới hạn mỗi người dùng',
  'activity.redemptionCode.perUserLimitPattern': 'Vui lòng nhập số nguyên dương',
  'activity.redemptionCode.perUserLimitPlaceholder': '1 (cố định)',
  'activity.redemptionCode.totalUsageRequired': 'Vui lòng nhập tổng số lần sử dụng',
  'activity.redemptionCode.totalUsagePattern': 'Vui lòng nhập -1 (không giới hạn) hoặc số nguyên dương',
  'activity.redemptionCode.totalUsagePlaceholder': '-1 (không giới hạn) hoặc số nguyên dương',
  'activity.redemptionCode.prefixRequired': 'Vui lòng nhập tiền tố sử dụng một lần',
  'activity.redemptionCode.prefixMaxLength': 'Tiền tố tối đa 4 ký tự',
  'activity.redemptionCode.prefixPattern': 'Chỉ được chứa chữ cái và số',
  'activity.redemptionCode.prefixPlaceholder': 'ví dụ: PROM',
  'activity.redemptionCode.awardTypeRequired': 'Vui lòng chọn loại phần thưởng',
  'activity.redemptionCode.awardTypePlaceholder': 'Vui lòng chọn loại phần thưởng',
  'activity.redemptionCode.pointAmountRequired': 'Vui lòng nhập số điểm',
  'activity.redemptionCode.pointAmountPattern': 'Vui lòng nhập số nguyên dương',
  'activity.redemptionCode.pointAmountPlaceholder': 'Số điểm (số nguyên dương)',
  'activity.redemptionCode.cashAmountRequired': 'Vui lòng nhập số tiền mặt',
  'activity.redemptionCode.cashAmountPattern': 'Vui lòng nhập số tiền hợp lệ',
  'activity.redemptionCode.cashAmountPlaceholder': 'Số tiền mặt',
  'activity.redemptionCode.currencyRequired': 'Vui lòng chọn loại tiền',
  'activity.redemptionCode.currencyPlaceholder': 'Vui lòng chọn loại tiền',
  'activity.redemptionCode.turnoverMultipleRequired': 'Vui lòng nhập bội số doanh thu',
  'activity.redemptionCode.turnoverMultiplePlaceholder': 'Bội số doanh thu',
  // Redemption Code Operations and Modals
  'activity.redemptionCode.addCodes': 'Thêm mã',
  'activity.redemptionCode.addUsageCount': 'Thêm số lần sử dụng',
  'activity.redemptionCode.showUniqueCode': 'Thông tin mã đổi thưởng',
  'activity.redemptionCode.exportCodes': 'Xuất mã',
  'activity.redemptionCode.copySuccess': 'Mã đổi thưởng đã được sao chép vào clipboard',
  'activity.redemptionCode.copyFailed': 'Sao chép thất bại',
  'activity.redemptionCode.copyCode': 'Sao chép mã đổi thưởng',
  'activity.redemptionCode.copyInstructions': 'Nhấp vào nút "Sao chép mã đổi thưởng" để sao chép mã vào clipboard',
  'activity.redemptionCode.batchNumber': 'Số lô',
  'activity.redemptionCode.batchQuantity': 'Số lượng',
  'activity.redemptionCode.generationStatus': 'Trạng thái tạo',
  'activity.redemptionCode.generating': 'Đang tạo',
  'activity.redemptionCode.completed': 'Hoàn thành',
  'activity.redemptionCode.failed': 'Thất bại',
  'activity.redemptionCode.batchOperator': 'Người thao tác',
  'activity.redemptionCode.batchCreateTime': 'Thời gian tạo',
  'activity.redemptionCode.batchOperation': 'Thao tác',
  'activity.redemptionCode.getBatchListFailed': 'Lấy danh sách lô thất bại',
  'activity.redemptionCode.exportFailed': 'Xuất thất bại',
  'activity.redemptionCode.availableDate': 'Ngày có thể đổi',
  'activity.redemptionCode.activityName': 'Tên hoạt động',
  'activity.redemptionCode.activityNamePlaceholder': 'Vui lòng nhập tên hoạt động',
  'activity.redemptionCode.creator': 'Người tạo',
  'activity.redemptionCode.creatorPlaceholder': 'Vui lòng nhập người tạo',
  'activity.redemptionCode.statusPlaceholder': 'Vui lòng chọn trạng thái',
  // Additional missing translations
  'activity.redemptionCode.points': 'Điểm',
  'activity.redemptionCode.cash': 'Tiền mặt',
  'activity.redemptionCode.unlimitedTimes': 'Không giới hạn',
  'activity.redemptionCode.timesUnit': 'lần',
  'activity.redemptionCode.quantityUnit': 'Số lượng',
  'activity.redemptionCode.dataLoadFailed': 'Tải dữ liệu thất bại',
  'activity.redemptionCode.queryParams': 'Tham số truy vấn',
  'activity.redemptionCode.createRedemptionCodeFailed': 'Tạo mã đổi thưởng thất bại',
  'activity.redemptionCode.startTime': 'Thời gian bắt đầu',
  'activity.redemptionCode.endTime': 'Thời gian kết thúc',
  'activity.redemptionCode.totalUsageLabel': 'Tổng số lần sử dụng (nhập -1 để không giới hạn)',
  'activity.redemptionCode.prefixLabel': 'Tiền tố (tối đa 4 ký tự, hệ thống tạo 5 ký tự)',
  'activity.redemptionCode.addCodesSuccess': 'Tạo mã thành công',
  'activity.redemptionCode.addCodesFailed': 'Tạo mã thất bại',
  'activity.redemptionCode.addUsageCountSuccess': 'Tăng số lần sử dụng thành công',
  'activity.redemptionCode.addUsageCountFailed': 'Tăng số lần sử dụng thất bại',
  'activity.redemptionCode.addCodesTitle': 'Thêm mã',
  'activity.redemptionCode.addUsageCountTitle': 'Thêm số lần sử dụng',
  'activity.redemptionCode.redemptionCodeName': 'Tên mã đổi thưởng',
  'activity.redemptionCode.currentTotalUsage': 'Tổng số lần sử dụng hiện tại',
  'activity.redemptionCode.unlimitedUsage': 'Không giới hạn',
  'activity.redemptionCode.addUsageCountRequired': 'Vui lòng nhập số lần sử dụng cần thêm',
  'activity.redemptionCode.addUsageCountRange': 'Số lần sử dụng phải từ 1-100000',
  'activity.redemptionCode.addUsageCountPlaceholder': 'Vui lòng nhập số lần sử dụng cần thêm',
  'activity.redemptionCode.singleUsePrefix': 'Tiền tố sử dụng một lần',
  'activity.redemptionCode.addCodesQuantityRequired': 'Vui lòng nhập số lượng mã cần thêm',
  'activity.redemptionCode.addCodesQuantityRange': 'Số lượng mã phải từ 1-100000',
  'activity.redemptionCode.addCodesQuantityPlaceholder': 'Vui lòng nhập số lượng mã cần thêm',
  'activity.redemptionCode.showUniqueCodeTitle': 'Thông tin mã đổi thưởng',
  'activity.redemptionCode.exportCodesTitle': 'Xuất mã',
  // Additional missing translations for forms
  'activity.redemptionCode.codeUnit': 'cái',
  'activity.redemptionCode.perUserUnit': 'lần',
  'activity.redemptionCode.export': 'Xuất',
  // Button translations
  'common.search': 'Tìm kiếm',
  'common.reset': 'Đặt lại',
  'common.add': 'Thêm mới',
  'common.disable': 'Tắt',
  'common.enable': 'Bật',
  // Confirmation dialog messages
  'activity.redemptionCode.confirmDisableMessage': 'Bạn có chắc chắn muốn tắt mã đổi thưởng "{{actName}}"?',
  'activity.redemptionCode.confirmEnableMessage': 'Bạn có chắc chắn muốn bật mã đổi thưởng "{{actName}}"?',
  // Show unique code modal
  'activity.redemptionCode.activityNameLabel': 'Tên hoạt động:',
  'activity.redemptionCode.redemptionCodeLabel': 'Mã đổi thưởng:',
  'activity.redemptionCode.close': 'Đóng',
  // Add codes modal
  'activity.redemptionCode.uniqueCode': 'Mã duy nhất',
  'activity.redemptionCode.addUsageCountLabel': 'Thêm số lần sử dụng',
  'activity.redemptionCode.addCodesQuantityLabel': 'Số lượng mã mới',
  'activity.redemptionCode.cancel': 'Hủy',
  'activity.redemptionCode.confirm': 'Xác nhận',
  'activity.redemptionCode.reusableModeDescription': '• Chế độ sử dụng lại: Tăng tổng số lần sử dụng của mã đổi thưởng',
  'activity.redemptionCode.systemUpdateDescription': '• Hệ thống sẽ cập nhật giới hạn tổng số lần sử dụng của mã đổi thưởng',
  'activity.redemptionCode.maxUsageDescription': '• Hỗ trợ tối đa lên đến 100,000 lần sử dụng',
  'activity.redemptionCode.perUserLimit': 'Giới hạn mỗi người dùng',
  'activity.redemptionCode.totalUsageLimit': 'Tổng số lần sử dụng (nhập -1 để không giới hạn)',
  'activity.redemptionCode.singleUsePrefixLabel': 'Tiền tố (tối đa 4 ký tự, hệ thống tạo 5 ký tự)',
  'activity.redemptionCode.singleUsePrefixRequired': 'Vui lòng nhập tiền tố sử dụng một lần',
  'activity.redemptionCode.singleUsePrefixMaxLength': 'Tiền tố tối đa 4 ký tự',
  'activity.redemptionCode.singleUsePrefixPattern': 'Chỉ cho phép chữ cái và số',
  'activity.redemptionCode.singleUsePrefixPlaceholder': 'vd: PROM',
  'activity.redemptionCode.pointAmount': 'Số điểm',
  'activity.redemptionCode.cashAmount': 'Số tiền mặt',
  'activity.redemptionCode.currency': 'Tiền tệ',
  'activity.redemptionCode.turnoverMultiple': 'Bội số doanh thu',
  'activity.redemptionCode.singleUseDescription': 'Để đảm bảo mã đủ ngắn, hệ thống chỉ tạo 5 ký tự, nhiệm vụ sử dụng một lần',
  'activity.redemptionCode.maxCodesDescription': 'Tối đa 100,000 mã',
  // Reward mode (奖励模式)
  'activity.redemptionCode.rewardMode': 'Chế độ thưởng',
  'activity.redemptionCode.rewardModeRequired': 'Vui lòng chọn chế độ thưởng',
  'activity.redemptionCode.rewardModePlaceholder': 'Vui lòng chọn chế độ thưởng',
  'activity.redemptionCode.fixedMode': 'Cố định',
  'activity.redemptionCode.rangeMode': 'Khoảng',
  'activity.redemptionCode.randomReward': 'Phần thưởng ngẫu nhiên',
  'activity.redemptionCode.randomPoints': 'Điểm ngẫu nhiên',
  'activity.redemptionCode.randomCash': 'Tiền mặt ngẫu nhiên',
  // Range settings (区间设置)
  'activity.redemptionCode.atLeastOneRange': 'Vui lòng thêm ít nhất một khoảng',
  'activity.redemptionCode.minAmount': 'Số tiền tối thiểu',
  'activity.redemptionCode.minAmountRequired': 'Vui lòng nhập số tiền tối thiểu',
  'activity.redemptionCode.minAmountMustBeGreaterThanZero': 'Số tiền tối thiểu phải lớn hơn 0',
  'activity.redemptionCode.maxAmount': 'Số tiền tối đa',
  'activity.redemptionCode.maxAmountRequired': 'Vui lòng nhập số tiền tối đa',
  'activity.redemptionCode.probability': 'Xác suất (%)',
  'activity.redemptionCode.probabilityRequired': 'Vui lòng nhập xác suất',
  'activity.redemptionCode.probabilityMax100': 'Xác suất không thể vượt quá 100%',
  'activity.redemptionCode.positiveIntegerRequired': 'Vui lòng nhập số nguyên dương',
  'activity.redemptionCode.validNumber': 'Vui lòng nhập số hợp lệ',
  'activity.redemptionCode.validNumberMax2Decimal': 'Vui lòng nhập số hợp lệ (tối đa 2 chữ số thập phân)',
  'activity.redemptionCode.addRange': 'Thêm',
  'activity.redemptionCode.probabilitySumNote': 'Tổng xác suất của tất cả các khoảng phải là 100%',
  'activity.redemptionCode.probabilityMustBe100': 'Tổng xác suất của cài đặt khoảng phải là 100%',
  // Export codes modal
  'activity.redemptionCode.totalRecords': 'Tổng {{total}} bản ghi',
  'common.all': 'Tất cả',

  // Bản dịch mẫu Vòng Quay May Mắn
  'activity.luckySpin.pcIcon': 'Biểu tượng PC',
  'activity.luckySpin.selectPcIcon': 'Vui lòng chọn biểu tượng PC',
  'activity.luckySpin.h5Icon': 'Biểu tượng H5',
  'activity.luckySpin.selectH5Icon': 'Vui lòng chọn biểu tượng H5',
  'activity.luckySpin.appIcon': 'Biểu tượng App',
  'activity.luckySpin.selectAppIcon': 'Vui lòng chọn biểu tượng App',
  'activity.confirmDelete': 'Bạn có chắc chắn muốn xóa hoạt động ?',

  // Bản dịch mẫu tùy chỉnh
  'activity.custom.taskType': 'Loại nhiệm vụ',
  'activity.custom.selectTaskType': 'Vui lòng chọn loại nhiệm vụ',
  'activity.custom.once': 'Một lần',
  'activity.custom.repeat': 'Lặp lại',
  'activity.custom.taskCycle': 'Chu kỳ nhiệm vụ',
  'activity.custom.selectTaskCycle': 'Vui lòng chọn chu kỳ nhiệm vụ',
  'activity.custom.daily': 'Hàng ngày',
  'activity.custom.weekly': 'Hàng tuần',
  'activity.custom.permanent': 'Vĩnh viễn',
  'activity.custom.cashRewardDisplay': 'Hiển thị phần thưởng tiền mặt',
  'activity.custom.enterCashRewardDisplay': 'Vui lòng nhập hiển thị phần thưởng tiền mặt',
  'activity.custom.pointRewardDisplay': 'Hiển thị phần thưởng điểm',
  'activity.custom.enterPointRewardDisplay': 'Vui lòng nhập hiển thị phần thưởng điểm',
  'activity.custom.ticketRewardDisplay': 'Hiển thị phần thưởng vé',
  'activity.custom.enterTicketRewardDisplay': 'Vui lòng nhập hiển thị phần thưởng vé',
  'activity.custom.unlockButtonName': 'Tên nút trạng thái mở khóa',
  'activity.custom.enterUnlockButtonName': 'Vui lòng nhập tên nút trạng thái mở khóa',
  'activity.custom.buttonJumpLink': 'Liên kết chuyển nút',
  'activity.custom.enterButtonJumpLink': 'Vui lòng nhập liên kết chuyển nút',
  'activity.custom.rewardDisplay': 'Cài đặt hiển thị phần thưởng',
  'activity.custom.vipLevelMode': 'Chế độ chọn cấp VIP',
  'activity.custom.singleSelect': 'Chọn đơn',
  'activity.custom.multipleSelect': 'Chọn nhiều',
  'activity.custom.vipLevel': 'Cấp VIP',
  'activity.custom.vipLevels': 'Cấp VIP',
  'activity.custom.selectVipLevel': 'Vui lòng chọn cấp VIP',
  'activity.custom.selectVipLevels': 'Vui lòng chọn cấp VIP',

  // Every Recharge Template
  'activity.everyRecharge.configTitle': 'Cấu hình thưởng mỗi lần nạp',
  'activity.everyRecharge.minRechargeAmount': 'Nạp tối thiểu ≥',
  'activity.everyRecharge.maxRechargeAmount': 'Nạp tối đa ≤',
  'activity.everyRecharge.awardType': 'Loại thưởng',
  'activity.everyRecharge.amount': 'Số tiền',
  'activity.everyRecharge.turnover': 'Doanh thu',
  'activity.everyRecharge.settings': 'Cài đặt',
  'activity.everyRecharge.add': 'Thêm',
  'activity.everyRecharge.addNew': 'Thêm mới',
  'activity.everyRecharge.delete': 'Xóa',
  'activity.everyRecharge.cash': 'Tiền mặt',
  'activity.everyRecharge.point': 'Điểm',
  'activity.everyRecharge.ticket': 'Vé tham gia',
  'activity.everyRecharge.pleaseSelect': 'Vui lòng chọn',
  'activity.everyRecharge.selectAwardType': 'Vui lòng chọn loại thưởng',
  'activity.everyRecharge.selectTicket': 'Vui lòng chọn vé tham gia',
  'activity.everyRecharge.enterMinRechargeAmount': 'Vui lòng nhập số tiền nạp tối thiểu',
  'activity.everyRecharge.enterMaxRechargeAmount': 'Vui lòng nhập số tiền nạp tối đa',
  'activity.everyRecharge.enterAmount': 'Vui lòng nhập',
  'activity.everyRecharge.enterTurnover': 'Vui lòng nhập',
  'activity.everyRecharge.amountMustBePositive': 'Số tiền phải lớn hơn 0',
  'activity.everyRecharge.turnoverMustBePositive': 'Doanh thu phải lớn hơn hoặc bằng 0',
  'activity.everyRecharge.minMustLessThanMax': 'Tối thiểu phải nhỏ hơn tối đa',
  'activity.everyRecharge.maxMustGreaterThanMin': 'Tối đa phải lớn hơn tối thiểu',
  'activity.everyRecharge.rangeOverlap': 'Khoảng số tiền nạp không được trùng lặp với các mức khác',
  'activity.everyRecharge.tierDescription': 'Mô tả trang nạp tiền',
  'activity.everyRecharge.awardSettings': 'Cài đặt phần thưởng',
  'activity.everyRecharge.globalDescription': 'Mô tả thưởng nạp tiền',

  // Mẫu thưởng nạp lần đầu
  'activity.firstDeposit.configTitle': 'Cấu hình thưởng nạp tiền',
  'activity.firstDeposit.minRechargeAmount': 'Nạp lần đầu ≥',
  'activity.firstDeposit.maxRechargeAmount': 'Nạp lần đầu ≤',
  'activity.firstDeposit.awardType': 'Loại thưởng',
  'activity.firstDeposit.amount': 'Số lượng',
  'activity.firstDeposit.turnover': 'Doanh thu',
  'activity.firstDeposit.addNew': '+ Thêm',
  'activity.firstDeposit.delete': 'Xóa',
  'activity.firstDeposit.cash': 'Tiền mặt',
  'activity.firstDeposit.point': 'Điểm',
  'activity.firstDeposit.ticket': 'Vé tham gia',
  'activity.firstDeposit.pleaseSelect': 'Vui lòng chọn',
  'activity.firstDeposit.selectAwardType': 'Vui lòng chọn loại thưởng',
  'activity.firstDeposit.selectTicket': 'Vui lòng chọn vé tham gia',
  'activity.firstDeposit.enterMinRechargeAmount': 'Vui lòng nhập số tiền nạp tối thiểu',
  'activity.firstDeposit.enterMaxRechargeAmount': 'Vui lòng nhập số tiền nạp tối đa',
  'activity.firstDeposit.enterAmount': 'Vui lòng nhập',
  'activity.firstDeposit.enterTurnover': 'Vui lòng nhập',
  'activity.firstDeposit.amountMustBePositive': 'Số tiền phải lớn hơn 0',
  'activity.firstDeposit.amountMustBeInteger': 'Số tiền phải là số nguyên',
  'activity.firstDeposit.turnoverMustBePositive': 'Hệ số doanh thu phải >= 0',
  'activity.firstDeposit.minMustLessThanMax': 'Tối thiểu phải nhỏ hơn tối đa',
  'activity.firstDeposit.maxMustGreaterThanMin': 'Tối đa phải lớn hơn tối thiểu',
  'activity.firstDeposit.awardSettings': 'Cài đặt giải thưởng',
  'activity.firstDeposit.rechargePageDescription': 'Mô tả trang nạp tiền',
  'activity.firstDeposit.enterDescription': 'Vui lòng nhập mô tả',
  'activity.firstDeposit.distributeMode': 'Phương thức phát thưởng',
  'activity.firstDeposit.distributeModeDirect': 'Phát trực tiếp vào tài khoản người dùng',
  'activity.firstDeposit.distributeModeDirectDesc': 'Sau lần nạp đầu tiên, tiền mặt vào tài khoản chính, điểm vào tài khoản điểm, lượt quay tự động phát',
  'activity.firstDeposit.distributeModeCoupon': 'Phát đến Trung tâm ưu đãi để nhận',
  'activity.firstDeposit.distributeModeCouponDesc': 'Sau lần nạp đầu tiên, phần thưởng xuất hiện trong Trung tâm ưu đãi, người dùng cần tự nhận',

  // Mẫu mời bạn bè
  'activity.invite.inviteRulesAndRewards': 'Quy tắc mời & Cài đặt phần thưởng',
  'activity.invite.inviteRulesLogic': 'Logic: Mỗi khi có "bạn bè hợp lệ", người mời có thể nhận thưởng mời qua To Claim trên ứng dụng; Nếu bật "Thưởng đồng thời cho người được mời", người được mời sẽ tự động nhận thưởng khi trở thành người dùng hợp lệ (mặc định vào tài khoản chính).',
  'activity.invite.inviteRulesDetail': 'Tiền mặt: số lượng + hệ số doanh thu (doanh thu cần = số tiền nhận × hệ số); Điểm: chỉ số lượng; Vòng quay: loại + số lượng (cho phép nhiều mục).',
  'activity.invite.taskNameMultiLang': 'Tên nhiệm vụ mời (Đa ngôn ngữ)',
  'activity.invite.taskNameDescription': 'Hiển thị theo ngôn ngữ đã chọn trong thông tin cơ bản:',
  'activity.invite.enterTaskName': 'Vui lòng nhập tên nhiệm vụ mời',
  'activity.invite.inviterReward': 'Phần thưởng người mời (To Claim thủ công)',
  'activity.invite.inviterRewardDescription': 'Tiền mặt: số lượng + hệ số doanh thu (doanh thu cần = số tiền nhận × hệ số); Điểm: chỉ số lượng; Vòng quay: loại + số lượng (cho phép nhiều mục).',
  'activity.invite.inviteeReward': 'Thưởng đồng thời cho người được mời (Tự động gửi)',
  'activity.invite.inviteeRewardDescription': 'Khi bật: Mỗi bạn bè hợp lệ kích hoạt, người mời tạo nhiệm vụ To Claim; người được mời tự động nhận phần thưởng được cấu hình trong cột này (mặc định vào tài khoản chính).',
  'activity.invite.amount': 'Số lượng',
  'activity.invite.turnoverMultiple': 'Hệ số doanh thu',
  'activity.invite.pointsNoTurnover': 'Điểm không yêu cầu doanh thu',
  'activity.invite.selectTicket': 'Vui lòng chọn vé',
  'activity.invite.addTicketReward': 'Thêm phần thưởng vòng quay',
  'activity.invite.achievementReward': 'Phần thưởng thành tựu (Người mời)',
  'activity.invite.achievementRulesLine1': 'Quy tắc: Phần thưởng thành tựu không còn chia theo tiền tệ; tiền tệ dựa trên thông tin cơ bản (PHP).',
  'activity.invite.achievementRulesLine2': '"Tên phần thưởng" thành tựu hỗ trợ đa ngôn ngữ: theo cài đặt ngôn ngữ thông tin cơ bản.',
  'activity.invite.achievementLevel': 'Ngưỡng',
  'activity.invite.rewardIcon': 'Biểu tượng phần thưởng',
  'activity.invite.threshold': 'Ngưỡng (Bạn bè hợp lệ ≥)',
  'activity.invite.enterThreshold': 'Vui lòng nhập ngưỡng',
  'activity.invite.rewardNameMultiLang': 'Tên phần thưởng (Đa ngôn ngữ)',
  'activity.invite.enterRewardName': 'Vui lòng nhập tên phần thưởng thành tựu',
  'activity.invite.enableCash': 'Bật',
  'activity.invite.enablePoint': 'Bật',
  'activity.invite.enableTicket': 'Bật',
  'activity.invite.addAchievementLevel': 'Thêm ngưỡng thành tựu',
  'activity.invite.cashTurnoverNote': 'Tiền mặt yêu cầu doanh thu = số tiền × hệ số doanh thu; điểm/vòng quay chỉ yêu cầu số lượng.',

  'activity.invite.rewardModeFixed': 'Thưởng cố định theo thành viên hợp lệ',
  'activity.invite.rewardModeFirstDeposit': 'Thưởng theo khoảng tiền nạp lần đầu',
  'activity.invite.rewardModeHint': 'Chỉ một chế độ có hiệu lực cùng lúc. Chuyển đổi chỉ áp dụng cho thành viên được mời sau đó; thành viên đã mời giữ nguyên chế độ và cấu hình cũ.',
  'activity.invite.inviterRewardLevel1': 'Bạn cấp 1 (người mời trực tiếp)',
  'activity.invite.inviterRewardLevel2': 'Bạn cấp 2',
  'activity.invite.inviterRewardLevel3': 'Bạn cấp 3',
  'activity.invite.level1': 'Cấp 1',
  'activity.invite.level2': 'Cấp 2',
  'activity.invite.level3': 'Cấp 3',
  'activity.invite.levelN': 'Cấp {n}',
  'activity.invite.firstDepositIntervalTitle': 'Thưởng theo khoảng tiền nạp lần đầu',
  'activity.invite.firstDepositRange': 'Khoảng tiền nạp lần đầu ({{coin}})',
  'activity.invite.andAbove': 'trở lên',
  'activity.invite.addFirstDepositInterval': 'Thêm khoảng',
  'activity.invite.firstDepositIntervalHint': 'Thưởng dựa trên số tiền nạp lần đầu của bạn khớp với khoảng; các khoảng không được chồng lấn hoặc bỏ trống, khoảng cao nhất không có giới hạn trên. Tiền mặt = số tiền nạp lần đầu x tỷ lệ của cấp đó trong khoảng khớp, giới hạn theo "Mức trần chi trả tối đa mỗi người" theo từng cấp.',
  'activity.invite.firstDepositCashReward': 'Thưởng tiền mặt (Tiền nạp lần đầu x Tỷ lệ)',
  'activity.invite.firstDepositCap': 'Mức trần chi trả tối đa mỗi người',
  'activity.invite.firstDepositCapHint': 'Giới hạn theo cấp, dùng chung cho toàn bộ các khoảng; số tiền trả = min(tiền nạp lần đầu x tỷ lệ, mức trần cấp đó). Để 0 nghĩa là cấp đó không giới hạn.',

  'activity.invite.rebateSetting': 'Cài đặt hoàn tiền',
  'activity.invite.rebateSettingHint': 'Hoàn tiền chỉ có hiệu lực khi hoạt động được bật, trong thời gian hiệu lực và công tắc này mở; nếu một trong số đó không thỏa thì dừng tính hoàn tiền mới (đã phát không bị ảnh hưởng).',
  'activity.invite.rebateEnabled': 'Công tắc hoàn tiền',
  'activity.invite.rebateLevel': 'Cấp hoàn tiền',
  'activity.invite.autoIssueThreshold': 'Phương thức phát',
  'activity.invite.autoIssueThresholdPrefix': 'Tự động vào tài khoản chính; số tiền mặt mỗi lần ≥',
  'activity.invite.autoIssueThresholdSuffix': '{{coin}} sẽ tạm giữ chờ phát, xác nhận/từ chối trong hộp thoại chi tiết bản ghi hoàn tiền',
  'activity.invite.rebateMethodDeposit': 'Hoàn tiền nạp',
  'activity.invite.rebateMethodBet': 'Hoàn tiền cược',
  'activity.invite.rebateMethodWinLoss': 'Hoàn tiền thắng/thua',
  'activity.invite.rebateMethodHint': 'Chọn một trong bốn phương thức hoàn tiền; chỉ một có hiệu lực cùng lúc. Sau khi chuyển, toàn bộ thành viên áp dụng phương thức mới từ kỳ kế tiếp.',
  'activity.invite.rebateMethodNgr': 'Hoàn tiền NGR',
  'activity.invite.ngrRuleHint': 'Kết toán nửa tháng (1–15 / 16–cuối tháng, chi trả ngày sau kỳ). NGR cá nhân = GGR bản thân − ưu đãi đã nhận (gồm hoa hồng, trừ toàn bộ) − đổi điểm thành tiền; hoa hồng kỳ = Σ NGR bạn bè từng cấp × tỷ lệ cấp (có thể âm, bù trừ); phải trả = hoa hồng kỳ + kết chuyển kỳ trước; âm thì không trả, kết chuyển kỳ sau, không trừ số dư. Thay đổi tỷ lệ/bội số/ngưỡng có hiệu lực từ lần kết toán kế tiếp.',
  'activity.invite.ngrLevelRatio': 'Tỷ lệ cấp {{n}}',
  'activity.invite.ngrCashTurnoverMultiple': 'Bội số doanh thu tiền mặt (0 = rút ngay)',
  'activity.invite.ngrAutoIssueThreshold': 'Ngưỡng xét duyệt',
  'activity.invite.ngrAutoIssueThresholdSuffix': '{{coin}} tạm giữ chờ phát (duyệt thủ công); dưới ngưỡng phát tự động',
  'activity.invite.depositThreshold': 'Ngưỡng (tổng tiền nạp cấp 1 hôm qua ≥ {{coin}})',
  'activity.invite.betThreshold': 'Ngưỡng (tổng cược hợp lệ cấp 1 hôm qua ≥ {{coin}})',
  'activity.invite.winLossThreshold': 'Ngưỡng (tổng thắng/thua thuần cấp 1 tháng này ≥ {{coin}})',
  'activity.invite.betVenueScope': 'Phạm vi sảnh tính hoàn tiền',
  'activity.invite.rebateTierIndex': 'Bậc',
  'activity.invite.addRebateTier': 'Thêm bậc',
  'activity.invite.rebateTierHint': 'Xếp bậc dựa trên tổng cơ số của bạn cấp 1 đạt ngưỡng cao nhất; dưới ngưỡng thấp nhất thì không có hoàn tiền kỳ này.',
  'activity.invite.rebateFootnote': 'Cơ số tính theo toàn bộ bạn từ cấp 1-3 (không yêu cầu hợp lệ); từ cấp 4 trở đi không tính vào bất kỳ cơ số thưởng hoặc hoàn tiền nào.',
  'activity.invite.dailyRebateCap': 'Mức trần hoàn tiền theo ngày (theo cấp)',
  'activity.invite.monthlyRebateCap': 'Mức trần hoàn tiền theo tháng (theo cấp)',
  'activity.invite.rebateCapHint': 'Tiền mặt mỗi cấp = min(cơ số cấp đó x tỷ lệ cấp đó, mức trần cấp đó), vượt mức trần sẽ chỉ trả theo mức trần; chỉ áp dụng cho tiền mặt, điểm/vé tham gia/vòng quay không bị ảnh hưởng. Để 0 nghĩa là cấp đó không giới hạn.',

  'activity.chickActivity.userQuery.title': 'Truy vấn trạng thái người dùng',
  'activity.chickActivity.userQuery.userQuery': 'Truy vấn người dùng',
  'activity.chickActivity.userQuery.userQueryPlaceholder': 'UID / Số điện thoại',
  'activity.chickActivity.userQuery.search': 'Tìm kiếm',
  'activity.chickActivity.userQuery.reset': 'Đặt lại',
  'activity.chickActivity.userQuery.enterUserQuery': 'Vui lòng nhập UID người dùng hoặc số điện thoại',
  'activity.chickActivity.userQuery.userNotFound': 'Không tìm thấy người dùng',
  'activity.chickActivity.userQuery.searchUserFailed': 'Tìm kiếm người dùng thất bại, vui lòng thử lại sau',
  'activity.chickActivity.userQuery.queryUserStateFailed': 'Truy vấn trạng thái người dùng thất bại',
  'activity.chickActivity.userQuery.queryUserStateFailedRetry': 'Truy vấn trạng thái người dùng thất bại, vui lòng thử lại sau',
  'activity.chickActivity.userQuery.queryRewardRecordsFailed': 'Truy vấn bản ghi phần thưởng thất bại',
  'activity.chickActivity.userQuery.queryRewardRecordsFailedRetry': 'Truy vấn bản ghi phần thưởng thất bại, vui lòng thử lại sau',
  'activity.chickActivity.userQuery.stateOverview': 'Tổng quan trạng thái hoạt động',
  'activity.chickActivity.userQuery.chickState': 'Trạng thái ấp trứng',
  'activity.chickActivity.userQuery.energy': 'Năng lượng',
  'activity.chickActivity.userQuery.todayBetCount': 'Số lần đặt cược hợp lệ hôm nay',
  'activity.chickActivity.userQuery.currentPool': 'Giải thưởng hiện tại (nếu có)',
  'activity.chickActivity.userQuery.currency': 'Tiền tệ:',
  'activity.chickActivity.userQuery.poolTotal': 'pool_total:',
  'activity.chickActivity.userQuery.poolRemaining': 'pool_remaining:',
  'activity.chickActivity.userQuery.chestPending': 'Rương chờ nhận (theo tiền tệ)',
  'activity.chickActivity.userQuery.item': 'Mục',
  'activity.chickActivity.userQuery.value': 'Giá trị',
  'activity.chickActivity.userQuery.stateEnumReference': 'Tham chiếu enum trạng thái: EGG_INCUBATING / EGG_READY / HATCHED_NO_ENERGY / WORKING / HUNGRY / SICK',
  'activity.chickActivity.userQuery.rewardRecords': 'Bản ghi phần thưởng và đăng nhập',
  'activity.chickActivity.userQuery.date': 'Ngày',
  'activity.chickActivity.userQuery.time': 'Thời gian',
  'activity.chickActivity.userQuery.type': 'Loại',
  'activity.chickActivity.userQuery.reward': 'Phần thưởng',
  'activity.chickActivity.userQuery.status': 'Trạng thái',
  'activity.chickActivity.userQuery.noData': 'Không có dữ liệu',
  'activity.chickActivity.userQuery.rewardType.depositCheckin': 'Đăng nhập gửi tiền',
  'activity.chickActivity.userQuery.rewardType.freeCheckin': 'Đăng nhập miễn phí',
  'activity.chickActivity.userQuery.rewardType.workReward': 'Phần thưởng làm việc',
  'activity.chickActivity.userQuery.rewardType.energyCheckin': 'Đăng ký Năng lượng',
  'activity.chickActivity.userQuery.rewardType.dailyBetMilestone': 'Mốc cược - Trong ngày',
  'activity.chickActivity.userQuery.rewardType.weeklyBetMilestone': 'Mốc cược - Trong tuần',
  'activity.chickActivity.userQuery.rewardType.unknown': 'Loại',
  'activity.chickActivity.userQuery.awardStatus.pending': 'Chờ nhận',
  'activity.chickActivity.userQuery.awardStatus.claimed': 'Đã nhận',
  'activity.chickActivity.userQuery.awardStatus.expired': 'Đã hết hạn',
  'activity.chickActivity.userQuery.awardStatus.unknown': 'Không xác định',
  'activity.chickActivity.userQuery.chickState.eggIncubating': 'Đang ấp',
  'activity.chickActivity.userQuery.chickState.eggReady': 'Sẵn sàng nở',
  'activity.chickActivity.userQuery.chickState.hatchedNoEnergy': 'Đã nở không có năng lượng',
  'activity.chickActivity.userQuery.chickState.working': 'Đang làm việc',
  'activity.chickActivity.userQuery.chickState.hungry': 'Đói',
  'activity.chickActivity.userQuery.chickState.sick': 'Ốm',
  'activity.chickActivity.userQuery.chickState.idle': 'Nhàn rỗi',
  'activity.chickActivity.userQuery.chickState.hatching': 'Đang ấp',
  'activity.chickActivity.userQuery.chickState.almostHatched': 'Sắp nở',
  'activity.chickActivity.userQuery.chickState.full': 'Đầy năng lượng',
  'activity.chickActivity.userQuery.chickState.tired': 'Mệt mỏi',
  'activity.chickActivity.userQuery.chickState.exhausted': 'Kiệt sức',
  'activity.chickActivity.userQuery.times': 'lần',
  'activity.chickActivity.userQuery.points': 'điểm',

  'activity.chickActivity.report.title': 'Báo cáo dữ liệu (Tổng hợp)',
  'activity.chickActivity.report.dateRange': 'Phạm vi ngày',
  'activity.chickActivity.report.selectDateRange': 'Vui lòng chọn phạm vi ngày',
  'activity.chickActivity.report.search': 'Tìm kiếm',
  'activity.chickActivity.report.reset': 'Đặt lại',
  'activity.chickActivity.report.queryDataFailed': 'Truy vấn dữ liệu thất bại',
  'activity.chickActivity.report.queryDataFailedRetry': 'Truy vấn báo cáo dữ liệu thất bại, vui lòng thử lại sau',
  'activity.chickActivity.report.statsDescription': 'Mô tả thống kê (Yêu cầu đóng băng)',
  'activity.chickActivity.report.participantCountDesc': 'Số người tham gia: Số lượng người dùng không trùng lặp vào trang hoạt động và nhấp vào nhiệm vụ ấp trứng hoặc nhận phần thưởng trong ngày (không theo cookie).',
  'activity.chickActivity.report.depositUserCountDesc': 'Số người dùng gửi tiền hoạt động: Số lượng người dùng không trùng lặp tham gia hoạt động và có ít nhất một lần gửi tiền trong ngày.',
  'activity.chickActivity.report.treasureBoxIssuedDesc': 'Rương đã phát: Số tiền phần thưởng tiền mặt được ghi vào rương trong ngày, thống kê theo tiền tệ (PHP / USDT / VND).',
  'activity.chickActivity.report.treasureBoxClaimedDesc': 'Rương đã nhận: Số tiền phần thưởng tiền mặt được nhận thành công từ rương trong ngày, thống kê theo tiền tệ.',
  'activity.chickActivity.report.treasureBoxExpiredDesc': 'Rương đã hết hạn: Số tiền phần thưởng tiền mặt hết hạn và chưa nhận trong ngày, thống kê theo tiền tệ (quy tắc 24h, thuộc về thời gian đạt được).',
  'activity.chickActivity.report.amountPrecision': 'Độ chính xác số tiền',
  'activity.chickActivity.report.amountPrecisionDesc': 'Độ chính xác số tiền: Tiền mặt thống nhất giữ lại 2 chữ số thập phân, chữ số thập phân thứ 3 bị cắt trực tiếp. Điểm bị cắt sau dấu thập phân.',
  'activity.chickActivity.report.date': 'Ngày',
  'activity.chickActivity.report.participantCount': 'Số người tham gia',
  'activity.chickActivity.report.depositUserCount': 'Số người dùng gửi tiền hoạt động',
  'activity.chickActivity.report.depositCheckinClaimCount': 'Số người nhận đăng nhập gửi tiền',
  'activity.chickActivity.report.depositCheckinPointsIssued': 'Điểm đăng nhập gửi tiền đã phát',
  'activity.chickActivity.report.freeCheckinClaimCount': 'Số người nhận đăng nhập miễn phí',
  'activity.chickActivity.report.freeCheckinPointsIssued': 'Điểm đăng nhập miễn phí đã phát',
  'activity.chickActivity.report.energyCheckinClaimCount': 'Số người nhận năng lượng',
  'activity.chickActivity.report.energyCheckinPointsIssued': 'Điểm năng lượng đã phát',
  'activity.chickActivity.report.treasureBoxIssued': 'Rương đã phát',
  'activity.chickActivity.report.treasureBoxClaimed': 'Rương đã nhận',
  'activity.chickActivity.report.treasureBoxClaimedCount': 'Số người nhận rương',
  'activity.chickActivity.report.treasureBoxExpired': 'Rương đã hết hạn',
  'activity.chickActivity.report.dailyMilestoneIssued': 'Mốc phát (Trong ngày)',
  'activity.chickActivity.report.dailyMilestoneClaimed': 'Mốc nhận (Trong ngày)',
  'activity.chickActivity.report.dailyMilestoneExpired': 'Mốc hết hạn (Trong ngày)',
  'activity.chickActivity.report.weeklyMilestoneIssued': 'Mốc phát (Trong tuần)',
  'activity.chickActivity.report.weeklyMilestoneClaimed': 'Mốc nhận (Trong tuần)',
  'activity.chickActivity.report.weeklyMilestoneExpired': 'Mốc hết hạn (Trong tuần)',

  // Mẫu hoàn trả cược mới
  'activity.newRebate.title': 'Cài đặt hoàn trả cược mới',
  'activity.newRebate.firstDepositRebate': 'Hoàn trả nạp tiền đầu',
  'activity.newRebate.vipRebate': 'Hoàn trả cược VIP',
  'activity.newRebate.tieredRebate': 'Hoàn trả cược theo bậc',
  'activity.newRebate.firstDepositAmount': 'Số tiền nạp đầu ≥',
  'activity.newRebate.enterFirstDepositAmount': 'Vui lòng nhập số tiền nạp đầu',
  'activity.newRebate.validDays': 'Số ngày hiệu lực',
  'activity.newRebate.enterValidDays': 'Vui lòng nhập số ngày hiệu lực',
  'activity.newRebate.rebateType': 'Loại hoàn trả',
  'activity.newRebate.selectRebateType': 'Vui lòng chọn loại hoàn trả',
  'activity.newRebate.cash': 'Tiền mặt',
  'activity.newRebate.point': 'Điểm',
  'activity.newRebate.rebatePercent': 'Tỷ lệ hoàn trả',
  'activity.newRebate.enterRebatePercent': 'Vui lòng nhập tỷ lệ hoàn trả',
  'activity.newRebate.truncateNotice': 'Tỷ lệ hoàn trả hỗ trợ tối đa 2 chữ số thập phân. Số tiền hoàn trả giữ 2 chữ số thập phân, phần vượt quá sẽ bị cắt bỏ (không làm tròn); phần thưởng dưới 0.01 sẽ bị loại bỏ và không phát. Áp dụng cho hoàn trả tiền mặt của Nạp đầu / VIP / Bậc thang; hoàn trả điểm không bị ảnh hưởng.',
  'activity.newRebate.maxRebateCash': 'Hoàn trả tiền mặt tối đa hàng ngày',
  'activity.newRebate.maxRebatePoint': 'Hoàn trả điểm tối đa',
  'activity.newRebate.enterMaxRebate': 'Vui lòng nhập số tiền hoàn trả tối đa',
  'activity.newRebate.turnover': 'Hệ số doanh thu',
  'activity.newRebate.enterTurnover': 'Vui lòng nhập doanh thu',
  'activity.newRebate.vipLevel': 'Cấp VIP',
  'activity.newRebate.selectVipLevel': 'Vui lòng chọn cấp VIP',
  'activity.newRebate.bettingTurnover': 'Doanh thu cược ≥',
  'activity.newRebate.enterBettingTurnover': 'Vui lòng nhập doanh thu cược',
  'activity.newRebate.vipLevelMin': 'Cấp tối thiểu',
  'activity.newRebate.vipLevelMax': 'Cấp tối đa',
  'activity.newRebate.addRule': 'Thêm',
  'activity.newRebate.deleteRule': 'Xóa',
  'activity.newRebate.gamePlatform': 'Nền tảng trò chơi',
  'activity.newRebate.ruleIndex': 'Quy tắc {{index}}',
  'activity.newRebate.tierIndex': 'Bậc {{index}}',
  'activity.newRebate.atLeastOneRule': 'Cần ít nhất một cấu hình (tiền mặt hoặc điểm)',
  'activity.newRebate.maxRuleLimit': 'Chỉ được phép một cấu hình tiền mặt và một cấu hình điểm',
  'activity.newRebate.vipLevelConflict': 'Cấp VIP này đã được sử dụng bởi cấu hình khác',
  'activity.newRebate.duplicateTurnoverType': 'Cấu hình cùng loại hoàn trả đã tồn tại cho mức doanh thu này',
  'activity.newRebate.atLeastOneGameType': 'Phải chọn ít nhất một loại trò chơi',
  'activity.newRebate.gameType.1': 'Trò chơi điện tử',
  'activity.newRebate.gameType.2': 'Casino trực tuyến',
  'activity.newRebate.gameType.3': 'Thể thao',
  'activity.newRebate.gameType.4': 'Xổ số',
  'activity.newRebate.gameType.5': 'Bắn cá',
  'activity.newRebate.gameType.6': 'Cờ bài',
  'activity.newRebate.gameType.7': 'Thể thao điện tử',
  'activity.newRebate.gameType.8': 'Mini Game',
  'activity.newRebate.gameType.9': 'Dự đoán',
  'activity.newRebate.gameType.10': 'Thể thao điện tử',
  'activity.newRebate.gameType.11': 'Arcade',
  'activity.newRebate.gameType.12': 'Bingo',
  'activity.newRebate.distributeMode': 'Phương thức phát thưởng',
  'activity.newRebate.distributeModeDirect': 'Phát trực tiếp vào tài khoản người dùng',
  'activity.newRebate.distributeModeDirectDesc': 'Khi quyết toán hoàn trả, tiền mặt vào tài khoản chính, điểm vào tài khoản điểm, tự động ghi nhận',
  'activity.newRebate.distributeModeCoupon': 'Phát đến Trung tâm ưu đãi chờ nhận',
  'activity.newRebate.distributeModeCouponDesc': 'Khi quyết toán hoàn trả, phần thưởng xuất hiện ở Trung tâm ưu đãi, người dùng nhận thủ công sẽ vào tài khoản',

  'activity.newRebate.gameGroupRebate': 'Hoàn trả nhóm trò chơi',
  'activity.newRebate.gameGroup.create': '+ Tạo nhóm mới',
  'activity.newRebate.gameGroup.createTitle': 'Tạo nhóm trò chơi',
  'activity.newRebate.gameGroup.syncIcons': 'Đồng bộ biểu tượng',
  'activity.newRebate.gameGroup.syncIconsTooltip': 'Lấy langGame.h5Img ở ngôn ngữ mặc định từ thư viện dispset và ghi đè vào iconUrl của mọi trò chơi có thể chọn. games[].iconUrl của API daily-stats lấy từ cột này.',
  'activity.newRebate.gameGroup.syncIconsConfirmTitle': 'Xác nhận đồng bộ biểu tượng cho tất cả trò chơi?',
  'activity.newRebate.gameGroup.syncIconsConfirmContent': 'Sẽ lấy h5Img ở ngôn ngữ mặc định theo lô; chỉ ghi nếu biểu tượng khác giá trị cũ. Thường hoàn tất dưới 5 giây.',
  'activity.newRebate.gameGroup.syncIconsRunning': 'Đang đồng bộ…',
  'activity.newRebate.gameGroup.syncIconsResultTitle': 'Hoàn tất đồng bộ',
  'activity.newRebate.gameGroup.syncIconsSummary': 'Tổng {{total}} / Khớp {{matched}} / Cập nhật {{updated}} / Bỏ qua {{skipped}}',
  'activity.newRebate.gameGroup.syncIconsSkippedTitle': 'Mục bị bỏ qua (vui lòng để Ops bổ sung h5Img ngôn ngữ mặc định ở thư viện trò chơi)',
  'activity.newRebate.gameGroup.syncIconsSkippedColPlatform': 'Nền tảng',
  'activity.newRebate.gameGroup.syncIconsSkippedColGameCode': 'Mã trò chơi',
  'activity.newRebate.gameGroup.syncIconsSkippedColReason': 'Lý do',
  'activity.newRebate.gameGroup.syncIconsFailed': 'Đồng bộ thất bại, vui lòng kiểm tra mạng hoặc log backend',
  'activity.newRebate.gameGroup.iconNotSynced': 'Chưa đồng bộ biểu tượng. Bấm "Đồng bộ biểu tượng" để bổ sung hàng loạt.',
  'activity.newRebate.gameGroup.iconLoadFailed': 'URL biểu tượng đã đồng bộ nhưng không tải được (có thể 404 hoặc sai đường dẫn). Vui lòng nhờ Ops kiểm tra h5Img ở thư viện trò chơi.',
  'activity.newRebate.gameGroup.editTitle': 'Chỉnh sửa nhóm',
  'activity.newRebate.gameGroup.basicInfo': 'Thông tin cơ bản',
  'activity.newRebate.gameGroup.gamesInGroup': 'Trò chơi trong nhóm',
  'activity.newRebate.gameGroup.gamesInGroupHint': 'Một trò chơi chỉ thuộc về một nhóm tại một thời điểm; trò chơi đã được chọn sẽ bị mờ.',
  'activity.newRebate.gameGroup.name': 'Tên nhóm',
  'activity.newRebate.gameGroup.namePlaceholder': 'VD: Nổi bật · PG',
  'activity.newRebate.gameGroup.coverImg': 'Ảnh bìa',
  'activity.newRebate.gameGroup.coverImgPlaceholder': 'Đề xuất 120×120 JPG/PNG, dán URL hình ảnh',
  'activity.newRebate.gameGroup.coverImgHint': 'Đề xuất 120×120 JPG/PNG/WEBP, mỗi ảnh tối đa 2MB',
  'activity.newRebate.gameGroup.startDate': 'Ngày bắt đầu',
  'activity.newRebate.gameGroup.endDate': 'Ngày kết thúc',
  'activity.newRebate.gameGroup.percent': 'Tỷ lệ hoàn',
  'activity.newRebate.gameGroup.percentPlaceholder': 'Nhập tỷ lệ hoàn',
  'activity.newRebate.gameGroup.maxRebate': 'Giới hạn ngày',
  'activity.newRebate.gameGroup.maxRebatePlaceholder': 'Nhập giới hạn ngày',
  'activity.newRebate.gameGroup.turnoverMultiplier': 'Vòng cược ×',
  'activity.newRebate.gameGroup.turnoverMultiplierPlaceholder': 'Nhập số vòng cược',
  'activity.newRebate.gameGroup.timeRange': 'Thời gian',
  'activity.newRebate.gameGroup.timeRangeHint': 'Tùy chọn; để trống = vĩnh viễn. Khi đặt: tự lên trang khi bắt đầu, tự gỡ khi kết thúc.',
  'activity.newRebate.gameGroup.sortNo': 'Thứ tự',
  'activity.newRebate.gameGroup.searchGame': 'Tìm tên trò chơi…',
  'activity.newRebate.gameGroup.expandAll': 'Mở rộng',
  'activity.newRebate.gameGroup.collapseAll': 'Thu gọn',
  'activity.newRebate.gameGroup.selectAllPlatform': 'Chọn tất cả',
  'activity.newRebate.gameGroup.gamesCount': '{{count}} trò',
  'activity.newRebate.gameGroup.selectedCount': 'Đã chọn {{count}} trò',
  'activity.newRebate.gameGroup.occupied': 'Đã dùng',
  'activity.newRebate.gameGroup.atLeastOneGame': 'Vui lòng chọn ít nhất một trò chơi',
  'activity.newRebate.gameGroup.emptySource': 'Chưa có trò chơi khả dụng. Vui lòng thêm trò chơi trong "Game Pool" trước.',
  'activity.newRebate.gameGroup.noMatchedGame': 'Không có trò chơi phù hợp',
  'activity.newRebate.gameGroup.emptyList': 'Chưa có nhóm nào',
  'activity.newRebate.gameGroup.listSubtitle': 'Vận hành tự tạo nhóm; vòng cược của trò chơi trong nhóm chỉ tính cho nhóm này, không tính vào hoàn trả bậc thang.',
  'activity.newRebate.gameGroup.tipDeduct': 'Quy tắc cốt lõi: Cược trong nhóm chỉ tính cho nhóm đó, KHÔNG tính vào bậc thang theo loại trò chơi (Slot/Live/Sport/Fish).',
  'activity.newRebate.gameGroup.tipUnique': 'Một trò chỉ thuộc một nhóm tại một thời điểm. Trò chơi đã thuộc nhóm khác sẽ hiển thị "Đã dùng" và bị mờ.',
  'activity.newRebate.gameGroup.tipDeductTitle': 'Quy tắc cốt lõi (gán cược)',
  'activity.newRebate.gameGroup.tipDeductDesc': 'Cược trong nhóm chỉ tính cho nhóm đó, KHÔNG tính vào bậc thang theo loại trò chơi (Slot/Live/Sport/Fish).',
  'activity.newRebate.gameGroup.tipUniqueTitle': 'Quyền sở hữu duy nhất',
  'activity.newRebate.gameGroup.tipUniqueDesc': 'Một trò chỉ thuộc một nhóm tại một thời điểm. Trò chơi đã thuộc nhóm khác sẽ hiển thị "Đã dùng" và bị mờ.',
  'activity.newRebate.gameGroup.noCover': 'Không ảnh bìa',
  'activity.newRebate.gameGroup.longTerm': 'Vĩnh viễn',
  'activity.newRebate.gameGroup.status': 'Trạng thái',
  'activity.newRebate.gameGroup.statusOf.online': 'Đang hoạt động',
  'activity.newRebate.gameGroup.statusOf.upcoming': 'Sắp tới',
  'activity.newRebate.gameGroup.statusOf.offline': 'Đã gỡ',
  'activity.newRebate.gameGroup.statusOf.manualOff': 'Gỡ thủ công',
  'activity.newRebate.gameGroup.operation': 'Thao tác',
  'activity.newRebate.gameGroup.edit': 'Sửa',
  'activity.newRebate.gameGroup.delete': 'Xóa',
  'activity.newRebate.gameGroup.unpublish': 'Gỡ',
  'activity.newRebate.gameGroup.publish': 'Đăng',
  'activity.newRebate.gameGroup.deleteConfirm': 'Xóa nhóm này?',
  'activity.newRebate.gameGroup.deleteSuccess': 'Đã xóa',
  'activity.newRebate.gameGroup.confirmOk': 'Xác nhận',
  'activity.newRebate.gameGroup.cancel': 'Hủy',
  'activity.newRebate.gameGroup.save': 'Lưu',

  // Thông tin ràng buộc ưu đãi mẫu dịch
  'activity.infoBinding.conditionSettings': 'Cài đặt điều kiện',
  'activity.infoBinding.serialNumber': 'Số thứ tự',
  'activity.infoBinding.enterSerialNumber': 'Vui lòng nhập số thứ tự',
  'activity.infoBinding.serialNumberMustBePositive': 'Số thứ tự phải lớn hơn 0',
  'activity.infoBinding.authInfoType': 'Khi thông tin xác thực =',
  'activity.infoBinding.selectAuthInfoType': 'Vui lòng chọn thông tin xác thực',
  'activity.infoBinding.authInfo.mobileTask': 'Nhiệm vụ và phần thưởng xác thực điện thoại',
  'activity.infoBinding.authInfo.emailTask': 'Nhiệm vụ và phần thưởng xác thực email',
  'activity.infoBinding.authInfo.withdrawPasswordTask': 'Nhiệm vụ và phần thưởng mật khẩu rút tiền',
  'activity.infoBinding.authInfo.kycTask': 'Nhiệm vụ và phần thưởng KYC',
  'activity.infoBinding.authInfo.downloadAppTask': 'Nhiệm vụ và phần thưởng tải ứng dụng',
  'activity.infoBinding.authInfo.appLoginMobileVerifiedTask': 'Đăng nhập APP thành công và xác thực điện thoại thành công',
  'activity.infoBinding.excludeMember.title': 'Danh sách thành viên không phát thưởng',
  'activity.infoBinding.excludeMember.manage': 'Quản lý danh sách loại trừ',
  'activity.infoBinding.excludeMember.memberAccount': 'Tài khoản thành viên',
  'activity.infoBinding.excludeMember.createUserName': 'Người thao tác',
  'activity.infoBinding.excludeMember.createTime': 'Thời gian tạo',
  'activity.infoBinding.excludeMember.searchPlaceholder': 'Tìm kiếm theo tài khoản',
  'activity.infoBinding.excludeMember.upload': 'Tải lên CSV',
  'activity.infoBinding.excludeMember.uploadTitle': 'Nhập hàng loạt tài khoản loại trừ',
  'activity.infoBinding.excludeMember.downloadTemplate': 'Tải xuống mẫu',
  'activity.infoBinding.excludeMember.uploadHint': 'Định dạng CSV: hàng đầu tiên là tiêu đề (memberAccount), các hàng tiếp theo là tài khoản',
  'activity.infoBinding.excludeMember.deleteSuccess': 'Xóa thành công',
  'activity.infoBinding.excludeMember.uploadSuccess': 'Tải lên thành công',
  'activity.infoBinding.excludeMember.operation': 'Thao tác',
  'activity.infoBinding.excludeMember.deleteConfirm': 'Xác nhận xóa bản ghi này?',
  'activity.infoBinding.excludeMember.confirmOk': 'Xác nhận',
  'activity.infoBinding.excludeMember.delete': 'Xóa',
  'activity.infoBinding.excludeMember.search': 'Tìm kiếm',
  'activity.infoBinding.excludeMember.total': 'Tổng cộng',
  'activity.infoBinding.excludeMember.saveFirst': 'Vui lòng lưu hoạt động trước khi quản lý danh sách',
  'activity.infoBinding.rewardDistribution': 'Thì phân phát',
  'activity.infoBinding.rewardType': 'Loại phần thưởng',
  'activity.infoBinding.pointAmount': 'Số lượng điểm',
  'activity.infoBinding.enterPointAmount': 'Vui lòng nhập số lượng điểm',
  'activity.infoBinding.pointAmountMustBePositive': 'Số lượng điểm phải lớn hơn 0',
  'activity.infoBinding.addPointReward': 'Thêm phần thưởng điểm',
  'activity.infoBinding.cashAmount': 'Số tiền mặt',
  'activity.infoBinding.enterCashAmount': 'Vui lòng nhập số tiền mặt',
  'activity.infoBinding.cashAmountMustBeNonNegative': 'Số tiền mặt không thể âm',
  'activity.infoBinding.desireMultiple': 'Bội số doanh thu',
  'activity.infoBinding.enterDesireMultiple': 'Vui lòng nhập bội số doanh thu',
  'activity.infoBinding.cashRequiresMultiple': 'Bội số doanh thu là bắt buộc khi phần thưởng tiền mặt lớn hơn 0',
  'activity.infoBinding.addCashReward': 'Thêm phần thưởng tiền mặt',
  'activity.infoBinding.otherSettings': 'Cài đặt khác',
  'activity.infoBinding.riskControlConditions': 'Điều kiện kiểm soát rủi ro',
  'activity.infoBinding.selectRiskControlLevel': 'Chọn mức kiểm soát rủi ro',
  'activity.infoBinding.taskSwitch': 'Công tắc nhiệm vụ',
  'activity.infoBinding.selectAuthType': 'Chọn loại nhiệm vụ',
  'activity.infoBinding.selectAuthTypePlaceholder': 'Vui lòng chọn loại nhiệm vụ',
  'activity.infoBinding.selectAuthTypeFirst': 'Vui lòng chọn loại nhiệm vụ trước',

  // Hoạt động Chick
  'chickActivity.activityConfig': 'Cấu hình hoạt động',
  'chickActivity.dataReport': 'Báo cáo dữ liệu',
  'chickActivity.userQuery': 'Truy vấn trạng thái người dùng',

  // Trang Cấu hình Hoạt động
  'chickActivity.activityBasic': 'Cơ bản Hoạt động',
  'chickActivity.activityStatus': 'Trạng thái Hoạt động',
  'chickActivity.enabled': 'Bật',
  'chickActivity.disabled': 'Tắt',
  'chickActivity.enabledHint': 'Có hiệu lực cho tất cả người dùng sau khi bật',
  'chickActivity.activityTime': 'Thời gian Hoạt động',
  'chickActivity.userScope': 'Phạm vi Người dùng',
  'chickActivity.userScopeDesc': 'Tất cả người dùng (tạo trứng và tham gia khi đăng nhập trong thời gian hoạt động)',
  'chickActivity.readonly': 'Chỉ đọc',
  'chickActivity.autoHatchTime': 'Thời gian Tự động Nở',
  'chickActivity.autoHatchTimeDesc': '72 giờ (tự động nở khi hết thời gian, năng lượng=0)',
  'chickActivity.systemDefault': 'Mặc định Hệ thống',
  'chickActivity.systemRules': 'Quy tắc Hệ thống (Chỉ đọc)',
  'chickActivity.systemRule1': 'Tổng năng lượng là 7 ô; vào ngày nạp tiền, nó phục hồi đầy; nếu không nạp tiền hàng ngày, -1.',
  'chickActivity.systemRule2': 'Năng lượng 4-7 có thể kích hoạt hoàn tiền làm việc; nếu năng lượng là 0 (Sick), check-in miễn phí xuất hiện.',
  'chickActivity.systemRule3': 'Mỗi lần nạp tiền tạo pool hoàn tiền mới (pool_total tính lại), và phần thưởng làm việc tương ứng được tính lại.',
  'chickActivity.systemRule4': 'Phần thưởng rương kho báu có hiệu lực trong 24 giờ; nếu không nhận, chúng sẽ hết hạn.',
  'chickActivity.systemRule5': 'Tiêu chí nhập liên ngày: Nếu đạt được vào ngày hiện tại nhưng được ghi vào rương kho báu vào ngày hôm sau, nó vẫn thuộc về ngày đạt được; hiệu lực bắt đầu từ thời điểm đạt được trong 24 giờ.',
  'chickActivity.systemRule6': 'Độ chính xác số tiền: giữ 2 chữ số thập phân, chữ số thứ 3 được cắt trực tiếp (không làm tròn).',
  'chickActivity.globalRebateRatio': 'Tỷ lệ Hoàn trả Toàn cầu',
  'chickActivity.globalRebateRatioExample': 'Ví dụ: Nạp 1000P → pool_total = 8P',
  'chickActivity.workPoolRebateRatio': 'Tỷ lệ Hoàn trả Pool Làm việc (%)',
  'chickActivity.workPoolRebateRatioDesc': 'Mỗi lần Nạp × Tỷ lệ này = Pool mới pool_total',
  'chickActivity.poolMaxAmount': 'Số tiền Pool Tối đa',
  'chickActivity.poolMaxAmountDesc': 'Giới hạn pool mỗi lần nạp (giới hạn nếu vượt quá)',
  'chickActivity.workPoolRatio': 'Điều kiện Mở khóa Thưởng (Tỷ lệ Cược Tích lũy)',
  'chickActivity.workPoolRatioExample': 'Kích hoạt thưởng làm việc sau khi cược hợp lệ tích lũy ≥ Pool × X%',
  'chickActivity.rewardTurnoverMultiple': 'Bội số Doanh thu Thưởng Tiền mặt',
  'chickActivity.rewardTurnoverMultipleDesc': 'Yêu cầu doanh thu để rút thưởng tiền mặt (bội số)',

  // Nhiệm vụ Nở
  'chickActivity.hatchTasks': 'Nhiệm vụ Nở',
  'chickActivity.taskOnceOnly': 'Mỗi nhiệm vụ chỉ có thể hoàn thành một lần',
  'chickActivity.hatchTaskDesc': 'Tên nhiệm vụ hiển thị mục chỉnh sửa đa ngôn ngữ; phần thưởng là giờ để giảm thời gian nở.',
  'chickActivity.taskNameMultiLang': 'Tên Nhiệm vụ (Đa ngôn ngữ)',
  'chickActivity.taskName': 'Tên Nhiệm vụ',
  'chickActivity.enterTaskName': 'Nhập tên nhiệm vụ',
  'chickActivity.taskDesc': 'Mô tả Nhiệm vụ',
  'chickActivity.enterTaskDesc': 'Nhập mô tả nhiệm vụ',
  'chickActivity.editTaskName': 'Chỉnh sửa Tên Nhiệm vụ (Đa ngôn ngữ)',
  'chickActivity.rewardHours': 'Phần thưởng (Giảm Thời gian Nở)',
  'chickActivity.directHatch': 'Nở Trực tiếp (Quy tắc Hệ thống)',
  'chickActivity.hours': 'giờ',
  'chickActivity.completionCondition': 'Điều kiện Hoàn thành (Chỉ đọc)',
  // Điều kiện hoàn thành theo taskKey (dùng chung cho nhiệm vụ nở và nhiệm vụ năng lượng)
  'chickActivity.taskCondition.bind_phone': 'Hoàn thành liên kết số điện thoại một lần',
  'chickActivity.taskCondition.bind_email': 'Hoàn thành liên kết email một lần',
  'chickActivity.taskCondition.kyc_verify': 'Hoàn thành xác minh KYC một lần',
  'chickActivity.taskCondition.name_chick': 'Đặt tên cho gà con lần đầu',
  'chickActivity.taskCondition.app_login': 'Hoàn thành đăng nhập APP',
  'chickActivity.taskCondition.first_deposit': 'Hoàn thành lần nạp tiền đầu tiên',
  'chickActivity.taskCondition.invite_valid_friend': 'Mời bạn bè hợp lệ',

  // Nhiệm vụ Năng lượng
  'chickActivity.energyTasks': 'Nhiệm vụ Năng lượng',
  'chickActivity.energyTaskDesc': 'Cấu hình nhiệm vụ năng lượng, hỗ trợ nhiệm vụ một lần và hàng ngày. Phần thưởng là giá trị năng lượng.',
  'chickActivity.energyTaskType': 'Loại Nhiệm vụ',
  'chickActivity.energyTaskTypeOnce': 'Nhiệm vụ Một lần',
  'chickActivity.energyTaskTypeDaily': 'Nhiệm vụ Hàng ngày',
  'chickActivity.rewardEnergy': 'Năng lượng Thưởng',
  'chickActivity.energyUnit': 'Năng lượng',
  'chickActivity.rewardPoints': 'Điểm Thưởng',

  // Check-in Nạp tiền
  'chickActivity.depositCheckin': 'Check-in Nạp tiền (7 Ngày Năng lượng)',
  'chickActivity.currentCurrency': 'Tiền tệ Hiện tại',
  'chickActivity.addTier': 'Thêm Cấp',
  'chickActivity.addWorkTier': 'Thêm Cấp',
  'chickActivity.depositCheckinDesc': 'Tổng Phần thưởng = Số tiền Nạp × (Cấp "Tỷ lệ Phần thưởng Năng lượng 7 Ngày") → Chia theo đường cong D1-D7 (Tổng=100%).',
  'chickActivity.amountTruncate': 'Cắt số tiền: Giữ 2 chữ số thập phân, cắt trực tiếp chữ số thứ 3. Cấp cao nhất có thể cấu hình "Giới hạn Điểm" (chỉ cấp cao nhất có hiệu lực).',
  'chickActivity.depositRange': 'Phạm vi Nạp tiền',
  'chickActivity.rewardRatio': 'Tỷ lệ Phần thưởng Năng lượng 7 Ngày (%)',
  'chickActivity.pointCap': 'Giới hạn Điểm Tối đa (Chỉ Cấp Cao nhất)',
  'chickActivity.range': 'Phạm vi',
  'chickActivity.total': 'Tổng',
  'chickActivity.tierNote': 'Thêm/xóa cấp sẽ đồng bộ ảnh hưởng đến các hàng đường cong D1-D7; cấp và đường cong của các tiền tệ khác nhau độc lập.',

  // Check-in Miễn phí
  'chickActivity.freeCheckin': 'Check-in Miễn phí (Sick)',
  'chickActivity.freeCheckinDesc': 'Ảnh hưởng tắt: Mục check-in miễn phí sẽ không xuất hiện khi năng lượng=0; không ảnh hưởng đến check-in nạp tiền và phần thưởng làm việc.',
  'chickActivity.triggerCondition': 'Điều kiện Kích hoạt',
  'chickActivity.sickCondition': 'Năng lượng = 0 (Sick)',
  'chickActivity.systemRule': 'Quy tắc Hệ thống',
  'chickActivity.dailyLimit': 'Giới hạn Hàng ngày',
  'chickActivity.times': 'lần',
  'chickActivity.rewardRange': 'Phạm vi Phần thưởng',
  'chickActivity.serverRandom': 'Ngẫu nhiên bởi máy chủ',
  'chickActivity.readonlyDisplay': 'Hiển thị Chỉ đọc',
  'chickActivity.restoreEnergy': 'Khôi phục Năng lượng',
  'chickActivity.no': 'Không',
  'chickActivity.fixed': 'Cố định',

  // Phần thưởng Làm việc
  'chickActivity.workReward': 'Phần thưởng Làm việc (Mốc)',
  'chickActivity.poolTriggerOnce': 'Kích hoạt một lần mỗi pool',
  'chickActivity.workRewardDesc': 'Điều kiện hoàn thành: Số lần cược hợp lệ tích lũy hàng ngày ≥ N lần, kích hoạt một lần; trao cấp cao nhất.',
  'chickActivity.workRewardDesc2': 'Số lượng rơi mỗi cấp cố định ở 1; tính lại các cấp có thể kích hoạt sau mỗi lần nạp tiền tạo pool mới.',
  'chickActivity.workRewardDescNew1': 'Mỗi lần nạp tiền sẽ tạo một pool làm việc mới, và bắt đầu tích lũy điều kiện mở khóa thưởng từ "thời gian tạo pool", sau đó tính số lần cược hợp lệ.',
  'chickActivity.workRewardDescNew2': 'Mốc là [Theo bậc]: Khi hoàn thành mỗi bậc, phần thưởng bậc đó được phát (mặc định 1 lần); mỗi bậc chỉ kích hoạt một lần.',
  'chickActivity.workRewardDescNew3': 'Sau lần nạp tiền tiếp theo, pool làm mới với số tiền nạp mới, và số lần cược đặt lại về 0.',
  'chickActivity.workCondition': 'Điều kiện Hoàn thành (Tích lũy Hàng ngày ≥ N lần)',
  'chickActivity.accumulateReach': 'Tích lũy Đạt',
  'chickActivity.dropCount': 'Số lượng Rơi',
  'chickActivity.rewardType': 'Loại Phát Thưởng',
  'chickActivity.cash': 'Tiền mặt',
  'chickActivity.points': 'Điểm',
  'chickActivity.poolToPointsRatio': 'Tỷ lệ Đổi Pool Thành Điểm',
  'chickActivity.cashToPointsRate': 'Điểm cho Mỗi 1 Đơn vị Tiền mặt',
  'chickActivity.useGlobal': 'Dùng Toàn cục',
  'chickActivity.tierRateModalDesc': 'Để trống để dùng cài đặt toàn cục, đặt tỷ lệ trao đổi tùy chỉnh cho cấp này',
  'chickActivity.workRewardTotalError': 'Tỷ lệ tổng Phần thưởng Làm việc (Mốc) phải là 100%, hiện tại là {total}%',
  'chickActivity.depositCurveTotalError': 'Xác thực đường cong Đăng ký Nạp tiền thất bại:\n{errors}',

  // Jeepney Activity
  'jeepneyActivity.activityStatus': 'Trạng thái hoạt động',
  'jeepneyActivity.selectActivityStatus': 'Vui lòng chọn trạng thái hoạt động',
  'jeepneyActivity.enabled': 'Bật',
  'jeepneyActivity.disabled': 'Tắt',
  'jeepneyActivity.currency': 'Loại tiền',
  'jeepneyActivity.selectCurrency': 'Vui lòng chọn loại tiền',
  'jeepneyActivity.activityTime': 'Thời gian bắt đầu/kết thúc hoạt động',
  'jeepneyActivity.selectActivityTime': 'Vui lòng chọn thời gian bắt đầu/kết thúc hoạt động',
  'jeepneyActivity.rewardExpireDays': 'Số ngày hết hạn phần thưởng',
  'jeepneyActivity.rewardExpireDaysPlaceholder': 'Nhập số ngày, -1 có nghĩa là không hết hạn',
  'jeepneyActivity.enterRewardExpireDays': 'Vui lòng nhập số ngày hết hạn phần thưởng',
  'jeepneyActivity.days': 'Ngày',
  'jeepneyActivity.riskControlLevel': 'Mức độ kiểm soát rủi ro',
  'jeepneyActivity.selectRiskControlLevel': 'Chọn mức độ kiểm soát rủi ro',
  'jeepneyActivity.riskControl.restrictLogin': 'Hạn chế đăng nhập',
  'jeepneyActivity.riskControl.restrictDeposit': 'Hạn chế nạp tiền',
  'jeepneyActivity.riskControl.restrictClaim': 'Tối ưu hóa hạn chế nhận',
  'jeepneyActivity.riskControl.suspectedRisk': 'Rủi ro nghi ngờ',
  'jeepneyActivity.riskControl.sameIpControl': 'Kiểm soát cùng IP',
  'jeepneyActivity.multiLanguage': 'Đa ngôn ngữ',
  'jeepneyActivity.basicSettings': 'Cài đặt cơ bản',
  'jeepneyActivity.activityName': 'Tên hoạt động',
  'jeepneyActivity.enterActivityName': 'Vui lòng nhập tên hoạt động',
  'jeepneyActivity.promotionName': 'Tên ưu đãi',
  'jeepneyActivity.detailUrl': 'URL chi tiết',
  'jeepneyActivity.enterDetailUrl': 'Vui lòng nhập URL chi tiết',
  'jeepneyActivity.activityIntroduction': 'Giới thiệu hoạt động',
  'jeepneyActivity.enterActivityIntroduction': 'Vui lòng nhập giới thiệu hoạt động',
  'jeepneyActivity.appIcon': 'Biểu tượng APP',
  'jeepneyActivity.selectAppIcon': 'Vui lòng tải lên biểu tượng APP',
  'jeepneyActivity.h5Icon': 'Biểu tượng H5',
  'jeepneyActivity.selectH5Icon': 'Vui lòng tải lên biểu tượng H5',
  'jeepneyActivity.pcIcon': 'Biểu tượng PC',
  'jeepneyActivity.selectPcIcon': 'Vui lòng tải lên biểu tượng PC',
  'jeepneyActivity.imageUploadTip': 'Kích thước chuẩn 700*280 chiều rộng, hỗ trợ .jpg .jpeg .png, tối đa 2M',
  
  // Cài đặt Track và Reward
  'jeepneyActivity.trackAndRewardSettings': 'Cài đặt Track và Reward',
  'jeepneyActivity.basicInfo': 'Thông tin cơ bản',
  'jeepneyActivity.totalStages': 'Tổng số giai đoạn',
  'jeepneyActivity.totalStagesRequired': 'Vui lòng nhập tổng số giai đoạn',
  'jeepneyActivity.totalStagesPlaceholder': 'Vui lòng nhập tổng số giai đoạn',
  'jeepneyActivity.totalStagesTip': 'Giai đoạn cuối cùng là giai đoạn cuối (không cần cấu hình số giai đoạn cuối riêng)',
  'jeepneyActivity.totalStagesTimeLimit': 'Giới hạn thời gian tổng giai đoạn',
  'jeepneyActivity.sectionEndStages': 'Giai đoạn kết thúc phần',
  'jeepneyActivity.sectionEndStagesPlaceholder': 'Vui lòng chọn giai đoạn kết thúc phần',
  'jeepneyActivity.sectionEndStagesTip': 'Giai đoạn kết thúc phần được sử dụng để kích hoạt "Phần thưởng mặc định kết thúc phần" và "Cửa sổ bật lên xem trước kết thúc phần". Sau khi chọn thủ công, các giai đoạn kết thúc phần trong bảng sẽ được đánh dấu',
  'jeepneyActivity.cashOutEnabledStages': 'Giai đoạn cho phép rút tiền',
  'jeepneyActivity.cashOutEnabledStagesPlaceholder': 'Vui lòng nhập giai đoạn cho phép rút tiền',
  'jeepneyActivity.finalStageConsumption': 'Tiêu thụ giai đoạn cuối',
  'jeepneyActivity.finalStageConsumptionPlaceholder': 'Vui lòng nhập tiêu thụ giai đoạn cuối',
  'jeepneyActivity.currencyAcquisitionMethods': 'Phương thức thu thập tiền tệ',
  'jeepneyActivity.currencyAcquisitionMethod': 'Phương thức thu thập tiền tệ',
  'jeepneyActivity.currencyMethod.invite': 'Mời nạp nhiên liệu',
  'jeepneyActivity.currencyMethod.pointsExchange': 'Đổi điểm',
  'jeepneyActivity.currencyMethod.recharge': 'Đổi nạp tiền',
  'jeepneyActivity.stages': 'Giai đoạn',
  'jeepneyActivity.exchangeRatio': 'Tỷ lệ đổi',
  'jeepneyActivity.minRechargeAmount': 'Số tiền nạp ≥',
  'jeepneyActivity.rewardValueType': 'Phương thức giá trị',
  'jeepneyActivity.rewardValueTypeRequired': 'Vui lòng chọn phương thức giá trị',
  'jeepneyActivity.rewardValueType.fixed': 'Phân phối cố định',
  'jeepneyActivity.rewardValueType.random': 'Phân phối ngẫu nhiên',
  'jeepneyActivity.value': 'Giá trị',
  'jeepneyActivity.currencyName': 'Tên tiền tệ',
  'jeepneyActivity.currencyNameRequired': 'Vui lòng nhập tên tiền tệ',
  'jeepneyActivity.currencyNamePlaceholder': 'Vui lòng nhập tên tiền tệ',
  'jeepneyActivity.buttonName': 'Tên nút',
  'jeepneyActivity.buttonNameRequired': 'Vui lòng nhập tên nút',
  'jeepneyActivity.buttonNamePlaceholder': 'Vui lòng nhập tên nút',
  'jeepneyActivity.singleRoundCashCap': 'Giới hạn tiền mặt một vòng',
  'jeepneyActivity.currencyRequired': 'Vui lòng chọn loại tiền',
  'jeepneyActivity.amountRequired': 'Vui lòng nhập số tiền',
  'jeepneyActivity.amount': 'Số tiền',
  'jeepneyActivity.stageConfig': 'Cấu hình giai đoạn',
  'jeepneyActivity.stageNumber': 'Số giai đoạn',
  'jeepneyActivity.stageType': 'Loại giai đoạn',
  'jeepneyActivity.stageType.normal': 'Bình thường',
  'jeepneyActivity.stageType.sectionEnd': 'Kết thúc phần',
  'jeepneyActivity.stageType.final': 'Cuối cùng',
  'jeepneyActivity.configSource': 'Nguồn phần thưởng',
  'jeepneyActivity.configSource.default': 'Cấu hình mặc định',
  'jeepneyActivity.configSource.manual': 'Cấu hình thủ công',
  'jeepneyActivity.rewardType': 'Loại phần thưởng',
  'jeepneyActivity.rewardType.fixed': 'Cố định',
  'jeepneyActivity.rewardType.random': 'Ngẫu nhiên',
  'jeepneyActivity.rewardContent': 'Nội dung phần thưởng',
  'jeepneyActivity.notConfigured': 'Chưa cấu hình',
  'jeepneyActivity.accumulatedConsumption': 'Tiêu thụ tích lũy',
  'jeepneyActivity.actualConsumption': 'Tiêu thụ thực tế (Chênh lệch)',
  'jeepneyActivity.distributionMethod': 'Phương thức phân phối',
  'jeepneyActivity.distributionMethod.all': 'Phân phối tất cả giải thưởng',
  'jeepneyActivity.distributionMethod.randomOne': 'Ngẫu nhiên phân phối một giải thưởng',
  'jeepneyActivity.cashOutEnabled': 'Đổi phần thưởng cấp này',
  'jeepneyActivity.defaultRewardSettings': 'Cài đặt cấp độ mặc định',
  'jeepneyActivity.singleRoundPointsCap': 'Giới hạn điểm một vòng',
  'jeepneyActivity.singleRoundPointsCapRequired': 'Vui lòng nhập giới hạn điểm một vòng',
  'jeepneyActivity.singleRoundPointsCapPlaceholder': 'Vui lòng nhập giới hạn điểm một vòng',
  'jeepneyActivity.singleRoundVoucherCap': 'Giới hạn một voucher một vòng',
  'jeepneyActivity.singleRoundVoucherCapRequired': 'Vui lòng nhập giới hạn một voucher một vòng',
  'jeepneyActivity.singleRoundVoucherCapPlaceholder': 'Vui lòng nhập giới hạn một voucher một vòng',
  'jeepneyActivity.singleRoundFuelCap': 'Giới hạn nhiên liệu một vòng',
  'jeepneyActivity.singleRoundFuelCapRequired': 'Vui lòng nhập giới hạn nhiên liệu một vòng',
  'jeepneyActivity.singleRoundFuelCapPlaceholder': 'Vui lòng nhập giới hạn nhiên liệu một vòng',
  'jeepneyActivity.sectionEndStagesRequired': 'Vui lòng chọn giai đoạn kết thúc phần',
  'jeepneyActivity.minimumParticipationThreshold': 'Ngưỡng tham gia tối thiểu',
  'jeepneyActivity.minimumParticipationThresholdRequired': 'Vui lòng nhập ngưỡng tham gia tối thiểu',
  'jeepneyActivity.minimumParticipationThresholdPlaceholder': 'Vui lòng nhập ngưỡng tham gia tối thiểu',
  'jeepneyActivity.globalCashTurnoverMultiplier': 'Hệ số vòng quay tiền mặt toàn cục',
  'jeepneyActivity.globalCashTurnoverMultiplierRequired': 'Vui lòng nhập hệ số vòng quay tiền mặt toàn cục',
  'jeepneyActivity.globalCashTurnoverMultiplierPlaceholder': 'Vui lòng nhập hệ số vòng quay tiền mặt toàn cục',
  'jeepneyActivity.countdownSettings': 'Cài đặt đếm ngược',
  'jeepneyActivity.countdownRuleTip': 'Trong thời gian đếm ngược tăng thời gian giới hạn, nếu không hoàn thành bất kỳ nhiệm vụ giới hạn thời gian nào, vòng tiếp theo sẽ được khởi động lại.',
  'jeepneyActivity.timedTaskCountdown': 'Đếm ngược nhiệm vụ giới hạn thời gian',
  'jeepneyActivity.duration': 'Thời lượng',
  'jeepneyActivity.durationRequired': 'Vui lòng nhập thời lượng đếm ngược',
  'jeepneyActivity.hours': 'Giờ',
  'jeepneyActivity.minutes': 'Phút',
  'jeepneyActivity.seconds': 'Giây',
  'jeepneyActivity.allowAllCompletion': 'Cho phép hoàn thành tất cả',
  'jeepneyActivity.allowAllCompletionTip': 'Nếu tắt, hoàn thành một nhiệm vụ sẽ làm cho mục nhiệm vụ này biến mất; khi kết thúc đếm ngược tiếp theo, các nhiệm vụ hoàn toàn mới sẽ được hiển thị.',
  'jeepneyActivity.rechargeTasks': 'Nhiệm vụ nạp tiền',
  'jeepneyActivity.rechargeAmount': 'Số tiền nạp ≥',
  'jeepneyActivity.timeIncrease': 'Tăng đếm ngược',
  'jeepneyActivity.timeIncreaseRequired': 'Vui lòng nhập tăng đếm ngược',
  'jeepneyActivity.inviteTasks': 'Nhiệm vụ mời',
  'jeepneyActivity.inviteFriends': 'Mời bạn bè',
  'jeepneyActivity.inviteFriendType': 'Loại mời bạn bè',
  'jeepneyActivity.inviteValidFriends': 'Bạn bè hợp lệ',
  'jeepneyActivity.inviteRegisteredFriends': 'Bạn bè đã đăng ký',
  'jeepneyActivity.registeredUsers': 'Số người đăng ký',
  'jeepneyActivity.peopleCount': 'Số người',
  'jeepneyActivity.peopleCountRequired': 'Vui lòng nhập số người',
  'jeepneyActivity.rewardValuePerInstance': 'Giá trị phần thưởng mỗi lần',
  'jeepneyActivity.rewardValue': 'Giá trị phần thưởng',
  'jeepneyActivity.pointsExchange': 'Đổi điểm',
  'jeepneyActivity.consumePoints': 'Tiêu thụ điểm',
  'jeepneyActivity.consumePointsRequired': 'Vui lòng nhập số điểm tiêu thụ',
  'jeepneyActivity.dailyPurchaseLimit': 'Giới hạn mua hàng ngày',
  'jeepneyActivity.dailyPurchaseLimitRequired': 'Vui lòng nhập giới hạn mua hàng ngày',
  'jeepneyActivity.testRechargeCount': 'Số lần nạp tiền thử nghiệm',
  'jeepneyActivity.testInviteCount': 'Số người mời thử nghiệm',
  'jeepneyActivity.unit': 'Đơn vị',
  'jeepneyActivity.unitRequired': 'Vui lòng chọn đơn vị',
  'jeepneyActivity.validFriends': 'Mời bạn bè hợp lệ',
  'jeepneyActivity.validFriendsRequired': 'Vui lòng nhập số bạn bè hợp lệ',
  'jeepneyActivity.countdownConfigTip': 'Khi cấu hình hoạt động, tránh đặt nhiều ngưỡng tương tự để tránh trải nghiệm khó hiểu (nên có ngưỡng rõ ràng và sự khác biệt về thời gian rõ ràng).',
  'jeepneyActivity.fuelConsumptionWarning': 'Các thay đổi trong bảng sẽ cập nhật tất cả các giá trị tiêu thụ tích lũy tiếp theo dựa trên giá trị đã nhập của giai đoạn hiện tại và tính lại tiêu thụ thực tế',
  'jeepneyActivity.pleaseSetTotalStages': 'Vui lòng đặt tổng số giai đoạn trước',
  'jeepneyActivity.defaultRewardConfig': 'Cài đặt cấp độ mặc định',
  'jeepneyActivity.entryReward': 'Phần thưởng vào cửa',
  'jeepneyActivity.entryRewardApplied': 'Nội dung phần thưởng vào cửa đã áp dụng',
  'jeepneyActivity.notSet': 'Chưa thiết lập',
  'jeepneyActivity.defaultReward': 'Cài đặt cấp độ',
  'jeepneyActivity.rewardConfig': 'Cấu hình phần thưởng',
  'jeepneyActivity.rewardTypeDuplicate.points': 'Điểm chỉ có thể xuất hiện một lần',
  'jeepneyActivity.rewardTypeDuplicate.fuel': 'Nhiên liệu chỉ có thể xuất hiện một lần',
  'jeepneyActivity.cashCurrencyDuplicate': 'Tiền mặt cùng loại tiền tệ chỉ có thể xuất hiện một lần',
  'jeepneyActivity.ticketTypeDuplicate': 'Bàn xoay cùng loại chỉ có thể xuất hiện một lần',
  'jeepneyActivity.rewardTypeRequired': 'Vui lòng chọn loại phần thưởng',
  'jeepneyActivity.rewardType.cash': 'Tiền mặt',
  'jeepneyActivity.rewardType.points': 'Điểm',
  'jeepneyActivity.rewardType.spinTicket': 'Vé quay',
  'jeepneyActivity.rewardType.fuel': 'Nhiên liệu',
  'jeepneyActivity.rewardType.none': 'Không',
  'jeepneyActivity.turntableType': 'Loại bàn quay',
  'jeepneyActivity.turntableTypeRequired': 'Vui lòng chọn loại bàn quay',
  'jeepneyActivity.turntable1': 'Bàn quay 1',
  'jeepneyActivity.turntable2': 'Bàn quay 2',
  'jeepneyActivity.rewardValueType': 'Loại giá trị phần thưởng',
  'jeepneyActivity.valueRequired': 'Vui lòng nhập giá trị',
  'jeepneyActivity.minValue': 'Giá trị tối thiểu',
  'jeepneyActivity.minValueRequired': 'Vui lòng nhập giá trị tối thiểu',
  'jeepneyActivity.maxValue': 'Giá trị tối đa',
  'jeepneyActivity.maxValueRequired': 'Vui lòng nhập giá trị tối đa',
  'jeepneyActivity.defaultRewardWarning': 'Lưu ý: Nút tiến lên một lần nhấp của client phải tiến lên 1 cấp, để tránh nhấp mà không di chuyển, nếu không được cấu hình, trò chơi không thể chơi',
  'jeepneyActivity.currencyConsumptionStrategy': 'Chiến lược tiêu thụ tiền tệ',
  'jeepneyActivity.rewardDistributionStrategy': 'Chiến lược phân phối phần thưởng',
  'jeepneyActivity.startingConsumption': 'Tiêu thụ ban đầu',
  'jeepneyActivity.startingConsumptionRequired': 'Vui lòng nhập tiêu thụ ban đầu',
  'jeepneyActivity.incrementalStep': 'Bước tăng dần',
  'jeepneyActivity.incrementalStepRequired': 'Vui lòng nhập bước tăng dần',
  'jeepneyActivity.randomDistributionFormulaGeneration': 'Tạo công thức phân phối ngẫu nhiên',
  'jeepneyActivity.rewardProgressionPerStage': 'Tiến trình phần thưởng theo cấp độ',
  'jeepneyActivity.stagesPerIncrease': 'Mỗi N cấp độ',
  'jeepneyActivity.stagesPerIncreaseRequired': 'Vui lòng nhập mỗi N cấp độ',
  'jeepneyActivity.stagesPerIncreaseMin': 'Phải lớn hơn 0',
  'jeepneyActivity.minValueIncrease': 'Tăng giá trị tối thiểu',
  'jeepneyActivity.minValueIncreaseRequired': 'Vui lòng nhập tăng giá trị tối thiểu',
  'jeepneyActivity.maxValueIncrease': 'Tăng giá trị tối đa',
  'jeepneyActivity.maxValueIncreaseRequired': 'Vui lòng nhập tăng giá trị tối đa',
  'jeepneyActivity.rewardProgressionHint': 'Gợi ý: Giá trị tối thiểu không nên vượt quá giá trị tối đa; khoảng càng rộng thì cảm giác ngẫu nhiên càng mạnh.',
  'jeepneyActivity.tailStageMultiplierValue': 'Giá trị hệ số cấp độ đuôi',
  'jeepneyActivity.tailStageMultiplier': 'Hệ số cấp độ đuôi',
  'jeepneyActivity.sectionEndMultiplier': 'Hệ số kết thúc đoạn',
  'jeepneyActivity.tailRewardMultiplier': 'Phần thưởng đuôi x',
  'jeepneyActivity.tailStageMultiplierDesc': 'Các cấp độ đuôi nhân nội dung phần thưởng với giá trị đã đặt',
  'jeepneyActivity.tailStageMultiplierTip': 'Các cấp độ đuôi nhân nội dung phần thưởng với giá trị đã đặt',
  'jeepneyActivity.sectionEndMultiplierTip': 'Các cấp độ đuôi nhân nội dung phần thưởng với giá trị đã đặt',
  'jeepneyActivity.finalStageMultiplierValue': 'Giá trị hệ số cấp độ cuối',
  'jeepneyActivity.finalMultiplier': 'Hệ số cuối',
  'jeepneyActivity.finalStageMultiplier': 'Hệ số cấp độ cuối',
  'jeepneyActivity.finalRewardMultiplier': 'Phần thưởng cuối x',
  'jeepneyActivity.finalStageMultiplierDesc': 'Cấp độ cuối cùng nhân nội dung phần thưởng với giá trị đã đặt',
  'jeepneyActivity.sectionEndMultiplierTip': 'Các cấp độ đuôi nhân nội dung phần thưởng với giá trị đã đặt',
  'jeepneyActivity.finalMultiplierTip': 'Cấp độ cuối cùng nhân nội dung phần thưởng với giá trị đã đặt',
  'jeepneyActivity.safetyUpperLimit': 'Giới hạn trên an toàn (Giá trị tối đa không vượt quá)',
  'jeepneyActivity.safetyUpperLimitRequired': 'Vui lòng nhập giới hạn trên an toàn',
  'jeepneyActivity.safetyUpperLimitDesc': 'Giải thích: Kết quả được tạo sẽ bị giới hạn không vượt quá giới hạn trên. Nhập 0 để tắt giới hạn trên.',
  'jeepneyActivity.safetyCap': 'Giới hạn trên an toàn (Giá trị tối đa không vượt quá)',
  'jeepneyActivity.safetyCapTip': 'Giải thích: Kết quả được tạo sẽ bị giới hạn không vượt quá giới hạn trên. Nhập 0 để tắt giới hạn trên.',
  'jeepneyActivity.previewAutoRefresh': 'Xem trước (Tự động làm mới)',
  'jeepneyActivity.currentStage': 'Cấp độ hiện tại',
  'jeepneyActivity.stage': 'Cấp độ',
  'jeepneyActivity.stageType': 'Loại cấp độ',
  'jeepneyActivity.autoGenerate': 'Tự động tạo',
  'jeepneyActivity.autoGenerateFixed': 'Tự động tạo (Cố định)',
  'jeepneyActivity.autoGenerateRandom': 'Tự động tạo (Ngẫu nhiên)',
  'jeepneyActivity.manualGenerate': 'Tạo thủ công',
  'jeepneyActivity.randomReward': 'Phần thưởng ngẫu nhiên: Giá trị được tạo ngẫu nhiên trong phạm vi',
  'jeepneyActivity.rewardColorTip.fixed': 'Phần thưởng cố định, giá trị không đổi',
  'jeepneyActivity.rewardColorTip.random': 'Phần thưởng ngẫu nhiên, giá trị được tạo ngẫu nhiên trong phạm vi',
  'jeepneyActivity.actualConsumptionNegativeWarning': 'Tiêu thụ thực tế là âm, được coi là bất thường ngoại trừ cấp độ cuối và sẽ chặn việc lưu',
  'jeepneyActivity.stageType.normal': 'Bình thường',
  'jeepneyActivity.stageType.tail': 'Cấp độ đuôi',
  'jeepneyActivity.stageType.final': 'Cấp độ cuối',
  'jeepneyActivity.result': 'Kết quả (Phần thưởng tương ứng)',
  'jeepneyActivity.minValueExceedsMax': 'Giá trị tối thiểu không nên vượt quá giá trị tối đa',
  'jeepneyActivity.multiplierLessThanOne': 'Hệ số phóng đại không thể nhỏ hơn 1',
  'jeepneyActivity.multiplierMin': 'Phải lớn hơn hoặc bằng 1',
  'jeepneyActivity.abnormalStatusMessage': 'Trạng thái bất thường: Khi giá trị tối thiểu lớn hơn giá trị tối đa, hoặc nhịp điệu tăng trưởng là 0, hoặc hệ số phóng đại nhỏ hơn 1, việc lưu sẽ bị chặn và một lời nhắc sẽ được hiển thị trong quá trình xác minh.',
  'jeepneyActivity.finalStageConsumptionTooltip': 'Tiêu thụ thực tế mặc định = Ngưỡng tích lũy cấp hiện tại - Ngưỡng tích lũy cấp trước (Cấp 1 trừ 0)\n•Cấp 1~N: Ngưỡng tích lũy phải tăng nghiêm ngặt\n•Cấp cuối N: Ngưỡng tích lũy phải ≥ cấp trước (cho phép bằng nhau = chênh lệch cấp cuối là 0)\n•Tiêu thụ chênh lệch của bất kỳ cấp nào không được âm (tính toán hệ thống)\n•Việc sửa đổi thủ công một cấp đơn lẻ, hoặc tiêu thụ thực tế cấp cuối, không bị ảnh hưởng bởi cấu hình mặc định.\nLưu ý: Nhấp vào nút đẩy ở phía client sẽ chắc chắn tiến lên 1 cấp. Để tránh không di chuyển sau khi nhấp, nếu không được cấu hình, trò chơi không thể chơi.',
  'jeepneyActivity.finalStageConsumptionRequired': 'Vui lòng nhập tiêu thụ cấp cuối',
  'jeepneyActivity.distributionMethodRequired': 'Vui lòng chọn phương thức phân phối',
  'jeepneyActivity.turnoverMultiple': 'Doanh thu',
  'jeepneyActivity.turnoverMultipleRequired': 'Vui lòng nhập bội số doanh thu',
  'jeepneyActivity.times': 'lần',
  'jeepneyActivity.vipLevel': 'Cấp VIP',
  'jeepneyActivity.allowedCashOutStages': 'Các cấp được phép rút tiền',
  'jeepneyActivity.rewardSyncStrategy': 'Chiến lược đồng bộ phần thưởng',
  'jeepneyActivity.rewardSyncStrategyRequired': 'Vui lòng chọn chiến lược đồng bộ phần thưởng',
  'jeepneyActivity.rewardSyncStrategy.coverAll': 'Bao phủ tất cả các cấp',
  'jeepneyActivity.rewardSyncStrategy.merge': 'Hợp nhất phần thưởng',
  'jeepneyActivity.configMethod': 'Phương thức cấu hình',
  'jeepneyActivity.configMethodRequired': 'Vui lòng chọn phương thức cấu hình',
  'jeepneyActivity.configMethod.autoGenerate': 'Tự động tạo',
  'jeepneyActivity.configMethod.manual': 'Thủ công',
  'jeepneyActivity.firstStageValue': 'Giá trị',
  'jeepneyActivity.firstStageValueRequired': 'Vui lòng nhập giá trị',
  'jeepneyActivity.firstStageMinValueRequired': 'Vui lòng nhập giá trị tối thiểu',
  'jeepneyActivity.firstStageMaxValueRequired': 'Vui lòng nhập giá trị tối đa',
  'jeepneyActivity.rewardConfigTip': 'Mỗi cấu hình cấp đề xuất tính toán thực tế, xác minh thủ công',
  'jeepneyActivity.useDefaultConfig': 'Sử dụng cấu hình mặc định',
  'jeepneyActivity.stageRewardConfig': 'Cấu hình phần thưởng cấp đơn',
  'jeepneyActivity.generationRule': 'Quy tắc tạo',
  'jeepneyActivity.generateRandomRule': 'Tạo quy tắc ngẫu nhiên',
  'jeepneyActivity.generateFixedRule': 'Tạo quy tắc cố định',
  'jeepneyActivity.fixedDistributionFormulaGeneration': 'Tạo công thức phân phối cố định',
  'jeepneyActivity.fixedIncrease': 'Tăng cố định',
  'jeepneyActivity.fixedIncreaseRequired': 'Vui lòng nhập tăng cố định',
  'jeepneyActivity.fixedIncreasePerPeriod': 'Giá trị cố định tăng mỗi chu kỳ',
  'jeepneyActivity.growthPeriod': 'Chu kỳ tăng trưởng',
  'jeepneyActivity.roundingMethod': 'Phương thức làm tròn',
  'jeepneyActivity.roundingMethodRequired': 'Vui lòng chọn phương thức làm tròn',
  'jeepneyActivity.roundingMethod.round': 'Làm tròn',
  'jeepneyActivity.roundingMethod.ceil': 'Làm tròn lên',
  'jeepneyActivity.roundingMethod.floor': 'Làm tròn xuống',
  'jeepneyActivity.actualConsumptionStrategy': 'Chiến lược tiêu thụ thực tế',
  'jeepneyActivity.consumptionStrategy.fixed': 'Cố định',
  'jeepneyActivity.consumptionStrategy.incremental': 'Tăng dần',
  'jeepneyActivity.inheritDefaultConsumption': 'Kế thừa tiêu thụ mặc định',
  'jeepneyActivity.finalStageConsumptionEditTip': 'Sẽ không ảnh hưởng đến các giai đoạn khác, chỉ sửa đổi mức tiêu thụ thực tế',
  'jeepneyActivity.settlementSettings': 'Cài đặt thanh toán',
  'jeepneyActivity.settlementThreshold': 'Ngưỡng thanh toán',
  'jeepneyActivity.settlementThresholdTypeRequired': 'Vui lòng chọn loại ngưỡng thanh toán',
  'jeepneyActivity.completeFinalStage': 'Hoàn thành giai đoạn cuối',
  'jeepneyActivity.occurredInRound': 'Ít nhất đã xảy ra trong vòng này',
  'jeepneyActivity.inviteValidUsers': 'Số người mời hợp lệ ≥',
  'jeepneyActivity.inviteValidUsersRequired': 'Vui lòng nhập số người mời hợp lệ',
  'jeepneyActivity.weightCalculation': 'Tính toán trọng số',
  'jeepneyActivity.rechargeWeight': 'Trọng số nạp tiền mỗi lần',
  'jeepneyActivity.rechargeWeightRequired': 'Vui lòng nhập trọng số nạp tiền mỗi lần',
  'jeepneyActivity.inviteWeight': 'Trọng số mời mỗi người',
  'jeepneyActivity.inviteWeightRequired': 'Vui lòng nhập trọng số mời mỗi người',
  'jeepneyActivity.dynamicProbability': 'Xác suất động',
  'jeepneyActivity.round': 'Vòng',
  'jeepneyActivity.baseProbability': 'Xác suất cơ bản(%)',
  'jeepneyActivity.baseProbabilityRequired': 'Vui lòng nhập xác suất cơ bản',
  'jeepneyActivity.weightConversionFactor': 'Hệ số chuyển đổi trọng số',
  'jeepneyActivity.weightConversionFactorRequired': 'Vui lòng nhập hệ số chuyển đổi trọng số',
  'jeepneyActivity.failureIncreasePerTime': 'Tăng thất bại mỗi lần(%)',
  'jeepneyActivity.failureIncreasePerTimeRequired': 'Vui lòng nhập tăng thất bại mỗi lần',
  'jeepneyActivity.failureIncreaseCap': 'Giới hạn tăng thất bại(%)',
  'jeepneyActivity.failureIncreaseCapRequired': 'Vui lòng nhập giới hạn tăng thất bại',
  'jeepneyActivity.minProbability': 'Xác suất tối thiểu(%)',
  'jeepneyActivity.minProbabilityRequired': 'Vui lòng nhập xác suất tối thiểu',
  'jeepneyActivity.maxProbability': 'Xác suất tối đa(%)',
  'jeepneyActivity.maxProbabilityRequired': 'Vui lòng nhập xác suất tối đa',
  'jeepneyActivity.actualProbability': 'Xác suất thực tế',
  'jeepneyActivity.noDynamicProbabilityRounds': 'Chưa có cấu hình xác suất động, vui lòng nhấp "Thêm mới" để thêm',
  'jeepneyActivity.roundExplanation': 'Chỉ sau khi hoàn thành giai đoạn cuối (Giai đoạn N), vòng tăng lên 1; các lần rút tiền giữa chừng không được tính vào vòng.',
  'common.yes': 'Có',
  'common.no': 'Không',
  'common.edit': 'Chỉnh sửa',
  'common.apply': 'Áp dụng',
  'common.on': 'Bật',
  'common.off': 'Tắt',
  'common.allow': 'Cho phép',
  'common.disallow': 'Không cho phép',
  'common.confirm': 'Xác nhận',
  'common.cancel': 'Hủy',
  'common.add': 'Thêm',
  'jeepneyActivity.settlementFailureSettings': 'Cài đặt thất bại thanh toán',
  'jeepneyActivity.settlementFailureTaskSettings': 'Cài đặt nhiệm vụ thất bại thanh toán',
  'jeepneyActivity.settlementFailureTaskRuleTip': 'Khi cấu hình hoạt động, cần đảm bảo các cấp độ số lần thất bại rõ ràng, tránh cấu hình nhiều mục cho cùng một số lần thất bại gây nhầm lẫn.',
  'jeepneyActivity.failureCount': 'Số lần thất bại',
  'jeepneyActivity.failureCountRequired': 'Vui lòng chọn số lần thất bại',
  'jeepneyActivity.inviteValidFriendsRequired': 'Vui lòng nhập số bạn bè hợp lệ được mời',
  'jeepneyActivity.noRechargeTasks': 'Chưa có cấu hình nhiệm vụ nạp tiền, vui lòng nhấp "Thêm mới" để thêm',
  'jeepneyActivity.noInviteTasks': 'Chưa có cấu hình nhiệm vụ mời, vui lòng nhấp "Thêm mới" để thêm',

  // ===== Jeepney 多币种改版新增 =====
  'jeepneyActivity.addCurrency': 'Tiền tệ',
  'jeepneyActivity.currencyPending': 'Chưa nhập',
  'jeepneyActivity.removeCurrencyGroup': 'Xoá tiền tệ này',
  'jeepneyActivity.keepAtLeastOneCurrency': 'Giữ lại ít nhất một loại tiền tệ',
  'jeepneyActivity.currencyHint': 'Các loại tiền tệ đã chọn sẽ có ô nhập riêng và bắt buộc ở mọi dòng số tiền; giữ lại ít nhất một loại',
  'jeepneyActivity.removeCurrencyConfirm': 'Bỏ chọn sẽ xoá toàn bộ số tiền đã nhập cho loại tiền tệ này, và người chơi dùng loại tiền tệ đó sẽ không còn thấy sự kiện. Xác nhận?',
  'jeepneyActivity.confirmRemoveCurrency': 'Xác nhận bỏ',
  'jeepneyActivity.thinkAgain': 'Suy nghĩ lại',
  'jeepneyActivity.cashRowOnlyOne': 'Chỉ được thêm một dòng tiền mặt',
  'jeepneyActivity.currencyGroupIncomplete': 'Vui lòng hoàn tất cấu hình cho từng loại tiền tệ',
  'jeepneyActivity.allCurrenciesShared': 'Dùng chung cho mọi tiền tệ',
  'jeepneyActivity.currencyConfigRecharge': 'Nạp ≥ (theo tiền tệ)',
  'jeepneyActivity.currencyConfigFriends': 'Bạn hợp lệ (theo tiền tệ)',
  'jeepneyActivity.currencyConfigRechargeTime': 'Theo tiền tệ (nạp ≥ + thời gian thêm)',
  'jeepneyActivity.currencyConfigFriendsTime': 'Theo tiền tệ (bạn hợp lệ + thời gian thêm)',
  'jeepneyActivity.currencyConfigRechargeFuel': 'Theo tiền tệ (nạp ≥ + lượng dầu)',
  'jeepneyActivity.rechargeGte': 'Nạp ≥',
  'jeepneyActivity.addTime': 'Thêm giờ',
  'jeepneyActivity.fuel': 'Dầu',
  'jeepneyActivity.friends': 'Bạn bè',
  'jeepneyFunnelAnalysis.currency': 'Tiền tệ',
  'jeepneyFunnelAnalysis.currencyAll': 'Tất cả',
  'jeepneyUserList.crossCurrencyNoSum': 'Số tiền không được cộng gộp giữa các loại tiền tệ. Hãy lọc theo một loại để xem tổng chi phí và tỷ lệ hoàn.',
  'jeepneyActivity.selectCurrencyFirst': 'Hãy chọn tiền tệ ở Cài đặt cơ bản trước',
  'jeepneyActivity.allCurrenciesAdded': 'Đã thêm tất cả tiền tệ đã chọn',
  'jeepneyActivity.minAmount': 'Số tiền ≥',
  'jeepneyFunnelAnalysis.statisticsDate': 'Ngày thống kê',
  'jeepneyFunnelAnalysis.dateSelect': 'Chọn ngày',
  'jeepneyFunnelAnalysis.fixedForToday': 'Cố định đến hôm nay',
  // Mốc cược (Trong ngày / Trong tuần)
  'chickActivity.dailyBetMilestone': 'Mốc cược (Trong ngày)',
  'chickActivity.weeklyBetMilestone': 'Mốc cược (Trong tuần)',
  'chickActivity.dailyBetMilestoneDesc': 'Đạt mốc sẽ ghi vào rương báu, người dùng cần nhận thủ công; không có đếm ngược 24 giờ riêng; 00:00 ngày hôm sau bắt đầu nhiệm vụ mới, phần thưởng đã đạt nhưng chưa nhận của ngày trước sẽ tự động hủy; không yêu cầu thể lực, thể lực = 0 (Sick) cũng có thể tham gia.',
  'chickActivity.weeklyBetMilestoneDesc': 'Đạt mốc sẽ ghi vào rương báu, người dùng cần nhận thủ công; không có đếm ngược 24 giờ riêng; 00:00 thứ Hai tuần sau bắt đầu nhiệm vụ tuần mới, phần thưởng đã đạt nhưng chưa nhận của tuần trước sẽ tự động hủy; không yêu cầu thể lực.',
  'chickActivity.dailyTemplateHint': ' — {amount}/{reward} tự động lấy ngưỡng và giá trị thưởng của hàng này, cả bảng dùng chung một mẫu.',
  'chickActivity.weeklyTemplateHint': ' — {amount}/{reward} tự động lấy ngưỡng và giá trị thưởng của hàng này, cả bảng dùng chung một mẫu.',
  'chickActivity.newBadge': 'Mới',
  'chickActivity.copyPreview': 'Xem trước nội dung (tự động)',
  'chickActivity.autoGenReadonly': 'Tự động tạo, không thể chỉnh sửa',
  'chickActivity.milestoneCondition': 'Điều kiện đạt',
  'chickActivity.currencyThreshold': 'Ngưỡng đa tiền tệ',
  'chickActivity.rewardValue': 'Giá trị thưởng',
  'chickActivity.turnoverMultiple': 'Hệ số vòng cược',
  'chickActivity.copyTemplateMultiLang': 'Mẫu nội dung (Đa ngôn ngữ)',
  'chickActivity.templatePlaceholderHint': 'Ký tự thay thế: {amount} (ngưỡng), {reward} (giá trị thưởng). Cả bảng dùng chung một mẫu.',
  'chickActivity.globalCurrencySettings': 'Cài đặt đa tiền tệ toàn cục',
  'chickActivity.globalRateHint': 'Đặt giá trị quy đổi của 1 {base} cho từng tiền tệ; mốc đặt "Dùng toàn cục" sẽ quy đổi ngưỡng theo đó.',
  'chickActivity.ratePerBase': '1 {base} =',
  'chickActivity.baseCurrencyHint': 'Mỗi mốc được cấu hình dựa trên {base}; các tiền tệ khác mặc định quy đổi theo cài đặt toàn cục ở trên, mỗi mốc cũng có thể tự ghi đè.',
  'chickActivity.currencyThresholdSettings': 'Cài đặt ngưỡng đa tiền tệ',
  'chickActivity.currencyThresholdModalDesc': 'Để trống thì tiền tệ đó dùng quy đổi toàn cục; điền vào thì mốc này dùng ngưỡng tùy chỉnh.',
  'chickActivity.threshold': 'Ngưỡng',
  'chickActivity.resetToGlobal': 'Đặt lại về dùng toàn cục',
  'chickActivity.addTierSlot': 'Thêm mốc',
  'chickActivity.notConfigured': 'Chưa cấu hình',
  'chickActivity.selectCurrency': 'Chọn tiền tệ',
  'chickActivity.milestoneCurrencyHint': 'Mỗi tiền tệ có các mốc riêng; chuyển tiền tệ ở trên để chỉnh sửa mốc của tiền tệ đó; các tiền tệ độc lập với nhau.',
  'chickActivity.milestoneRuleEnergy': 'Mốc cược không yêu cầu thể lực; mọi mức thể lực (kể cả 0 / Sick) đều có thể tích lũy và nhận thưởng.',
  'chickActivity.milestoneRuleClaim': 'Khi đạt mốc, phần thưởng được ghi vào rương báu và phải nhận thủ công; không có đếm ngược 24 giờ riêng — khi vòng mới bắt đầu lúc 00:00 hàng ngày / 00:00 thứ Hai hàng tuần, phần thưởng đã đạt nhưng chưa nhận của vòng trước sẽ tự động hủy.',

  // Chung - Ngày trong tuần
  'common.weekday.monday': 'Thứ Hai',
  'common.weekday.tuesday': 'Thứ Ba',
  'common.weekday.wednesday': 'Thứ Tư',
  'common.weekday.thursday': 'Thứ Năm',
  'common.weekday.friday': 'Thứ Sáu',
  'common.weekday.saturday': 'Thứ Bảy',
  'common.weekday.sunday': 'Chủ Nhật',

  // Hoạt động Phong Bì Đỏ
  'redPacket.title': 'Cài đặt Phong Bì Đỏ',
  'redPacket.name': 'Tên Phong Bì Đỏ',
  'redPacket.enterName': 'Vui lòng nhập tên phong bì đỏ',
  'redPacket.ruleTitle': 'Tiêu đề quy tắc',
  'redPacket.enterRuleTitle': 'Vui lòng nhập tiêu đề quy tắc',
  'redPacket.ruleContent': 'Mô tả quy tắc',
  'redPacket.enterRuleContent': 'Vui lòng nhập mô tả quy tắc',
  'redPacket.currency': 'Loại tiền tệ',
  'redPacket.selectCurrency': 'Vui lòng chọn loại tiền tệ',
  'redPacket.addRedPacket': 'Thêm Phong Bì Đỏ',
  'redPacket.editRedPacket': 'Chỉnh sửa Phong Bì Đỏ',
  'redPacket.createSuccess': 'Tạo thành công',
  'redPacket.updateSuccess': 'Cập nhật thành công',
  'redPacket.hasIssueRecordsTip': 'Hoạt động này đã có bản ghi phát hành. Loại người dùng, chu kỳ thống kê, loại sự kiện, loại phát hành, phương thức phát hành và phạm vi số tiền phong bì không thể thay đổi. Chỉ có thể chỉnh sửa tên, thời gian phát hành và thời hạn nhận.',
  'redPacket.deleteSuccess': 'Xóa thành công',
  'redPacket.confirmDelete': 'Bạn có chắc muốn xóa hoạt động phong bì đỏ này?',
  'redPacket.dataLoadFailed': 'Không tải được dữ liệu',
  'redPacket.operation': 'Thao tác',

  'redPacket.stats.title': 'Thống kê Mưa phong bì',
  'redPacket.stats.redPacketName': 'Tên phong bì',
  'redPacket.stats.distributionTime': 'Thời gian phát hành',
  'redPacket.stats.distributionMethod': 'Cách phát hành',
  'redPacket.stats.userCount': 'Người dùng đã nhận',
  'redPacket.stats.totalAmount': 'Số tiền thực tế',
  'redPacket.stats.settings': 'Cài đặt',
  'redPacket.stats.viewMemberList': 'Xem danh sách',
  'redPacket.stats.memberAccount': 'Tài khoản thành viên',
  'redPacket.stats.amount': 'Số tiền',
  'redPacket.stats.claimTime': 'Thời gian nhận',
  'redPacket.stats.exportMemberList': 'Xuất danh sách',
  'redPacket.stats.loadFailed': 'Tải thất bại',
  'redPacket.stats.memberListLoadFailed': 'Tải danh sách thất bại',

  'redPacket.distributionType.label': 'Loại Phát Hành',
  'redPacket.distributionType.daily': 'Hàng ngày',
  'redPacket.distributionType.weekly': 'Hàng tuần',
  'redPacket.distributionType.monthly': 'Hàng tháng',
  'redPacket.distributionType.specified': 'Chỉ định',
  'redPacket.selectDistributionType': 'Vui lòng chọn loại phát hành',

  'redPacket.distributionTime': 'Thời gian Phát Hành',
  'redPacket.selectDistributionTime': 'Vui lòng chọn thời gian phát hành',
  'redPacket.weekDay': 'Thứ',
  'redPacket.selectWeekDay': 'Vui lòng chọn thứ',
  'redPacket.monthDay': 'Ngày',
  'redPacket.selectMonthDay': 'Vui lòng chọn ngày',
  'redPacket.time': 'Thời gian',
  'redPacket.selectTime': 'Vui lòng chọn thời gian',

  'redPacket.distributionMethod.label': 'Phương thức Phát Hành',
  'redPacket.distributionMethod.scheduled': 'Nhận theo lịch',
  'redPacket.distributionMethod.popup': 'Nhận qua popup',
  'redPacket.distributionMethod.autoCredit': 'Tự động cộng',
  'redPacket.selectDistributionMethod': 'Vui lòng chọn phương thức phát hành',

  'redPacket.claimValidity': 'Thời hạn Nhận',
  'redPacket.enterValidityValue': 'Vui lòng nhập giá trị thời hạn',
  'redPacket.selectValidityUnit': 'Vui lòng chọn đơn vị',
  'redPacket.validityUnit.minute': 'Phút',
  'redPacket.validityUnit.day': 'Ngày',

  'redPacket.amountRange': 'Khoảng Số tiền Phong Bì Đỏ',
  'redPacket.amountConfig': 'Cấu hình Số tiền',
  'redPacket.minAmount': 'Số tiền Tối thiểu',
  'redPacket.enterMinAmount': 'Vui lòng nhập số tiền tối thiểu',
  'redPacket.maxAmount': 'Số tiền Tối đa',
  'redPacket.enterMaxAmount': 'Vui lòng nhập số tiền tối đa',

  'redPacket.userType.label': 'Loại Người dùng',
  'redPacket.userType.nonFirstDeposit': 'Người dùng Không Nạp lần đầu',
  'redPacket.userType.nonfirstdeposit': 'Người dùng Không Nạp lần đầu',
  'redPacket.userType.firstDeposit': 'Người dùng Nạp lần đầu',
  'redPacket.userType.firstdeposit': 'Người dùng Nạp lần đầu',
  'redPacket.userType.specifiedUser': 'Người dùng Chỉ định',
  'redPacket.userType.specifieduser': 'Người dùng Chỉ định',
  'redPacket.selectUserType': 'Vui lòng chọn loại người dùng',
  'redPacket.userConfig': 'Cấu hình Người dùng',

  'redPacket.uploadMemberList': 'Tải lên Danh sách',
  'redPacket.uploadMemberListTip': 'Vui lòng tải lên tệp CSV, định dạng: dòng đầu tiên là tiêu đề memberAccount, mỗi dòng sau chứa một tài khoản',
  'redPacket.memberListRequired': 'Vui lòng tải lên danh sách thành viên',
  'redPacket.memberCount': '{count} thành viên',
  'redPacket.specifiedUsers': 'Người dùng Chỉ định',

  'redPacket.statisticsTime': 'Thời gian Thống kê',
  'redPacket.statisticsConfig': 'Cấu hình Thống kê',
  'redPacket.statisticsCycle.label': 'Chu kỳ Thống kê',
  'redPacket.statisticsCycle.weekly': 'Hàng tuần',
  'redPacket.statisticsCycle.monthly': 'Hàng tháng',
  'redPacket.selectStatisticsCycle': 'Vui lòng chọn chu kỳ thống kê',
  'redPacket.userTypeStatisticsCycle.label': 'Chu kỳ Thống kê Loại Người dùng',
  'redPacket.statisticsStartDay': 'Ngày Bắt đầu',
  'redPacket.selectStartDay': 'Vui lòng chọn ngày bắt đầu',
  'redPacket.statisticsEndDay': 'Ngày Kết thúc',
  'redPacket.selectEndDay': 'Vui lòng chọn ngày kết thúc',
  'redPacket.statisticsEffectiveTime.label': 'Thời Gian Hiệu Lực Thống Kê',
  'redPacket.turnoverMultiple.label': 'Bội Số Doanh Thu',
  'redPacket.turnoverMultiple.placeholder': 'Nhập bội số doanh thu',
  'redPacket.turnoverMultiple.required': 'Vui lòng nhập bội số doanh thu',
  'redPacket.statisticsEffectiveTime.placeholder': 'Chọn thời gian hiệu lực thống kê',
  'redPacket.statisticsEffectiveTime.tooltip': 'Chỉ thống kê dữ liệu sau thời điểm này, tránh tính dữ liệu lịch sử vào điều kiện',
  'redPacket.statisticsRange': 'Khoảng Thống kê',

  'redPacket.cycleMismatchWeekly': 'Đối với thống kê hàng tuần, chỉ có thể chọn phát hành Hàng ngày hoặc Hàng tuần',
  'redPacket.cycleMismatchMonthly': 'Đối với thống kê hàng tháng, chỉ có thể chọn phát hành Hàng tháng hoặc Chỉ định',

  'redPacket.eventType.label': 'Loại Sự kiện',
  'redPacket.eventType.deposit': 'Nạp tiền',
  'redPacket.eventType.bet': 'Cược',
  'redPacket.eventType.negativeProfit': 'Lợi nhuận Âm',
  'redPacket.eventType.negativeprofit': 'Lợi nhuận Âm',
  'redPacket.eventType.negative_profit': 'Lợi nhuận Âm',
  'redPacket.eventType.balance': 'Số dư',
  'redPacket.selectEventType': 'Vui lòng chọn loại sự kiện',
  'redPacket.addEventType': 'Thêm Sự kiện',
  'redPacket.eventTypeConfig': 'Cấu hình Loại Sự kiện',
  'redPacket.eventTypeRequired': 'Vui lòng thêm ít nhất một loại sự kiện',

  // FBMPLAY-1737 阶梯配置
  'redPacket.tier.section': 'Cấu hình bậc thang',
  'redPacket.tier.title': 'Bậc',
  'redPacket.tier.add': 'Thêm bậc',
  'redPacket.tier.remove': 'Xóa bậc này',
  'redPacket.tier.conditionMin': 'Điều kiện số tiền tối thiểu',
  'redPacket.tier.conditionMax': 'Điều kiện số tiền tối đa',
  'redPacket.tier.noLimitPlaceholder': 'Để trống = không giới hạn',
  'redPacket.tier.noLimit': 'Không giới hạn',
  'redPacket.tier.rewardMin': 'Số tiền phát tối thiểu',
  'redPacket.tier.rewardMax': 'Số tiền phát tối đa',
  'redPacket.tier.required': 'Vui lòng thiết lập ít nhất một bậc',
  'redPacket.tier.conditionMinRequired': 'Vui lòng nhập điều kiện số tiền tối thiểu',
  'redPacket.tier.conditionMaxRequired': 'Vui lòng nhập điều kiện số tiền tối đa (chỉ bậc cuối được để trống)',
  'redPacket.tier.conditionRangeInvalid': 'Điều kiện tối thiểu không được lớn hơn điều kiện tối đa',
  'redPacket.tier.rewardRequired': 'Vui lòng nhập số tiền phát tối thiểu/tối đa',
  'redPacket.tier.rewardRangeInvalid': 'Số tiền phát tối thiểu không được lớn hơn tối đa',
  'redPacket.tier.multipleRequired': 'Vui lòng nhập bội số doanh thu',
  'redPacket.tier.overlap': 'Điều kiện tối thiểu phải lớn hơn điều kiện tối đa của bậc trước (các bậc tăng dần, không chồng lấn)',
  'redPacket.tier.hint': 'Loại sự kiện dùng chung cho mọi bậc; khoảng điều kiện các bậc phải tăng dần và không chồng lấn, bậc cuối để trống tối đa = không giới hạn; người dùng nhận theo bậc cao nhất đạt được',
  'redPacket.tier.legacyHint': 'Hoạt động này dùng cấu hình cũ (nhiều sự kiện / số tiền cố định) và không còn được tính sau khi cập nhật; vui lòng thiết lập lại loại sự kiện và các bậc trước khi lưu',
  'redPacket.tier.legacyTag': 'Cũ',

  'redPacket.distributionConfig': 'Cấu hình Phát Hành',

  // Rương kho báu
  'treasureBox.config.title': 'Cài đặt Rương',
  'treasureBox.config.activityStatus': 'Trạng thái Hoạt động',
  'treasureBox.config.enabled': 'Bật',
  'treasureBox.config.disabled': 'Tắt',
  'treasureBox.config.activityThreshold': 'Ngưỡng Hoạt động',
  'treasureBox.config.activityThresholdDesc': 'Sau nửa đêm hàng ngày, phân phối ngẫu nhiên rương cho người dùng có hoạt động check-in >= giá trị này',
  'treasureBox.config.dailyBoxLimit': 'Giới hạn Rương Hàng ngày',
  'treasureBox.config.dailyBoxLimitDesc': 'Số lượng rương tối đa phân phối mỗi 24 giờ',
  'treasureBox.config.levelConfig': 'Cấu hình Cấp Rương',
  'treasureBox.config.levelName': 'Tên Cấp',
  'treasureBox.config.dropRate': 'Tỷ lệ Rơi (%)',
  'treasureBox.config.expireHours': 'Giờ Hết hạn',
  'treasureBox.config.prizeConfig': 'Cấu hình Giải thưởng (Tiền thưởng)',
  'treasureBox.config.flowMultiple': 'Hệ số Doanh thu',
  'treasureBox.config.setup': 'Cài đặt',
  'treasureBox.config.save': 'Lưu',
  'treasureBox.config.saveSuccess': 'Lưu thành công',
  'treasureBox.config.saveFailed': 'Lưu thất bại',
  'treasureBox.config.loadFailed': 'Tải cấu hình thất bại',
  'treasureBox.config.dropRateSumError': 'Tổng tỷ lệ rơi tất cả cấp phải là 100%, hiện tại là {total}%',
  'treasureBox.config.enableGuard': 'Trước khi bật: tổng tỷ lệ rơi phải đạt 100%, và mọi cấp có tỷ lệ rơi > 0 đều phải cấu hình khoảng thưởng',
  'treasureBox.config.statusUpdateSuccess': 'Cập nhật trạng thái thành công',
  'treasureBox.config.statusUpdateFailed': 'Cập nhật trạng thái thất bại',
  'treasureBox.config.prizeConfigTitle': 'Cấu hình Giải thưởng',
  'treasureBox.config.minAmount': 'Số tiền Tối thiểu',
  'treasureBox.config.maxAmount': 'Số tiền Tối đa',
  'treasureBox.config.probability': 'Xác suất (%)',
  'treasureBox.config.addRange': 'Thêm Khoảng',
  'treasureBox.config.prizeProbSumError': 'Tổng xác suất tất cả khoảng giải thưởng phải là 100%, hiện tại là {total}%',
  'treasureBox.config.currentPrize': 'Khoảng Giải thưởng Hiện tại',

  'treasureBox.level.WOOD': 'Rương Gỗ',
  'treasureBox.level.IRON': 'Rương Sắt',
  'treasureBox.level.BRONZE': 'Rương Đồng',
  'treasureBox.level.SILVER': 'Rương Bạc',
  'treasureBox.level.GOLD': 'Rương Vàng',
  'treasureBox.level.DIAMOND': 'Rương Kim Cương',

  'treasureBox.stats.title': 'Thống kê Rương',
  'treasureBox.stats.dateRange': 'Khoảng Ngày',
  'treasureBox.stats.search': 'Tìm kiếm',
  'treasureBox.stats.reset': 'Đặt lại',
  'treasureBox.stats.levelName': 'Tên Cấp',
  'treasureBox.stats.statsDate': 'Ngày',
  'treasureBox.stats.coinCode': 'Loại tiền',
  'treasureBox.records.coinCode': 'Loại tiền',
  'treasureBox.stats.grantCount': 'Đã Phát',
  'treasureBox.stats.openCount': 'Đã Mở',
  'treasureBox.stats.expiredCount': 'Đã Hết hạn',
  'treasureBox.stats.totalPrizeAmount': 'Tổng Giải thưởng',
  'treasureBox.stats.keyGrantCount': 'Số Chìa khóa Phát',
  'treasureBox.stats.keyUsedCount': 'Số Chìa khóa Đã dùng',
  'treasureBox.stats.timeRequired': 'Vui lòng chọn khoảng ngày',
  'treasureBox.stats.queryFailed': 'Truy vấn thống kê thất bại',

  'treasureBox.records.title': 'Lịch sử Phân phối Rương',
  'treasureBox.records.boxId': 'ID Rương',
  'treasureBox.records.memberAccount': 'Tài khoản Thành viên',
  'treasureBox.records.memberInfoId': 'ID Người dùng',
  'treasureBox.records.keyId': 'ID Chìa khóa',
  'treasureBox.records.levelCode': 'Cấp Rương',
  'treasureBox.records.grantTime': 'Thời gian Phát',
  'treasureBox.records.expireTime': 'Thời gian Hết hạn',
  'treasureBox.records.openTime': 'Thời gian Mở',
  'treasureBox.records.openKeyId': 'Mã Chìa khóa Mở',
  'treasureBox.records.prizeAmount': 'Số tiền Giải thưởng',
  'treasureBox.records.flowMultiple': 'Hệ số Doanh thu',
  'treasureBox.records.tradeNo': 'Mã Giao dịch',
  'treasureBox.records.search': 'Tìm kiếm',
  'treasureBox.records.reset': 'Đặt lại',
  'treasureBox.records.queryFailed': 'Truy vấn lịch sử thất bại',
  'treasureBox.records.selectLevel': 'Chọn cấp rương',
  'treasureBox.records.allLevels': 'Tất cả Cấp',
  'treasureBox.records.boxStatus': 'Trạng thái Rương',
  'treasureBox.records.boxStatus.pending': 'Chờ mở',
  'treasureBox.records.boxStatus.opened': 'Đã mở',
  'treasureBox.records.boxStatus.expired': 'Đã hết hạn',
  'treasureBox.records.grantSource': 'Nguồn Phát',
  'treasureBox.records.grantSource.autoGrant': 'Phát tự động hàng ngày',
  'treasureBox.records.grantSource.activityReward': 'Phần thưởng Hoạt động',
  'treasureBox.records.selectBoxStatus': 'Chọn trạng thái rương',
  'treasureBox.records.selectGrantSource': 'Chọn nguồn phát',
  'treasureBox.records.timeRequired': 'Vui lòng chọn ít nhất một khoảng thời gian',
  'treasureBox.records.keyDataPkCode': 'Mã Chìa khóa Mở',


  // ========== Phát Vòng Quay Miễn Phí ==========

  // Danh sách trắng

  // Phát

  // Danh sách & tìm kiếm phát

  // Đợt

  // Trạng thái đợt

  // Chi tiết

  // Trạng thái chi tiết

  // Thống kê

  // ===== Bảng xếp hạng nhà cung cấp =====
  'activity.vendorLeaderboard.title': 'Bảng xếp hạng nhà cung cấp',
  'activity.vendorLeaderboard.boardConfigTitle': 'B · Cấu hình bảng',
  'activity.vendorLeaderboard.boardConfigTip': 'Mỗi bảng độc lập: phạm vi game / hội viên / chỉ số xếp hạng / thưởng / phát thưởng. Chuyển bảng ở trên để cấu hình riêng.',
  'activity.vendorLeaderboard.addBoard': 'Thêm bảng',
  'activity.vendorLeaderboard.board': 'Bảng',
  'activity.vendorLeaderboard.overallBoard': 'Bảng tổng',
  'activity.vendorLeaderboard.unnamedBoard': 'Bảng chưa đặt tên',
  'activity.vendorLeaderboard.confirmRemoveBoard': 'Xóa bảng này?',
  'activity.vendorLeaderboard.boardBasic': 'Thông tin bảng',
  'activity.vendorLeaderboard.boardNameZh': 'Tên bảng (Trung)',
  'activity.vendorLeaderboard.boardNameZhTip': 'Tên tab tiếng Trung ở front-end',
  'activity.vendorLeaderboard.boardNameEn': 'Tên bảng (Anh)',
  'activity.vendorLeaderboard.boardNameEnTip': 'Tên tab tiếng Anh ở front-end',
  'activity.vendorLeaderboard.boardSort': 'Thứ tự hiển thị (thứ tự tab)',
  'activity.vendorLeaderboard.boardSortTip': 'Giá trị nhỏ hiển thị trước',
  'activity.vendorLeaderboard.boardBanner': 'Banner bảng (front-end, riêng từng bảng)',
  'activity.vendorLeaderboard.boardBannerTip': 'Tải banner riêng cho từng nền tảng',
  'activity.vendorLeaderboard.bannerH5': 'Banner H5',
  'activity.vendorLeaderboard.bannerPc': 'Banner PC',
  'activity.vendorLeaderboard.bannerApp': 'Banner App',
  'activity.vendorLeaderboard.gameScope': 'Phạm vi bảng',
  'activity.vendorLeaderboard.gameScopeTip': 'Chọn game nào được tính cho bảng này: Thể loại / Nền tảng / Game (3 cấp). Cha chọn một phần nghĩa là chọn từng phần. 6 thể loại cố định; Sports chỉ tới cấp nền tảng.',
  'activity.vendorLeaderboard.searchGame': 'Tìm game',
  'activity.vendorLeaderboard.catSlot': 'Slot (Điện tử)',
  'activity.vendorLeaderboard.catCasino': 'Casino (Trực tiếp)',
  'activity.vendorLeaderboard.catPoker': 'Poker (Bài)',
  'activity.vendorLeaderboard.catBingo': 'Bingo',
  'activity.vendorLeaderboard.catSports': 'Sports (Thể thao)',
  'activity.vendorLeaderboard.catFish': 'Fish (Bắn cá)',
  'activity.vendorLeaderboard.memberScope': 'Cấp hội viên tham gia',
  'activity.vendorLeaderboard.joinMember': 'Hội viên',
  'activity.vendorLeaderboard.memberAll': 'Tất cả hội viên',
  'activity.vendorLeaderboard.memberVip': 'Cấp VIP chỉ định',
  'activity.vendorLeaderboard.vipLevels': 'Cấp VIP',
  'activity.vendorLeaderboard.rankSource': 'Chỉ số xếp hạng & Nguồn dữ liệu',
  'activity.vendorLeaderboard.metric': 'Chỉ số xếp hạng',
  'activity.vendorLeaderboard.metricValidBet': 'Cược hợp lệ (Bảng cược)',
  'activity.vendorLeaderboard.metricProfit': 'Lợi nhuận (Bảng thắng)',
  'activity.vendorLeaderboard.metricLoss': 'Thua lỗ (Bảng thua)',
  'activity.vendorLeaderboard.rankSourceTip': 'Nguồn dữ liệu dùng lại các bảng Xếp hạng người dùng (cược / thắng / thua), chu kỳ gồm thời gian thực (kỳ hiện tại) + hôm qua (bảng chốt kỳ trước), thống kê theo chu kỳ tự nhiên (không trượt). Cột giá trị front-end theo chỉ số: cược hợp lệ / lợi nhuận / thua lỗ. Cược không hợp lệ, đối ứng, đối đánh do kiểm soát rủi ro nền tảng và tầng dữ liệu xác định.',
  'activity.vendorLeaderboard.minThreshold': 'Ngưỡng lên bảng tối thiểu (PHP)',
  'activity.vendorLeaderboard.minThresholdTip': 'Cược hợp lệ thấp hơn mức này không lên bảng',
  'activity.vendorLeaderboard.minBoardCount': 'Số người tối thiểu để thành bảng',
  'activity.vendorLeaderboard.minBoardCountTip': 'Khi không đủ, hạng trống không phát để chống trục lợi lưu lượng thấp',
  'activity.vendorLeaderboard.optional': 'Tùy chọn',
  'activity.vendorLeaderboard.rewardLadder': 'Bậc thưởng',
  'activity.vendorLeaderboard.importExcel': 'Tải lên Excel',
  'activity.vendorLeaderboard.downloadTemplate': 'Tải mẫu',
  'activity.vendorLeaderboard.importTip': 'Trường mẫu: Hạng (hoặc khoảng đầu · cuối) · Số người · Loại thưởng (Tiền mặt / Điểm / Vé vòng quay) · Giá trị · Bội số doanh thu (tiền mặt) · Loại vòng quay (vé). Nhập sẽ ghi đè bậc hiện tại.',
  'activity.vendorLeaderboard.importEmpty': 'Không phân tích được dữ liệu hợp lệ',
  'activity.vendorLeaderboard.importSuccess': 'Nhập thành công {{count}} bậc',
  'activity.vendorLeaderboard.importFail': 'Nhập thất bại, vui lòng kiểm tra định dạng tệp',
  'activity.vendorLeaderboard.enableRankRange': 'Bật khoảng hạng',
  'activity.vendorLeaderboard.enableRankRangeTip': 'Mặc định mỗi hạng cấu hình riêng; khi bật có thể gán cùng một thưởng theo khoảng (vd 4~10)',
  'activity.vendorLeaderboard.rank': 'Hạng',
  'activity.vendorLeaderboard.count': 'Số người',
  'activity.vendorLeaderboard.rewardContent': 'Nội dung thưởng (nhiều mục)',
  'activity.vendorLeaderboard.rewardValue': 'Giá trị',
  'activity.vendorLeaderboard.rewardCash': 'Tiền mặt',
  'activity.vendorLeaderboard.rewardPoint': 'Điểm',
  'activity.vendorLeaderboard.rewardSpinTicket': 'Vé vòng quay',
  'activity.vendorLeaderboard.flowLabel': 'Doanh thu',
  'activity.vendorLeaderboard.times': 'lần',
  'activity.vendorLeaderboard.selectSpinType': 'Chọn loại vòng quay',
  'activity.vendorLeaderboard.addReward': 'Thêm thưởng',
  'activity.vendorLeaderboard.addRank': 'Thêm hạng',
  'activity.vendorLeaderboard.operation': 'Thao tác',
  'activity.vendorLeaderboard.delete': 'Xóa',
  'activity.vendorLeaderboard.settlement': 'Kết toán & Phát thưởng',
  'activity.vendorLeaderboard.settleCycle': 'Chu kỳ kết toán (ngày)',
  'activity.vendorLeaderboard.settleCycleTip': 'Số ngày tính từ thời điểm bảng bắt đầu hiệu lực (không gắn với tuần tự nhiên); chốt bảng, kết toán và reset mỗi N ngày',
  'activity.vendorLeaderboard.days': 'ngày',
  'activity.vendorLeaderboard.boardTime': 'Thời gian hiệu lực bảng',
  'activity.vendorLeaderboard.boardTimeTip': 'Thời gian bắt đầu / kết thúc của bảng này; phải nằm trong khoảng thời gian hiệu lực của hoạt động',
  'activity.vendorLeaderboard.errBoardTimeRequired': 'Vui lòng đặt thời gian hiệu lực cho bảng "{{name}}"',
  'activity.vendorLeaderboard.errBoardTimeOrder': 'Thời gian bắt đầu của bảng "{{name}}" phải sớm hơn thời gian kết thúc',
  'activity.vendorLeaderboard.errBoardTimeWithinActivity': 'Thời gian hiệu lực của bảng "{{name}}" phải nằm trong khoảng thời gian hiệu lực của hoạt động',
  'activity.vendorLeaderboard.errSettleCycle': 'Chu kỳ kết toán của bảng "{{name}}" phải là số ngày lớn hơn 0',
  'activity.vendorLeaderboard.tieRule': 'Quy tắc hòa',
  'activity.vendorLeaderboard.tieFirstReach': 'Người đạt trước ưu tiên',
  'activity.vendorLeaderboard.arrivalTiming': 'Thời điểm nhận',
  'activity.vendorLeaderboard.arrivalTimingFixed': '16:00 hôm sau',
  'activity.vendorLeaderboard.arrivalTimingTip': 'Phát trước 16:00 ngày hôm sau khi chốt bảng (hệ thống cố định)',
  'activity.vendorLeaderboard.distributeMode': 'Cách phát',
  'activity.vendorLeaderboard.distributeDirect': 'Phát trực tiếp vào tài khoản',
  'activity.vendorLeaderboard.distributeClaim': 'Người dùng phải nhận',
  'activity.vendorLeaderboard.rewardExpireDays': 'Số ngày hết hạn thưởng (-1 = không hết hạn)',
  'activity.vendorLeaderboard.rewardExpireDaysTip': '-1 nghĩa là không hết hạn',
  'activity.vendorLeaderboard.grantAudit': 'Duyệt phát thưởng',
  'activity.vendorLeaderboard.grantAuditTip': 'Bật = phát sau khi vận hành đối chiếu; Tắt = tự động phát không đối chiếu',
  'activity.vendorLeaderboard.on': 'Bật',
  'activity.vendorLeaderboard.off': 'Tắt',
  'activity.vendorLeaderboard.activityRule': 'Quy tắc hoạt động (cấu hình vận hành, riêng từng bảng)',
  'activity.vendorLeaderboard.ruleTip': 'Vận hành điền từng dòng quy tắc khớp với mô tả cách chơi front-end. Có thể thêm/xóa mục, hiển thị theo thứ tự trong popup quy tắc front-end. Điền một bộ cho mỗi ngôn ngữ (Trung / Anh).',
  'activity.vendorLeaderboard.ruleItems': 'Mục quy tắc',
  'activity.vendorLeaderboard.ruleItemPlaceholder': 'Nhập một mục quy tắc',
  'activity.vendorLeaderboard.addRuleItem': 'Thêm mục quy tắc',
  'activity.vendorLeaderboard.errNoBoard': 'Cấu hình ít nhất một bảng',
  'activity.vendorLeaderboard.errBoardName': 'Bảng "{{name}}" cần cả tên Trung và Anh',
  'activity.vendorLeaderboard.errVip': 'Bảng "{{name}}": vui lòng chọn cấp VIP',
  'activity.vendorLeaderboard.errNoReward': 'Bảng "{{name}}": cấu hình ít nhất một bậc thưởng',
  'activity.vendorLeaderboard.errRewardValue': 'Bảng "{{name}}": giá trị thưởng phải lớn hơn 0',
  'activity.vendorLeaderboard.errSpinTicket': 'Bảng "{{name}}": vui lòng chọn loại vòng quay',
  'activity.vendorLeaderboard.errLastBoard': 'Giữ lại ít nhất một bảng',
  'activity.vendorLeaderboard.errRankOverlap': 'Bảng "{{name}}": thứ hạng bị trùng hoặc chồng lấn, vui lòng kiểm tra',
  'activity.vendorLeaderboard.rankConflictHint': 'Thứ hạng bị trùng hoặc chồng lấn (đã tô đỏ). Mỗi thứ hạng chỉ được cấu hình một lần — vui lòng điều chỉnh trước khi lưu',
  'fsBatch.platformCode': 'Mã nền tảng',
  'fsBatch.currency': 'Tiền tệ',
  'fsBatch.batchNo': 'Mã lô',
  'fsBatch.status': 'Trạng thái',
  'fsBatch.query': 'Tìm kiếm',
  'fsBatch.reset': 'Đặt lại',
  'fsBatch.dispatchTime': 'Thời gian phát',
  'fsBatch.finishTime': 'Thời gian hoàn thành',
  'fsBatch.addDispatch': 'Thêm phát',
  'fsBatch.games': 'Trò chơi',
  'fsBatch.rounds': 'Số vòng',
  'fsBatch.total': 'Tổng',
  'fsBatch.expanded': 'Đã tạo',
  'fsBatch.progress': 'Tiến độ',
  'fsBatch.action': 'Thao tác',
  'fsBatch.detail': 'Chi tiết',
  'fsBatch.viewProgress': 'Xem tiến độ',
  'fsBatch.refreshProgress': 'Làm mới',
  'fsBatch.progressText': 'Thành công {{success}} / Thất bại {{fail}} / Chờ {{pending}}',
  'fsBatch.batchStatus.0': 'Đã tạo',
  'fsBatch.batchStatus.1': 'Đang tạo',
  'fsBatch.batchStatus.2': 'Đang phát',
  'fsBatch.batchStatus.3': 'Hoàn thành',
  'fsBatch.batchStatus.4': 'Thất bại một phần',
  'fsBatch.batchStatus.5': 'Thất bại',
  'fsBatch.submitTitle': 'Thêm phát Free Spin',
  'fsBatch.platformCodeRequired': 'Vui lòng nhập mã nền tảng',
  'fsBatch.platformCodePlaceholder': 'VD: SL_FC',
  'fsBatch.currencyRequired': 'Vui lòng chọn tiền tệ',
  'fsBatch.currencyPlaceholder': 'Vui lòng chọn tiền tệ',
  'fsBatch.gameIds': 'ID trò chơi',
  'fsBatch.gameIdsRequired': 'Vui lòng chọn trò chơi',
  'fsBatch.gameIdsPlaceholder': 'Chọn trò chơi (nhiều)',
  'fsBatch.gameIdsEmpty': 'Vui lòng chọn nền tảng trước, hoặc thêm trò chơi trong danh sách',
  'fsBatch.roundsLabel': 'Số vòng phát',
  'fsBatch.roundsRequired': 'Vui lòng nhập số vòng',
  'fsBatch.roundsPlaceholder': 'Số vòng Free Spin mỗi thành viên',
  'fsBatch.denomination': 'Mệnh giá (tùy chọn)',
  'fsBatch.denominationPlaceholder': 'Để trống dùng mặc định của trò chơi',
  'fsBatch.startTime': 'Thời gian bắt đầu (tùy chọn)',
  'fsBatch.startTimePlaceholder': 'Để trống có hiệu lực ngay',
  'fsBatch.endTime': 'Thời gian kết thúc',
  'fsBatch.endTimeRequired': 'Vui lòng chọn thời gian kết thúc',
  'fsBatch.endTimePast': 'Thời gian kết thúc không được sớm hơn hiện tại',
  'fsBatch.endBeforeStart': 'Thời gian kết thúc phải muộn hơn thời gian bắt đầu',
  'fsBatch.endTimePlaceholder': 'Hạn hiệu lực',
  'fsBatch.memberFile': 'Danh sách thành viên',
  'fsBatch.selectCsv': 'Chọn tệp CSV',
  'fsBatch.csvFormatHint': 'Định dạng CSV: dòng đầu tiêu đề, mỗi dòng một tài khoản thành viên',
  'fsBatch.downloadTemplate': 'Tải mẫu',
  'fsBatch.remark': 'Ghi chú (tùy chọn)',
  'fsBatch.remarkPlaceholder': 'Mục đích phát lần này',
  'fsBatch.uploadRequired': 'Vui lòng tải lên tệp CSV danh sách thành viên',
  'fsBatch.fileSizeLimit': 'Tệp không được vượt quá 30MB',
  'fsBatch.uploadFailed': 'Tải tệp lên thất bại',
  'fsBatch.submitFailed': 'Gửi thất bại',
  'fsBatch.submitSuccess': 'Đã gửi phát, mã lô: {{batchNo}}',
  'fsBatch.taskTitle': 'Chi tiết phát',
  'fsBatch.memberId': 'Tài khoản thành viên',
  'fsBatch.vendorUsername': 'Tài khoản NCC',
  'fsBatch.currency': 'Tiền tệ',
  'fsBatch.attempt': 'Số lần thử lại',
  'fsBatch.vendorTxId': 'Mã GD NCC',
  'fsBatch.errorCode': 'Mã lỗi',
  'fsBatch.errorMsg': 'Thông báo lỗi',
  'fsBatch.taskStatus.0': 'Chờ phát',
  'fsBatch.taskStatus.1': 'Đang xử lý',
  'fsBatch.taskStatus.2': 'Thành công',
  'fsBatch.taskStatus.3': 'Thất bại',
  'fsBatch.whitelistTab': 'Danh sách trò chơi Free Spin',
  'fsBatch.dispatchTab': 'Phát Free Spin',
  'fsBatch.wlId': 'ID',
  'fsBatch.wlGameId': 'ID trò chơi',
  'fsBatch.wlGameName': 'Tên trò chơi',
  'fsBatch.wlUpdateTime': 'Thời gian cập nhật',
  'fsBatch.wlEnabled': 'Bật',
  'fsBatch.wlDisabled': 'Tắt',
  'fsBatch.wlEnable': 'Bật',
  'fsBatch.wlDisable': 'Tắt',
  'fsBatch.wlDelete': 'Xóa',
  'fsBatch.wlAdd': 'Thêm',
  'fsBatch.wlAddTitle': 'Thêm trò chơi whitelist',
  'fsBatch.wlGameIdRequired': 'Vui lòng nhập ID trò chơi',
  'fsBatch.wlGameIdPlaceholder': 'game_id phía nhà cung cấp',
  'fsBatch.wlGameNamePlaceholder': 'Vui lòng nhập tên trò chơi',
  'fsBatch.wlDeleteConfirm': 'Xóa trò chơi này?',
  'fsBatch.wlDeleteSuccess': 'Đã xóa',
  'fsBatch.wlAddSuccess': 'Đã thêm',
  'fsBatch.wlOpSuccess': 'Thao tác thành công',
  'fsBatch.wlOpFailed': 'Thao tác thất bại',
  'chickActivity.continuousCheckin': 'Điểm danh liên tục',
  'chickActivity.continuousCheckinDesc': 'Khi tắt: ẩn lối vào điểm danh liên tục ở giao diện người dùng; số ngày liên tục đã tích lũy được giữ lại và tiếp tục sau khi bật lại.',
  'chickActivity.continuousCheckinRule': 'Quy tắc (cố định): tính từ ngày điểm danh đầu tiên; bỏ lỡ một ngày sẽ tính lại từ ngày 1; ngày thứ N nhận thưởng của ngày N, đủ một vòng sẽ quay lại ngày 1; mỗi ngày tối đa một lần. Thưởng tiền mặt cần hoàn thành bội số cược trước khi rút (không có công tắc riêng).',
  'chickActivity.continuousTargetDay': 'Số ngày liên tục mục tiêu',
  'chickActivity.dayUnit': 'ngày',
  'chickActivity.coupon': 'Vé tham gia',
  'chickActivity.couponTemplate': 'Mẫu vé',
  'chickActivity.selectCouponTemplate': 'Chọn mẫu vé',
  'chickActivity.depositCheckinV2': 'Điểm danh nạp tiền (Đa chiều · Đa phần thưởng)',
  'chickActivity.statMetric': 'Chiều thống kê',
  'chickActivity.byAmount': 'Theo số tiền',
  'chickActivity.byCount': 'Theo số lần',
  'chickActivity.byAmountHint': 'Theo số tiền: xếp bậc theo tổng số tiền nạp tích lũy.',
  'chickActivity.byCountHint': 'Theo số lần: xếp bậc theo tổng số lần nạp; cơ sở thưởng vẫn là tổng số tiền nạp.',
  'chickActivity.cycleSpan': 'Độ dài chu kỳ',
  'chickActivity.rewardTypesMulti': 'Loại thưởng (chọn nhiều, ít nhất một)',
  'chickActivity.v2Formula': 'Tiền mặt/Điểm: tổng thưởng = tổng nạp tích lũy × "tỷ lệ tổng {span} ngày" của bậc → chia theo đường cong D1–D{span} (tổng=100%); Vé: mỗi bậc cấu hình "mẫu vé + tổng số lượng" → chia theo đường cong số lượng (tổng = tổng số lượng, số nguyên).',
  'chickActivity.v2FormulaNote': 'Số tiền cắt còn 2 chữ số thập phân; tỷ lệ hỗ trợ 1 chữ số thập phân. Chỉ bậc cao nhất có thể đặt "giới hạn" (vé không có). Nạp thêm lên bậc → bắt đầu vòng mới từ ngày 1 của bậc mới (không điểm danh 2 lần trong ngày); đủ một vòng thì lần nạp tiếp theo bắt đầu vòng mới.',
  'chickActivity.tierRangeTitle': 'Thiết lập bậc (tiền mặt/điểm/vé dùng chung)',
  'chickActivity.depositAmountRange': 'Khoảng số tiền nạp',
  'chickActivity.depositCountRange': 'Khoảng số lần nạp',
  'chickActivity.amountUnit': 'số tiền',
  'chickActivity.countUnit': 'lần',
  'chickActivity.noUpperLimit': 'Không giới hạn (-1)',
  'chickActivity.depositAmount': 'số tiền nạp',
  'chickActivity.depositCount': 'số lần nạp',
  'chickActivity.tierRange': 'Bậc',
  'chickActivity.thresholdMin': 'Ngưỡng (số tiền; đạt khi khoản nạp đầu tiên trong ngày >= ngưỡng)',
  'chickActivity.baseCapCash': 'Giới hạn cơ sở tính thưởng tiền mặt (số tiền)',
  'chickActivity.baseCapPoints': 'Giới hạn cơ sở tính điểm (số tiền)',
  'chickActivity.baseCapHint': 'Cơ sở thưởng = min(khoản nạp đầu tiên trong ngày, giới hạn); không ảnh hưởng xếp bậc; để trống = không giới hạn. VD: nạp 1.000.000, giới hạn 10.000 thì tính theo 10.000.',
  'chickActivity.dailyRatioCurveTitle': ' - Tỷ lệ mỗi ngày theo số ngày liên tiếp (%, áp dụng trên khoản nạp đầu tiên trong ngày; mỗi ngày độc lập, không cần tổng=100%)',
  'chickActivity.dailyRatioExample': 'Ví dụ: bậc D3 tỷ lệ 10%, khoản nạp đầu 150 thì bậc đó nhận 150 x 10% = 15 hôm đó (nhiều bậc đạt cùng lúc sẽ cộng dồn).',
  'chickActivity.cycleSpanHintV3': 'Chu kỳ = số ngày liên tiếp tối đa của mỗi bậc: vượt quá sẽ quay về D1; mỗi bậc đếm độc lập, trượt ngưỡng (hoặc không điểm danh) chỉ reset bậc đó.',
  'chickActivity.v3Formula': 'Chỉ lấy khoản nạp đầu tiên trong ngày để xếp bậc, mỗi ngày điểm danh một lần (kết toán tất cả bậc cùng lúc); bậc nào đạt ngưỡng thì +1 ngày và trả tỷ lệ x min(khoản nạp đầu, giới hạn cơ sở) cộng dồn; vé tham gia trả theo đường cong ngày của từng bậc.',
  'chickActivity.v3FormulaNote': 'Không đạt ngưỡng bậc nào (hoặc hôm đó không điểm danh) thì bậc đó reset về D1, các bậc đạt khác không ảnh hưởng. Số tiền cắt 2 chữ số thập phân; điểm lấy nguyên.',
  'chickActivity.tierRangeTitleV3': 'Thiết lập ngưỡng bậc (dùng chung cho tiền mặt/điểm/vé; bậc thấp nhất >=1, tăng dần, có thể cộng dồn)',
  'chickActivity.wagerMultipleHint': 'Doanh thu yêu cầu = thưởng bậc x hệ số (tất cả trò chơi, không thời hạn); 0/trống = không yêu cầu',
  'chickActivity.couponCurveTitleV3': 'Đường cong phát vé (theo ngày D liên tiếp của từng bậc; tổng số chỉ để kiểm tra cấu hình, đứt chuỗi phát lại từ D1, không giới hạn cộng dồn)',
  'chickActivity.v3FootNote': 'Thêm/xóa bậc đồng bộ mọi loại thưởng đã bật; các loại tiền tệ độc lập; tên bậc là khóa trạng thái chuỗi - đổi tên sau khi chạy sẽ tính lại chuỗi của bậc đó.',
  'chickActivity.totalRatioPercent': ' tỷ lệ tổng (%)',
  'chickActivity.highestTierCap': 'Giới hạn bậc cao nhất',
  'chickActivity.onlyHighestTier': 'Chỉ bậc cao nhất',
  'chickActivity.curveTotal': 'Tổng',
  'chickActivity.splitCurveTitle': ' đường cong phân chia (tổng=100%)',
  'chickActivity.couponCurveTitle': 'Đường cong phát vé (chia theo số lượng, số nguyên, tổng = tổng số lượng)',
  'chickActivity.couponTotalQty': 'Tổng số lượng',
  'chickActivity.typeConfigSuffix': ' cấu hình',
  'chickActivity.cashWagerEnable': 'Bật yêu cầu cược (hoàn thành trước khi rút tiền)',
  'chickActivity.wagerBase': 'Cơ sở tính cược',
  'chickActivity.wagerBaseReward': 'Chỉ tiền thưởng',
  'chickActivity.wagerBaseRewardDeposit': 'Thưởng + tiền nạp',
  'chickActivity.wagerScope': 'Phạm vi cược',
  'chickActivity.wagerScopeAll': 'Tất cả trò chơi',
  'chickActivity.wagerScopeSports': 'Chỉ thể thao',
  'chickActivity.wagerScopeLive': 'Chỉ casino trực tiếp',
  'chickActivity.wagerScopeSlots': 'Chỉ slot',
  'chickActivity.wagerDeadline': 'Hạn hoàn thành cược (ngày)',
  'chickActivity.wagerMultipleTimes': 'Bội số cược (x)',
  'chickActivity.wagerNote': 'Ghi chú',
  'chickActivity.wagerFormula': 'Cược yêu cầu = thưởng của bậc × bội số',
  'chickActivity.v2FootNote': 'Thêm/xóa bậc sẽ đồng bộ các hàng đường cong của mọi loại thưởng đã bật; các loại tiền tệ độc lập; đổi chiều/chu kỳ/loại thưởng không xóa giá trị đã nhập.',
  'chickActivity.applyScope': 'Phạm vi thương hiệu trò chơi',
  'chickActivity.allBrands': 'Tất cả thương hiệu',
  'chickActivity.allGamesOfBrand': 'Tất cả trò chơi của thương hiệu',
  'chickActivity.specificGames': 'Trò chơi chỉ định',
  'chickActivity.selectGamesPlaceholder': 'Tìm và chọn trò chơi',
  'chickActivity.scopeHint': 'Khi chọn "Trò chơi chỉ định", chỉ cược của các trò đã chọn được tính vào mốc này; thương hiệu và trò chơi đơn lẻ chỉ chọn một.',
  'chickActivity.scopeInherit': 'Kế thừa mặc định',
  'chickActivity.scopeOverride': 'Ghi đè riêng',
  'chickActivity.defaultScopeTitle': 'Phạm vi áp dụng (mặc định; bậc mới tự kế thừa, có thể ghi đè theo bậc)',
  'chickActivity.tierScopeTitle': 'Phạm vi thương hiệu của bậc',
  'chickActivity.tierScopeHint': '"Kế thừa mặc định" theo phạm vi cấp mô-đun; ghi đè chỉ ảnh hưởng bậc này.',
  'chickActivity.currentDefault': 'Mặc định hiện tại',
  'activity.chickActivity.report.continuousClaimCount': 'Người nhận điểm danh liên tục',
  'activity.chickActivity.report.continuousCash': 'Tiền mặt điểm danh liên tục',
  'activity.chickActivity.report.continuousPoints': 'Điểm điểm danh liên tục',
  'activity.chickActivity.report.continuousCoupon': 'Vé điểm danh liên tục',
  'activity.chickActivity.report.v2ClaimCount': 'Người nhận điểm danh nạp',
  'activity.chickActivity.report.v2Cash': 'Tiền mặt điểm danh nạp',
  'activity.chickActivity.report.v2Points': 'Điểm điểm danh nạp',
  'activity.chickActivity.report.v2Coupon': 'Vé điểm danh nạp',
  'chickActivity.allGamesLabel': 'Tất cả trò chơi',
  'chickActivity.andMoreItems': 'và {n} mục',
  'chickActivity.scopeTreeHint': 'Chọn theo ba cấp: Phân loại → Nền tảng → Trò chơi; không chọn = tất cả trò chơi',
  'chickActivity.pickGames': 'Chọn trò chơi',
  'chickActivity.collapseGames': 'Thu gọn',
  'chickActivity.selectedGamesCount': 'Đã chọn {n}',
  'chickActivity.noGames': 'Nền tảng này chưa có dữ liệu trò chơi',
  'chickActivity.editCopy': 'Sửa nội dung',
  'chickActivity.taskNameLabel': 'Tên nhiệm vụ',
  'chickActivity.taskDescLabel': 'Mô tả nhiệm vụ',
  'chickActivity.pickGamesHint': 'Chọn trò chơi chỉ định; không chọn = tất cả trò chơi của nền tảng này',
  'chickActivity.searchGamePlaceholder': 'Tìm nền tảng / tên trò chơi',
};

